/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * OriginPoint Engine API
 * 元点引擎后端 API 文档
 * OpenAPI spec version: 0.0.9
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { origin_point_engine_api } from '../lib/axios-client';
export interface AdminAdjustBalanceRequest {
  delta: number;
  /** @minLength 1 */
  reason: string;
}

export interface AdminCreateAnnouncementRequest {
  content: string;
  isPinned?: boolean;
  status?: string;
  title: string;
}

export interface AdminCreatePromptItemRequest {
  content: string;
  name: string;
  /** system/user/assistant */
  role: string;
  tags?: string[];
}

export interface AdminCreateSystemConfigRequest {
  category: string;
  description?: string;
  isActive?: boolean;
  isSystem?: boolean;
  key: string;
  /** string, int, float, bool, json */
  type: string;
  value: string;
}

export interface AdminCreateSystemEngineRequest {
  author: string;
  config?: string;
  description?: string;
  name: string;
  thumbnail?: string;
  type: ModelsSystemEngineType;
  version: string;
}

export interface AdminCreateTemplateRequest {
  content: string;
  description?: string;
  isActive?: boolean;
  name: string;
  order?: number;
  title: string;
  type: string;
}

export interface AdminDistributePassRequest {
  /** @minItems 1 */
  distributions: AdminDistributionItem[];
  passType: string;
  reason: string;
}

export interface AdminDistributePassResult {
  batchId?: string;
  failedCount?: number;
  results?: AdminDistributePassResultItem[];
  successCount?: number;
  totalAmount?: number;
  totalUsers?: number;
}

export interface AdminDistributePassResultItem {
  error?: string;
  expiresAt?: string;
  newBalance?: number;
  success?: boolean;
  userId?: string;
}

export interface AdminDistributePointsRequest {
  /**
   * @minItems 1
   * @maxItems 100
   */
  distributions: AdminDistributionItem[];
  reason: string;
}

export interface AdminDistributePointsResult {
  batchId?: string;
  failedCount?: number;
  results?: AdminDistributeResultItem[];
  successCount?: number;
  totalAmount?: number;
  totalUsers?: number;
}

export interface AdminDistributeResultItem {
  error?: string;
  newBalance?: number;
  success?: boolean;
  userId?: string;
}

export interface AdminDistributionItem {
  amount: number;
  userId: string;
}

export type AdminRechargeOrderDetailResponseUser = {
  email?: string;
  id?: string;
  username?: string;
};

export interface AdminRechargeOrderDetailResponse {
  amountPoints?: number;
  amountRmb?: number;
  createdAt?: string;
  description?: string;
  exchangeRate?: number;
  id?: string;
  orderNo?: string;
  paidAt?: string;
  paymentMethod?: ModelsPaymentMethod;
  paymentType?: ModelsPaymentType;
  status?: ModelsPaymentStatus;
  thirdPartyData?: string;
  thirdPartyOrderNo?: string;
  title?: string;
  transactions?: ModelsTransactionRecord[];
  updatedAt?: string;
  user?: AdminRechargeOrderDetailResponseUser;
}

export type AdminRechargeOrderListItemUser = {
  email?: string;
  id?: string;
  username?: string;
};

export interface AdminRechargeOrderListItem {
  amountPoints?: number;
  amountRmb?: number;
  createdAt?: string;
  description?: string;
  exchangeRate?: number;
  id?: string;
  orderNo?: string;
  paidAt?: string;
  paymentMethod?: ModelsPaymentMethod;
  paymentType?: ModelsPaymentType;
  status?: ModelsPaymentStatus;
  thirdPartyOrderNo?: string;
  title?: string;
  user?: AdminRechargeOrderListItemUser;
}

export type AdminRechargeOrdersResponsePagination = {
  limit?: number;
  page?: number;
  pages?: number;
  total?: number;
};

export interface AdminRechargeOrdersResponse {
  orders?: AdminRechargeOrderListItem[];
  pagination?: AdminRechargeOrdersResponsePagination;
}

export interface AdminRefundRechargeOrderRequest {
  reason: string;
  refundAmount?: number;
}

export interface AdminSendUserMessageRequest {
  content: string;
  title: string;
}

export interface AdminUpdateAdminPermissionsRequest {
  permissions?: string[];
}

export interface AdminUpdateAnnouncementRequest {
  content?: string;
  isPinned?: boolean;
  status?: string;
  title?: string;
}

export interface AdminUpdateContentRequest {
  category?: string;
  description?: string;
  status?: string;
  tags?: string;
  title?: string;
  type: string;
}

export type AdminUpdateContentStatusRequestType = typeof AdminUpdateContentStatusRequestType[keyof typeof AdminUpdateContentStatusRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminUpdateContentStatusRequestType = {
  engine: 'engine',
} as const;

export interface AdminUpdateContentStatusRequest {
  status: string;
  type: AdminUpdateContentStatusRequestType;
}

export interface AdminUpdateHelpCenterRequest {
  /** FAQ 正文（Markdown，支持超链接；飞书等文档链接直接写进正文） */
  faqMarkdown?: string;
  /** QQ 群链接 */
  qqGroupUrl?: string;
}

export interface AdminUpdatePromptItemRequest {
  content?: string;
  name?: string;
  role?: string;
  tags?: string[];
}

export interface AdminUpdateRechargeOrderStatusRequest {
  reason?: string;
  status: string;
}

export interface AdminUpdateSystemConfigRequest {
  category?: string;
  description?: string;
  isActive?: boolean;
  type?: string;
  value?: string;
}

export interface AdminUpdateSystemEngineStatusRequest {
  status?: ModelsSystemEngineStatus;
}

export interface AdminUpdateTemplateRequest {
  content?: string;
  description?: string;
  isActive?: boolean;
  name?: string;
  order?: number;
  title?: string;
  type?: string;
}

export interface HandlerBalanceResponse {
  isMember?: boolean;
  memberExpiresAt?: string;
  membershipType?: string;
  originPoints?: number;
}

export interface HandlerBatchDeleteUsersRequest {
  /**
   * @minItems 1
   * @maxItems 100
   */
  userIds: string[];
}

export interface HandlerBatchUpdateUserStatusRequest {
  status: string;
  /**
   * @minItems 1
   * @maxItems 100
   */
  userIds: string[];
}

export interface HandlerBatchUserResult {
  failedCount?: number;
  results?: HandlerBatchUserResultItem[];
  successCount?: number;
  total?: number;
}

export interface HandlerBatchUserResultItem {
  error?: string;
  success?: boolean;
  userId?: string;
}

export interface HandlerChangePasswordRequest {
  /** @minLength 6 */
  newPassword: string;
}

export interface HandlerCheckBalanceResponse {
  hasEnoughPoints?: boolean;
  originPoints?: number;
}

export type HandlerCreateOrderResponseOrder = {
  orderNo?: string;
  status?: string;
};

export interface HandlerCreateOrderResponse {
  order?: HandlerCreateOrderResponseOrder;
  /** 支付参数(SDK返回) */
  payment?: unknown;
}

export interface HandlerCreatePaymentOrderRequest {
  /** 支付金额（人民币） */
  amountRmb: number;
  /** 月卡类型（已废弃，保留兼容） */
  cardType?: string;
  /** 微信OpenID */
  openid?: string;
  /** 通行证类型（购买通行证时必填） */
  passType?: string;
  /** 支付方式：alipay/wechat/zpay */
  paymentMethod: string;
  /** 支付类型：direct/pass/monthly */
  paymentType: string;
  /** 购买数量（已废弃） */
  quantity?: number;
}

export interface HandlerInviteCodeResponse {
  inviteCode?: string;
  /** 邀请人用户名/昵称 */
  invitedBy?: string;
}

export interface HandlerInviteRecordsResponse {
  page?: number;
  pageSize?: number;
  records?: IdentityInviteRecord[];
  total?: number;
}

export interface HandlerPaymentStatusResponse {
  amountPoints?: number;
  amountRmb?: number;
  createdAt?: string;
  orderNo?: string;
  paidAt?: string;
  status?: string;
}

export interface HandlerReviewCreatorEarningRequest {
  /** true=通过(等持有期到自动发放) / false=驳回(永不发放) */
  approve?: boolean;
  /** 审核/驳回备注 */
  note?: string;
}

export interface HandlerSimulatePaymentRequest {
  /** 订单ID */
  orderId: string;
}

export interface HandlerSystemConfigResponse {
  config?: unknown;
}

export type HandlerTransactionHistoryResponsePagination = {
  limit?: number;
  page?: number;
  pages?: number;
  total?: number;
};

export interface HandlerTransactionHistoryResponse {
  pagination?: HandlerTransactionHistoryResponsePagination;
  /** 注意：此处可能需要确认实际返回的模型，Service 里返回的是 []*TransactionRecord */
  transactions?: IdentityInviteRecord[];
}

export interface HandlerUpdateProfileRequest {
  /** 兼容字段 */
  avatar?: string;
  avatarUrl?: string;
  bio?: string;
  userCard?: string;
  username?: string;
}

export type HandlerUserListResponsePagination = {
  limit?: number;
  page?: number;
  pages?: number;
  total?: number;
};

export interface HandlerUserListResponse {
  pagination?: HandlerUserListResponsePagination;
  users?: HandlerUserResponse[];
}

export interface HandlerUserResponse {
  avatar?: string;
  avatarUrl?: string;
  bio?: string;
  createdAt?: string;
  email?: string;
  id?: string;
  inviteCode?: string;
  isVerified?: boolean;
  lastLoginAt?: string;
  membershipType?: string;
  name?: string;
  originPoints?: number;
  phoneVerified?: boolean;
  points?: number;
  role?: string;
  status?: string;
  totalRecharge?: number;
  updatedAt?: string;
  username?: string;
}

export interface HandlersCalculateCreatorEarningsRequest {
  /** 结算日期（格式：2006-01-02） */
  settlementDate: string;
}

export interface HandlersChangePasswordRequest {
  /** @minLength 6 */
  newPassword: string;
}

export interface HandlersChoiceItem {
  /** 选择ID */
  id?: string;
  /** 选择文本 */
  text?: string;
}

export interface HandlersCleanupExpiredSessionsRequest {
  /**
   * 清理多少天前未访问的会话
   * @minimum 1
   * @maximum 365
   */
  days: number;
}

export interface HandlersConsumptionStatsResponse {
  /** 平均消耗 */
  avgConsumption?: number;
  /** 总消耗量 */
  totalConsumption?: number;
  /** 总记录数 */
  totalRecords?: number;
}

export interface HandlersCreateCommentRequest {
  content: string;
  /** 回复的评论ID */
  parentId?: string;
  /** 1-5星评分，0表示不评分 */
  rating?: number;
}

export interface HandlersCreateEngineCommentRequest {
  /** 评论内容 */
  content: string;
  /** 父评论ID（回复时使用） */
  parentId?: string;
  /** 评分（0-5，0表示不评分） */
  rating?: number;
}

export type HandlersCreateEngineRequestSettings = { [key: string]: unknown };

export interface HandlersCreateEngineRequest {
  /** 新增：是否允许自定义角色 */
  allowCustomUser?: boolean;
  backgroundImageUrl?: string;
  category?: string;
  characterProfiles?: ModelsWorldInfo[];
  characters?: string[];
  description?: string;
  imageUrl?: string;
  name: string;
  /** 新增：支持创建时选择模板 */
  presetTemplateId?: string;
  rules?: string;
  settings?: HandlersCreateEngineRequestSettings;
  tags?: string[];
  worldInfo?: ModelsWorldInfo[];
}

export interface HandlersCreateIncentiveConfigRequest {
  dailyLimit?: number;
  description?: string;
  isActive?: boolean;
  monthlyLimit?: number;
  points: number;
  type: string;
}

export interface HandlersCreatePromptPresetRequest {
  allowTakeover?: boolean;
  code: string;
  description?: string;
  isActive?: boolean;
  isDefault?: boolean;
  layerConfig?: ModelsLayerConfig;
  name: string;
  pov?: string;
  showInnerThoughts?: boolean;
}

export interface HandlersCurrentSceneData {
  /** 可选选项 */
  choices?: HandlersChoiceItem[];
  /** 场景内容 */
  context?: string;
  /** 记忆更新 */
  memoryUpdates?: string;
  /** 元数据 */
  metadata?: HandlersSceneMetadata;
}

export interface HandlersDeleteSessionData {
  /** 删除结果消息 */
  message?: string;
}

export interface HandlersDeleteSessionRequest {
  /** 会话ID */
  sessionId: string;
}

export interface HandlersDeleteSessionResponse {
  /** 响应码 */
  code?: HandlersResCode;
  /** 数据 */
  data?: HandlersDeleteSessionData;
  /** 响应消息 */
  msg?: string;
}

export interface HandlersGetMessagesCursor {
  /** 事件号 */
  event?: number;
  /** 回合号 */
  round?: number;
}

export interface HandlersGetMessagesData {
  /** 是否还有更多 */
  hasMore?: boolean;
  /** 消息列表 */
  messages?: ModelsStoryEvent[];
  /** 下一页游标 */
  nextCursor?: HandlersGetMessagesCursor;
  /** 会话信息（可选） */
  session?: HandlersGetMessagesSessionData;
}

export interface HandlersGetMessagesResponse {
  /** 响应码 */
  code?: HandlersResCode;
  /** 数据 */
  data?: HandlersGetMessagesData;
  /** 响应消息 */
  msg?: string;
}

export interface HandlersGetMessagesSessionData {
  /** 创建时间 */
  createdAt?: string;
  /** 当前步骤 */
  currentStep?: number;
  /** 引擎ID */
  engineId?: string;
  /** 会话ID */
  id?: string;
  /** 是否活跃 */
  isActive?: boolean;
  /** 更新时间 */
  updatedAt?: string;
  /** 用户ID */
  userId?: string;
}

export interface HandlersGetMySessionsData {
  /** 会话列表 */
  sessions?: HandlersSessionListItem[];
  /** 总数 */
  total?: number;
}

export interface HandlersGetMySessionsResponse {
  /** 响应码 */
  code?: HandlersResCode;
  /** 数据 */
  data?: HandlersGetMySessionsData;
  /** 响应消息 */
  msg?: string;
}

export interface HandlersGuestRegisterRequest {
  email: string;
  /** 可选，用于迁移游客数据 */
  guestId?: string;
  /** @minLength 6 */
  password: string;
  /**
   * @minLength 3
   * @maxLength 50
   */
  username: string;
}

export interface HandlersHelpCenterContent {
  /** FAQ 正文（Markdown，支持超链接；飞书等文档链接直接写进正文） */
  faqMarkdown?: string;
  /** QQ 群链接 */
  qqGroupUrl?: string;
}

export interface HandlersImportWorldInfoRequest {
  /** JSON文件的字符串内容 */
  fileData: string;
  /** "append" | "replace" | "merge" */
  importMode?: string;
  /** 是否保留现有条目（仅merge模式有效） */
  preserveExisting?: boolean;
}

/**
 * 类型：like（点赞）或 dislike（点踩）
 */
export type HandlersLikeCommentRequestType = typeof HandlersLikeCommentRequestType[keyof typeof HandlersLikeCommentRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandlersLikeCommentRequestType = {
  like: 'like',
  dislike: 'dislike',
} as const;

export interface HandlersLikeCommentRequest {
  /** 类型：like（点赞）或 dislike（点踩） */
  type: HandlersLikeCommentRequestType;
}

export interface HandlersMakeChoiceData {
  /** 消息（可选） */
  message?: string;
  /** 任务状态 */
  status?: string;
  /** 任务ID */
  taskId?: string;
}

export interface HandlersMakeChoiceRequest {
  /** 选择ID */
  choiceId: string;
  /** 可选：自定义文本（优先级高于choiceId对应的文本） */
  customText?: string;
}

export interface HandlersMakeChoiceResponse {
  /** 响应码 */
  code?: HandlersResCode;
  /** 数据 */
  data?: HandlersMakeChoiceData;
  /** 响应消息 */
  msg?: string;
}

export interface HandlersNewSessionRequest {
  /** 引擎ID */
  engineId: string;
}

export interface HandlersNewSessionResponse {
  /** 响应码 */
  code?: HandlersResCode;
  /** 数据 */
  data?: HandlersNewSessionResponseData;
  /** 响应消息 */
  msg?: string;
}

export interface HandlersNewSessionResponseData {
  /** 当前场景 */
  currentScene?: HandlersCurrentSceneData;
  /** 会话信息 */
  session?: HandlersNewSessionSessionData;
}

export interface HandlersNewSessionSessionData {
  /** 创建时间 */
  createdAt?: string;
  /** 当前步骤 */
  currentStep?: number;
  /** 引擎ID */
  engineId?: string;
  /** 会话ID */
  id?: string;
  /** 故事历史 */
  storyHistory?: ModelsStoryEvent[];
  /** 更新时间 */
  updatedAt?: string;
  /** 用户选择 */
  userChoices?: ModelsUserChoice[];
  /** 用户ID */
  userId?: string;
}

export interface HandlersPreviewEngineRequest {
  /** 引擎ID */
  engineId: string;
  /** 可选：draft（默认）或 reviewing */
  sessionType?: string;
  /** 可选：用户输入，为空时返回开场白 */
  userInput?: string;
}

export type HandlersResCode = typeof HandlersResCode[keyof typeof HandlersResCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandlersResCode = {
  CodeSuccess: 1000,
  CodeInvalidParam: 1001,
  CodeNeedLogin: 1100,
  CodeInvalidToken: 1101,
  CodeTokenExpired: 1102,
  CodeUserNotFound: 1200,
  CodeUsernameTaken: 1201,
  CodeEmailTaken: 1202,
  CodeAccountNotActive: 1203,
  CodeInvalidCredentials: 1204,
  CodeVerificationFailed: 1205,
  /** 手机号已被使用 */
  CodePhoneTaken: 1206,
  /** 手机号未注册 */
  CodePhoneNotRegistered: 1207,
  /** 手机号已绑定 */
  CodePhoneBound: 1208,
  /** 手机号未绑定 */
  CodePhoneNotBound: 1209,
  CodeServerBusy: 1300,
  CodeDatabaseError: 1301,
  CodeEmailSendFailed: 1302,
  CodeTokenGenerateFailed: 1303,
  CodeSessionNotFound: 1400,
  CodePermissionDenied: 1401,
  CodeInvalidSessionID: 1402,
  CodeHistoryFailed: 1403,
  /** 余额不足 */
  CodeInsufficientBalance: 1404,
  /** AI 限流 */
  CodeAIRateLimit: 1500,
  /** AI 服务繁忙 */
  CodeAIServerBusy: 1501,
  /** AI 调用超时 */
  CodeAITimeout: 1502,
  /** 解析失败 */
  CodeAIParseFailed: 1503,
  /** Schema 验证失败 */
  CodeAISchemaInvalid: 1504,
  /** 上下文过长 */
  CodeAIContextTooLong: 1505,
  /** 厂商不可用 */
  CodeAIProviderDown: 1506,
  /** AI 生成失败 */
  CodeAIGenerateFailed: 1507,
  /** 短信发送失败 */
  CodeSmsSendFailed: 1600,
  /** 验证码已过期 */
  CodeSmsCodeExpired: 1601,
  /** 验证码错误 */
  CodeSmsCodeInvalid: 1602,
  /** 发送太频繁 */
  CodeSmsTooFrequent: 1603,
  /** 手机号加密失败 */
  CodeSmsEncryptFail: 1604,
  /** 幂等性检查失败 */
  CodeIdempotencyFailed: 1700,
  /** 操作失败 */
  CodeOperationFailed: 1701,
  /** 签到失败 */
  CodeCheckinFailed: 1702,
  /** 任务提交失败 */
  CodeTaskSubmitFailed: 1703,
  /** 删除失败 */
  CodeDeleteFailed: 1704,
} as const;

export interface HandlersResponseData {
  code?: HandlersResCode;
  /** 当字段为空，就不展示这个 */
  data?: unknown;
  msg?: string;
}

export interface HandlersSceneMetadata {
  /** 角色列表 */
  characters?: string[];
  /** 时间 */
  time?: string;
}

export interface HandlersSearchContentRequest {
  /** 分类筛选 */
  category?: string;
  /** 每页数量 */
  limit?: number;
  /** 排序方向 */
  order?: string;
  /** 页码 */
  page?: number;
  /** 搜索关键词 */
  query: string;
  /** 排序字段 */
  sortBy?: string;
  /** 标签筛选（数组） */
  tags?: string[];
  /** 搜索类型：engine（引擎）、user（用户） */
  types?: string[];
}

export interface HandlersSessionListItem {
  /** 背景图URL */
  backgroundImageUrl?: string;
  /** 创建时间 */
  createdAt?: string;
  /** 当前步骤 */
  currentStep?: number;
  /** 引擎ID */
  engineId?: string;
  /** 引擎标题 */
  engineTitle?: string;
  /** 会话ID */
  id?: string;
  /** 封面图URL */
  imageUrl?: string;
  /** 是否活跃 */
  isActive?: boolean;
  /** 最后活动时间 */
  lastActivity?: string;
  /** 更新时间 */
  updatedAt?: string;
}

export interface HandlersSetEnginePresetRequest {
  presetCode?: string;
  presetId?: string;
}

export interface HandlersStartEnginePlayRequest {
  /** 引擎ID */
  engineId: string;
}

export interface HandlersTaskStatusData {
  /** 创建时间 */
  createdAt?: string;
  /** 错误信息（失败时返回） */
  error?: string;
  /** 任务结果（完成时返回） */
  result?: unknown;
  /** 会话ID */
  sessionId?: string;
  /** 任务状态: queued/processing/completed/failed */
  status?: string;
  /** 任务ID */
  taskId?: string;
  /** 更新时间 */
  updatedAt?: string;
}

export interface HandlersTaskStatusResponse {
  /** 响应码 */
  code?: HandlersResCode;
  /** 数据 */
  data?: HandlersTaskStatusData;
  /** 响应消息 */
  msg?: string;
}

export interface HandlersUpdateCommentRequest {
  content: string;
}

export interface HandlersUpdateCreatorSplitConfigRequest {
  /** 描述 */
  description?: string;
  /** 分成比例（0-1之间） */
  splitRatio: number;
}

export type HandlersUpdateEngineRequestSettings = { [key: string]: unknown };

export interface HandlersUpdateEngineRequest {
  allowCustomUser?: boolean;
  backgroundImageUrl?: string;
  category?: string;
  characterProfiles?: ModelsWorldInfo[];
  characters?: string[];
  description?: string;
  imageUrl?: string;
  name?: string;
  presetTemplateId?: string;
  rules?: string;
  settings?: HandlersUpdateEngineRequestSettings;
  status?: string;
  tags?: string[];
  worldInfo?: ModelsWorldInfo[];
}

export interface HandlersUpdateIncentiveConfigRequest {
  /** 每日限制 */
  dailyLimit?: number;
  /** 描述 */
  description?: string;
  /** 是否激活 */
  isActive?: boolean;
  /** 每月限制 */
  monthlyLimit?: number;
  /** 激励点数 */
  points?: number;
}

export interface HandlersUpdateProfileRequest {
  /** 头像URL（兼容字段） */
  avatar?: string;
  /** 头像URL */
  avatarUrl?: string;
  /** 个人简介 */
  bio?: string;
  /** 用户卡信息 */
  userCard?: string;
  /** 用户名 */
  username?: string;
}

export interface HandlersUpdatePromptPresetRequest {
  allowTakeover?: boolean;
  description?: string;
  isActive?: boolean;
  isDefault?: boolean;
  layerConfig?: ModelsLayerConfig;
  name?: string;
  pov?: string;
  showInnerThoughts?: boolean;
}

/**
 * 设置信息
 */
export type HandlersUpdateUserSettingsRequestSettings = { [key: string]: unknown };

export interface HandlersUpdateUserSettingsRequest {
  /** 设置信息 */
  settings: HandlersUpdateUserSettingsRequestSettings;
}

export interface HandlersValidateWorldInfoImportRequest {
  /** JSON文件的字符串内容 */
  fileData: string;
}

/**
 * 补填邀请码请求参数
 */
export interface IdentityBindInviteCodeRequest {
  /** 邀请码
@example "ABCDEF" */
  inviteCode: string;
}

/**
 * 绑定手机号请求参数
 */
export interface IdentityBindPhoneRequest {
  /** 短信验证码
@example "123456" */
  code: string;
  /** 手机号
@example "13800138000" */
  phone: string;
}

export interface IdentityInviteRecord {
  createdAt?: string;
  inviteCode?: string;
  inviteName?: string;
  inviteeAvatar?: string;
  inviteeId?: string;
  rewardPoints?: number;
  /** pending, granted, failed */
  rewardStatus?: string;
  rewardedAt?: string;
  totalRebate?: number;
}

/**
 * 邮箱登录请求参数
 */
export interface IdentityLoginEmailRequest {
  /** 邮箱地址
@example "user@example.com" */
  email: string;
  /** 密码
@example "password123" */
  password: string;
}

/**
 * 手机号登录请求参数
 */
export interface IdentityLoginPhoneRequest {
  /** 短信验证码
@example "123456" */
  code: string;
  /** 邀请码 (可选)
@example "A3B2C1D4" */
  inviteCode?: string;
  /** 手机号
@example "13800138000" */
  phone: string;
}

/**
 * 刷新令牌请求参数
 */
export interface IdentityRefreshTokenRequest {
  /** 刷新令牌 */
  refreshToken: string;
}

/**
 * 邮箱注册请求参数
 */
export interface IdentityRegisterEmailRequest {
  /** 邮箱地址
@example "user@example.com" */
  email: string;
  /**
   * 密码
@example "password123"
   * @minLength 6
   */
  password: string;
  /**
   * 用户名
@example "john_doe"
   * @minLength 3
   * @maxLength 50
   */
  username: string;
}

/**
 * 手机号注册请求参数
 */
export interface IdentityRegisterPhoneRequest {
  /** 短信验证码
@example "123456" */
  code: string;
  /** 邀请码 (可选)
@example "A3B2C1D4" */
  inviteCode?: string;
  /**
   * 密码
@example "password123"
   * @minLength 6
   */
  password: string;
  /** 手机号
@example "13800138000" */
  phone: string;
  /**
   * 用户名
@example "user123"
   * @minLength 3
   * @maxLength 50
   */
  username: string;
}

/**
 * 发送邮箱验证码请求参数
 */
export interface IdentitySendEmailCodeRequest {
  /** 邮箱地址
@example "user@example.com" */
  email: string;
  /** 验证码类型 (register, login, reset_password)
@example "register" */
  type?: string;
}

/**
 * 验证码类型 (register, login, bind)
@example "register"
 */
export type IdentitySendSmsRequestType = typeof IdentitySendSmsRequestType[keyof typeof IdentitySendSmsRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdentitySendSmsRequestType = {
  register: 'register',
  login: 'login',
  bind: 'bind',
} as const;

/**
 * 发送短信验证码请求参数
 */
export interface IdentitySendSmsRequest {
  /** 手机号
@example "13800138000" */
  phone: string;
  /** 验证码类型 (register, login, bind)
@example "register" */
  type: IdentitySendSmsRequestType;
}

/**
 * 登录或注册成功后返回的 Token 信息及用户信息
 */
export interface IdentityTokenResponse {
  /** JWT 访问令牌 */
  accessToken?: string;
  /** 过期时间 (秒) */
  expiresIn?: number;
  /** 刷新令牌 */
  refreshToken?: string;
  /** 用户信息 */
  user?: IdentityUserDTO;
}

export interface IdentityUserDTO {
  displayName?: string;
  email?: string;
  id?: string;
  inviteCode?: string;
  phone?: string;
  rewardPoints?: number;
  twoFactorEnabled?: boolean;
  username?: string;
}

export interface IdentityVerifyEmailRequest {
  /** 验证码 */
  code: string;
  /** 邮箱地址 */
  email: string;
  /** 类型 */
  type?: string;
}

export interface ModelsAnnouncement {
  /** 作者信息 */
  author?: ModelsUser;
  /** 作者ID */
  authorId?: string;
  /** 公告内容（支持Markdown） */
  content?: string;
  createdAt?: string;
  deletedAt?: string;
  id?: string;
  /** 是否置顶 */
  isPinned?: boolean;
  /** 公告状态 */
  status?: ModelsAnnouncementStatus;
  /** 公告标题 */
  title?: string;
  updatedAt?: string;
  /** 浏览次数 */
  viewCount?: number;
}

export type ModelsAnnouncementStatus = typeof ModelsAnnouncementStatus[keyof typeof ModelsAnnouncementStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsAnnouncementStatus = {
  /** 草稿 */
  AnnouncementStatusDraft: 'draft',
  /** 已发布 */
  AnnouncementStatusPublished: 'published',
  /** 已归档 */
  AnnouncementStatusArchived: 'archived',
} as const;

export interface ModelsChoice {
  /** 预期后果 */
  consequence?: string;
  description?: string;
  id?: string;
  text?: string;
}

export interface ModelsConsumptionRecord {
  /** 消费的元点数量（折后） */
  amount?: number;
  author?: ModelsUser;
  /** 创作者ID */
  authorId?: string;
  createdAt?: string;
  deletedAt?: string;
  /** 消费详情（如使用的AI功能） */
  details?: string;
  /** 折扣率 */
  discountRate?: number;
  /** 折扣来源: none/pass/activity */
  discountSource?: string;
  engine?: ModelsEngine;
  /** 作品ID */
  engineId?: string;
  id?: string;
  /** Token 统计字段 */
  inputTokens?: number;
  /** 使用的模型名称 */
  modelName?: string;
  /** 折扣信息（新增） */
  originalAmount?: number;
  /** 输出 token 数 */
  outputTokens?: number;
  /** 关联数据 */
  player?: ModelsUser;
  /** 消费者ID */
  playerId?: string;
  /** 游戏会话ID */
  sessionId?: string;
  /** 总 token 数 */
  totalTokens?: number;
  /** 消费类型: "game_play", "ai_assistant" */
  type?: string;
  updatedAt?: string;
}

export interface ModelsCreatorEarnings {
  /** 关联数据 */
  author?: ModelsUser;
  /** 创作者ID */
  authorId?: string;
  /** 已发后追回的冲正交易ID(Phase 1) */
  clawbackTxId?: string;
  createdAt?: string;
  deletedAt?: string;
  /** 实际收益 */
  earnings?: number;
  engine?: ModelsEngine;
  /** 作品ID */
  engineId?: string;
  /** 审核 + 延迟到账(持有期)+ 防刷字段（迁移 26 加列；行为由 system_configs.reward_hold_* 热控）。 */
  holdUntil?: string;
  id?: string;
  /** 发放时间 */
  paidAt?: string;
  /** 审核/驳回备注 */
  reviewNote?: string;
  /** 审核时间 */
  reviewedAt?: string;
  /** 'system' 或审核管理员 userID */
  reviewedBy?: string;
  /** 命中规则明细 JSON 数组 */
  riskFlags?: string;
  /** 风控评分 0-100 */
  riskScore?: number;
  /** 结算日期 */
  settlementDate?: string;
  /** 分成比例 */
  splitRatio?: number;
  /** 状态机: pending(旧/持有期关时直接发) → held(持有/冷静期) → under_review(命中风控待人工,Phase 1)
       → approved(已通过待发) → paid(已发) ；旁路 rejected(驳回) / clawed_back(已发后追回,Phase 1) / failed */
  status?: string;
  /** 总消费金额 */
  totalConsumption?: number;
  /** 关联的交易记录ID */
  transactionId?: string;
  updatedAt?: string;
}

export interface ModelsEngine {
  author?: ModelsUser;
  authorId?: string;
  backgroundImageUrl?: string;
  category?: string;
  /** 时间戳 */
  createdAt?: string;
  deletedAt?: string;
  description?: string;
  draftVersion?: ModelsEngineVersion;
  /** 当前草稿版本 */
  draftVersionId?: string;
  id?: string;
  /** 图片字段已迁移到版本表，这里作为计算属性从版本获取 */
  imageUrl?: string;
  /** 审核反馈（同步自版本表，便于列表展示） */
  lastReviewNote?: string;
  lastReviewedAt?: string;
  /** 下一个版本号 */
  nextVersionNumber?: number;
  publishedVersion?: ModelsEngineVersion;
  /** 多版本引用（指向当前版本） */
  publishedVersionId?: string;
  reviewingVersion?: ModelsEngineVersion;
  /** 当前审核中版本 */
  reviewingVersionId?: string;
  /** 统计和分类 */
  statistics?: string;
  /** 状态和可见性 */
  status?: ModelsEngineStatus;
  title?: string;
  updatedAt?: string;
  /** 显示用主版本号 */
  version?: string;
}

export type ModelsEngineStatus = typeof ModelsEngineStatus[keyof typeof ModelsEngineStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsEngineStatus = {
  EngineStatusDraft: 'draft',
  EngineStatusPublished: 'published',
  EngineStatusReviewing: 'reviewing',
  EngineStatusRejected: 'rejected',
} as const;

export interface ModelsEngineVersion {
  allowCustomUser?: boolean;
  backgroundImageUrl?: string;
  characterProfiles?: string;
  /** 时间戳 */
  createdAt?: string;
  createdBy?: string;
  deletedAt?: string;
  description?: string;
  engineId?: string;
  /** 开场白（计算属性，统一从 FirstMessages 复数列获取） */
  firstMessage?: string;
  /** 多条开场白 */
  firstMessages?: string;
  id?: string;
  imageUrl?: string;
  /** 核心配置（从 Settings JSONB 拆出的独立列） */
  narrativeCore?: string;
  presetTemplateId?: string;
  reviewNote?: string;
  reviewedAt?: string;
  /** 审核相关 */
  reviewerId?: string;
  /** 扩展配置 */
  settings?: string;
  tags?: string[];
  /** 核心内容 */
  title?: string;
  /** 草稿=0，提交审核时递增 */
  versionNumber?: number;
  /** 版本元信息 */
  versionType?: string;
  /** 内容数据 */
  worldInfo?: string;
}

export interface ModelsLayerConfig {[key: string]: ModelsPromptRef[]}

export type ModelsPaymentMethod = typeof ModelsPaymentMethod[keyof typeof ModelsPaymentMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsPaymentMethod = {
  /** 支付宝 */
  PaymentMethodAlipay: 'alipay',
  /** 微信支付 */
  PaymentMethodWechat: 'wechat',
  /** 模拟支付 */
  PaymentMethodSimulated: 'simulated',
} as const;

export type ModelsPaymentStatus = typeof ModelsPaymentStatus[keyof typeof ModelsPaymentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsPaymentStatus = {
  /** 待支付 */
  PaymentStatusPending: 'pending',
  /** 已支付 */
  PaymentStatusPaid: 'paid',
  /** 已完成 */
  PaymentStatusCompleted: 'completed',
  /** 支付失败 */
  PaymentStatusFailed: 'failed',
  /** 已取消 */
  PaymentStatusCancelled: 'cancelled',
  /** 已退款 */
  PaymentStatusRefunded: 'refunded',
} as const;

export type ModelsPaymentType = typeof ModelsPaymentType[keyof typeof ModelsPaymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsPaymentType = {
  /** 直接充值 */
  PaymentTypeDirect: 'direct',
  /** 通行证购买 */
  PaymentTypePass: 'pass',
  /** 月卡（已废弃，保留兼容） */
  PaymentTypeMonthly: 'monthly',
  /** 消费 */
  PaymentTypeConsume: 'consume',
  /** 退款 */
  PaymentTypeRefund: 'refund',
  /** 每日领取 */
  PaymentTypeDaily: 'daily',
  /** 创作激励 */
  PaymentTypeIncentive: 'incentive',
  /** 邀请奖励 */
  PaymentTypeInvite: 'invite',
  /** 创作者收益分成 */
  PaymentTypeRevenue: 'revenue',
  /** 管理员发放 */
  PaymentTypeAdminGrant: 'admin_grant',
  /** 管理员余额调整（可正可负） */
  PaymentTypeAdminAdjust: 'admin_adjust',
} as const;

export interface ModelsPresetTemplate {
  /** immersive/interactive/novel */
  code?: string;
  created_at?: string;
  deleted_at?: string;
  description?: string;
  id?: string;
  is_active?: boolean;
  is_default?: boolean;
  /** 核心：层级配置 */
  layer_config?: string;
  /** 元数据 */
  metadata?: string;
  name?: string;
  updated_at?: string;
}

export interface ModelsPromptItem {
  content?: string;
  created_at?: string;
  deleted_at?: string;
  id?: string;
  name?: string;
  /** system/user/assistant */
  role?: string;
  /** PostgreSQL数组，用于分类和搜索（须用 pq.StringArray 才能正确读取 text[]） */
  tags?: string[];
  updated_at?: string;
}

export interface ModelsPromptRef {
  enabled?: boolean;
  prompt_id?: string;
}

export type ModelsRetrievalMethod = typeof ModelsRetrievalMethod[keyof typeof ModelsRetrievalMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsRetrievalMethod = {
  /** 关键词调用：直接包含在提示词中 */
  RetrievalMethodPrompt: 'prompt',
  /** 向量检索：根据上下文智能检索 */
  RetrievalMethodVector: 'vector',
  /** 永久调用：始终包含 */
  RetrievalMethodPermanent: 'permanent',
} as const;

/**
 * 元数据
 */
export type ModelsStoryEventMetadata = { [key: string]: unknown };

export interface ModelsStoryEvent {
  /** 可选选项 */
  choices?: ModelsChoice[];
  /** 事件内容 */
  content?: string;
  /** ✨ 事件序号（用于排序） */
  eventNumber?: number;
  id?: string;
  /** 元数据 */
  metadata?: ModelsStoryEventMetadata;
  /** 选择结果 */
  outcome?: string;
  /** ✨ 轮次号（用于排序） */
  roundNumber?: number;
  timestamp?: string;
  /** scene, event, choice, outcome */
  type?: string;
}

export type ModelsSystemEngineStatus = typeof ModelsSystemEngineStatus[keyof typeof ModelsSystemEngineStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsSystemEngineStatus = {
  SystemEngineStatusRunning: 'running',
  SystemEngineStatusStopped: 'stopped',
  SystemEngineStatusError: 'error',
  SystemEngineStatusUpdating: 'updating',
} as const;

export type ModelsSystemEngineType = typeof ModelsSystemEngineType[keyof typeof ModelsSystemEngineType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsSystemEngineType = {
  SystemEngineTypeAIChat: 'ai-chat',
  SystemEngineTypeStory: 'story',
  SystemEngineTypeGame: 'game',
  SystemEngineTypeSimulation: 'simulation',
} as const;

export interface ModelsTemplate {
  content?: string;
  createdAt?: string;
  deletedAt?: string;
  description?: string;
  id?: string;
  isActive?: boolean;
  name?: string;
  order?: number;
  title?: string;
  type?: ModelsTemplateType;
  updatedAt?: string;
}

export type ModelsTemplateType = typeof ModelsTemplateType[keyof typeof ModelsTemplateType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsTemplateType = {
  /** 角色模板 */
  TemplateTypeCharacter: 'character',
  /** 地点模板 */
  TemplateTypeLocation: 'location',
} as const;

export interface ModelsTransactionRecord {
  /** 元点数量（正数为收入，负数为支出） */
  amount?: number;
  /** 交易后余额 */
  balance?: number;
  /** 交易后余额 */
  balanceAfter?: number;
  /** 交易前余额 */
  balanceBefore?: number;
  /** 时间戳 */
  createdAt?: string;
  deletedAt?: string;
  /** 交易描述 */
  description?: string;
  id?: string;
  /** 关联信息 */
  orderId?: string;
  /** 关联游戏会话ID */
  sessionId?: string;
  /** 交易信息 */
  type?: ModelsPaymentType;
  user?: ModelsUser;
  userId?: string;
}

export interface ModelsUser {
  avatarUrl?: string;
  /** 个人资料 */
  bio?: string;
  /** 时间戳 */
  createdAt?: string;
  deletedAt?: string;
  id?: string;
  /** 用户状态 */
  isVerified?: boolean;
  role?: ModelsUserRole;
  status?: ModelsUserStatus;
  updatedAt?: string;
  /** 用户卡 - AI知识库信息 */
  userCard?: string;
  username?: string;
}

export interface ModelsUserChoice {
  choiceId?: string;
  /** 选择时的上下文 */
  context?: string;
  eventId?: string;
  timestamp?: string;
}

export type ModelsUserRole = typeof ModelsUserRole[keyof typeof ModelsUserRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsUserRole = {
  UserRoleUser: 'user',
  UserRoleCreator: 'creator',
  UserRoleAdmin: 'admin',
  UserRoleSuperAdmin: 'super_admin',
} as const;

export type ModelsUserStatus = typeof ModelsUserStatus[keyof typeof ModelsUserStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelsUserStatus = {
  UserStatusActive: 'active',
  UserStatusBanned: 'banned',
  UserStatusPending: 'pending',
} as const;

export interface ModelsWorldInfo {
  content?: string;
  enabled?: boolean;
  id?: string;
  /** 是否为默认用户卡（仅角色档案使用） */
  isUserCard?: boolean;
  /** "and" / "or"，默认 "or" */
  keywordLogic?: string;
  /** 触发关键词（支持 AND/OR） */
  keywords?: string[];
  /** 排序 */
  order?: number;
  /** 父级ID（空表示顶级） */
  parentId?: string;
  /** 优先级 1-10 */
  priority?: number;
  /** prompt/permanent */
  retrievalMethod?: ModelsRetrievalMethod;
  title?: string;
}

/**
 * 游玩信息
 */
export type HandlersStartEnginePlayRequestBody = HandlersStartEnginePlayRequest;

/**
 * 选择信息
 */
export type HandlersMakeChoiceRequestBody = HandlersMakeChoiceRequest;

export type RequestBody = { [key: string]: unknown };

export type GetAdminAnnouncementsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 状态筛选
 */
status?: string;
};

export type GetAdminAnnouncements200AllOfData = { [key: string]: unknown };

export type GetAdminAnnouncements200AllOf = {
  data?: GetAdminAnnouncements200AllOfData;
};

export type GetAdminAnnouncements200 = HandlersResponseData & GetAdminAnnouncements200AllOf;

export type GetAdminAuditLogsParams = {
/**
 * 操作人ID
 */
userId?: string;
/**
 * 动作（模糊匹配）
 */
action?: string;
/**
 * 资源类型
 */
resource?: string;
/**
 * 状态(success/failed/warning)
 */
status?: string;
/**
 * 关键词（详情/IP 模糊匹配）
 */
search?: string;
/**
 * 开始时间
 */
startDate?: string;
/**
 * 结束时间
 */
endDate?: string;
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
pageSize?: number;
};

export type GetAdminAuditLogs200AllOfData = { [key: string]: unknown };

export type GetAdminAuditLogs200AllOf = {
  data?: GetAdminAuditLogs200AllOfData;
};

export type GetAdminAuditLogs200 = HandlersResponseData & GetAdminAuditLogs200AllOf;

export type GetAdminConsumptionRecordsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 作者ID筛选
 */
authorId?: string;
/**
 * 引擎ID筛选
 */
engineId?: string;
/**
 * 玩家ID筛选
 */
playerId?: string;
/**
 * 开始日期（格式：2006-01-02）
 */
startDate?: string;
/**
 * 结束日期（格式：2006-01-02）
 */
endDate?: string;
};

export type GetAdminConsumptionRecords200 = { [key: string]: unknown };

export type GetAdminConsumptionRecords500 = { [key: string]: unknown };

export type GetAdminConsumptionStatsParams = {
/**
 * 作者ID筛选
 */
authorId?: string;
/**
 * 引擎ID筛选
 */
engineId?: string;
/**
 * 开始日期（格式：2006-01-02）
 */
startDate?: string;
/**
 * 结束日期（格式：2006-01-02）
 */
endDate?: string;
};

export type GetAdminConsumptionStats200AllOf = {
  data?: HandlersConsumptionStatsResponse;
};

export type GetAdminConsumptionStats200 = HandlersResponseData & GetAdminConsumptionStats200AllOf;

export type GetAdminContentParams = {
/**
 * 内容类型 (默认 engine)
 */
type?: string;
/**
 * 状态筛选
 */
status?: string;
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 搜索关键词
 */
search?: string;
};

export type GetAdminContent200AllOfData = { [key: string]: unknown };

export type GetAdminContent200AllOf = {
  data?: GetAdminContent200AllOfData;
};

export type GetAdminContent200 = HandlersResponseData & GetAdminContent200AllOf;

export type DeleteAdminContentIdParams = {
/**
 * 类型 (默认 engine)
 */
type?: string;
};

export type PostAdminContentIdStatus200AllOfData = { [key: string]: unknown };

export type PostAdminContentIdStatus200AllOf = {
  data?: PostAdminContentIdStatus200AllOfData;
};

export type PostAdminContentIdStatus200 = HandlersResponseData & PostAdminContentIdStatus200AllOf;

export type GetAdminCreatorEarningsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 作者ID筛选
 */
authorId?: string;
/**
 * 引擎ID筛选
 */
engineId?: string;
};

export type GetAdminCreatorEarnings200 = { [key: string]: unknown };

export type GetAdminCreatorEarnings500 = { [key: string]: unknown };

export type PostAdminCreatorEarningsCalculate200 = { [key: string]: unknown };

export type PostAdminCreatorEarningsCalculate400 = { [key: string]: unknown };

export type PostAdminCreatorEarningsCalculate500 = { [key: string]: unknown };

export type PostAdminCreatorEarningsProcess200 = { [key: string]: unknown };

export type PostAdminCreatorEarningsProcess500 = { [key: string]: unknown };

export type GetAdminCreatorEarningsReviewQueueParams = {
/**
 * 状态筛选，默认 held
 */
status?: string;
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
};

export type GetAdminCreatorEarningsReviewQueue200AllOf = {
  data?: ModelsCreatorEarnings[];
};

export type GetAdminCreatorEarningsReviewQueue200 = HandlersResponseData & GetAdminCreatorEarningsReviewQueue200AllOf;

export type GetAdminCreatorEarningsStats200AllOfData = { [key: string]: unknown };

export type GetAdminCreatorEarningsStats200AllOf = {
  data?: GetAdminCreatorEarningsStats200AllOfData;
};

export type GetAdminCreatorEarningsStats200 = HandlersResponseData & GetAdminCreatorEarningsStats200AllOf;

export type GetAdminCreatorSplitConfig200 = { [key: string]: unknown };

export type GetAdminCreatorSplitConfig500 = { [key: string]: unknown };

export type PutAdminCreatorSplitConfig200 = { [key: string]: unknown };

export type PutAdminCreatorSplitConfig400 = { [key: string]: unknown };

export type PutAdminCreatorSplitConfig500 = { [key: string]: unknown };

export type PostAdminEnginesIdUnpublish200AllOfData = { [key: string]: unknown };

export type PostAdminEnginesIdUnpublish200AllOf = {
  data?: PostAdminEnginesIdUnpublish200AllOfData;
};

export type PostAdminEnginesIdUnpublish200 = HandlersResponseData & PostAdminEnginesIdUnpublish200AllOf;

export type PostAdminGuestCleanup200 = { [key: string]: unknown };

export type PostAdminGuestCleanup400 = { [key: string]: unknown };

export type PostAdminGuestCleanup500 = { [key: string]: unknown };

export type PostAdminGuestCleanupAll200 = { [key: string]: unknown };

export type PostAdminGuestCleanupAll500 = { [key: string]: unknown };

export type GetAdminGuestMetrics200 = { [key: string]: unknown };

export type GetAdminGuestMetrics500 = { [key: string]: unknown };

export type GetAdminIncentiveConfigs200 = { [key: string]: unknown };

export type GetAdminIncentiveConfigs500 = { [key: string]: unknown };

export type PostAdminIncentiveConfigs200 = { [key: string]: unknown };

export type PostAdminIncentiveConfigs400 = { [key: string]: unknown };

export type PutAdminIncentiveConfigsId200 = { [key: string]: unknown };

export type PutAdminIncentiveConfigsId400 = { [key: string]: unknown };

export type PutAdminIncentiveConfigsId404 = { [key: string]: unknown };

export type PutAdminIncentiveConfigsId500 = { [key: string]: unknown };

export type DeleteAdminIncentiveConfigsId200 = { [key: string]: unknown };

export type DeleteAdminIncentiveConfigsId400 = { [key: string]: unknown };

export type GetAdminIncentiveRecordsParams = {
/**
 * 激励类型
 */
type?: string;
/**
 * 激励状态
 */
status?: string;
/**
 * 作者ID
 */
authorId?: string;
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
pageSize?: number;
};

export type GetAdminIncentiveRecords200 = { [key: string]: unknown };

export type GetAdminIncentiveRecords500 = { [key: string]: unknown };

export type PostAdminIncentiveRecordsIdProcess200 = { [key: string]: unknown };

export type PostAdminIncentiveRecordsIdProcess400 = { [key: string]: unknown };

export type PostAdminIncentiveRecordsIdProcess500 = { [key: string]: unknown };

export type GetAdminIncentiveStats200 = { [key: string]: unknown };

export type GetAdminIncentiveStats500 = { [key: string]: unknown };

export type GetAdminPriceConfigsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 配置类型
 */
type?: string;
/**
 * 分类
 */
category?: string;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 排序字段
 */
sort?: string;
/**
 * 排序顺序 (asc/desc)
 */
order?: string;
};

export type GetAdminPriceConfigs200AllOfData = { [key: string]: unknown };

export type GetAdminPriceConfigs200AllOf = {
  data?: GetAdminPriceConfigs200AllOfData;
};

export type GetAdminPriceConfigs200 = HandlersResponseData & GetAdminPriceConfigs200AllOf;

export type PostAdminPriceConfigs200AllOfData = { [key: string]: unknown };

export type PostAdminPriceConfigs200AllOf = {
  data?: PostAdminPriceConfigs200AllOfData;
};

export type PostAdminPriceConfigs200 = HandlersResponseData & PostAdminPriceConfigs200AllOf;

export type GetAdminPriceConfigsCategories200AllOfData = { [key: string]: unknown };

export type GetAdminPriceConfigsCategories200AllOf = {
  data?: GetAdminPriceConfigsCategories200AllOfData;
};

export type GetAdminPriceConfigsCategories200 = HandlersResponseData & GetAdminPriceConfigsCategories200AllOf;

export type GetAdminPriceConfigsId200AllOfData = { [key: string]: unknown };

export type GetAdminPriceConfigsId200AllOf = {
  data?: GetAdminPriceConfigsId200AllOfData;
};

export type GetAdminPriceConfigsId200 = HandlersResponseData & GetAdminPriceConfigsId200AllOf;

export type GetAdminPromptItemsParams = {
/**
 * 标签筛选
 */
tag?: string;
};

export type GetAdminPromptItems200 = { [key: string]: unknown };

export type GetAdminPromptItems500 = { [key: string]: unknown };

export type GetAdminPromptPresets200 = { [key: string]: unknown };

export type GetAdminPromptPresets500 = { [key: string]: unknown };

export type PostAdminPromptPresets400 = { [key: string]: unknown };

export type GetAdminPromptPresetsId200 = { [key: string]: unknown };

export type GetAdminPromptPresetsId400 = { [key: string]: unknown };

export type GetAdminPromptPresetsId404 = { [key: string]: unknown };

export type PutAdminPromptPresetsId400 = { [key: string]: unknown };

export type DeleteAdminPromptPresetsId200 = { [key: string]: unknown };

export type DeleteAdminPromptPresetsId400 = { [key: string]: unknown };

export type GetAdminRechargeOrdersParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 订单状态
 */
status?: string;
/**
 * 支付方式
 */
paymentMethod?: string;
/**
 * 支付类型
 */
paymentType?: string;
};

export type GetAdminRechargeOrders200AllOf = {
  data?: AdminRechargeOrdersResponse;
};

export type GetAdminRechargeOrders200 = HandlersResponseData & GetAdminRechargeOrders200AllOf;

export type GetAdminRechargeOrdersId200AllOf = {
  data?: AdminRechargeOrderDetailResponse;
};

export type GetAdminRechargeOrdersId200 = HandlersResponseData & GetAdminRechargeOrdersId200AllOf;

export type PostAdminRechargeOrdersIdRefund200AllOfData = { [key: string]: unknown };

export type PostAdminRechargeOrdersIdRefund200AllOf = {
  data?: PostAdminRechargeOrdersIdRefund200AllOfData;
};

export type PostAdminRechargeOrdersIdRefund200 = HandlersResponseData & PostAdminRechargeOrdersIdRefund200AllOf;

export type PutAdminRechargeOrdersIdStatus200AllOfData = { [key: string]: unknown };

export type PutAdminRechargeOrdersIdStatus200AllOf = {
  data?: PutAdminRechargeOrdersIdStatus200AllOfData;
};

export type PutAdminRechargeOrdersIdStatus200 = HandlersResponseData & PutAdminRechargeOrdersIdStatus200AllOf;

export type GetAdminSettlementConsumptionRecordsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 作者ID筛选
 */
authorId?: string;
/**
 * 引擎ID筛选
 */
engineId?: string;
/**
 * 玩家ID筛选
 */
playerId?: string;
/**
 * 开始日期（格式：2006-01-02）
 */
startDate?: string;
/**
 * 结束日期（格式：2006-01-02）
 */
endDate?: string;
};

export type GetAdminSettlementConsumptionRecords200AllOf = {
  data?: ModelsConsumptionRecord[];
};

export type GetAdminSettlementConsumptionRecords200 = HandlersResponseData & GetAdminSettlementConsumptionRecords200AllOf;

export type GetAdminSystemEnginesParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 引擎类型
 */
type?: string;
/**
 * 引擎状态
 */
status?: string;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 排序字段
 */
sort?: string;
/**
 * 排序顺序
 */
order?: string;
};

export type GetAdminSystemEngines200AllOfData = { [key: string]: unknown };

export type GetAdminSystemEngines200AllOf = {
  data?: GetAdminSystemEngines200AllOfData;
};

export type GetAdminSystemEngines200 = HandlersResponseData & GetAdminSystemEngines200AllOf;

export type PostAdminSystemEngines200AllOfData = { [key: string]: unknown };

export type PostAdminSystemEngines200AllOf = {
  data?: PostAdminSystemEngines200AllOfData;
};

export type PostAdminSystemEngines200 = HandlersResponseData & PostAdminSystemEngines200AllOf;

export type GetAdminTemplatesParams = {
/**
 * 模板类型
 */
type?: string;
/**
 * 是否激活 (true/false)
 */
isActive?: string;
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
pageSize?: number;
};

export type GetAdminTemplates200AllOfData = { [key: string]: unknown };

export type GetAdminTemplates200AllOf = {
  data?: GetAdminTemplates200AllOfData;
};

export type GetAdminTemplates200 = HandlersResponseData & GetAdminTemplates200AllOf;

export type GetAdminUsersParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 角色筛选
 */
role?: string;
/**
 * 状态筛选
 */
status?: string;
/**
 * 搜索用户名/邮箱
 */
search?: string;
/**
 * 排序字段
 */
sort?: string;
/**
 * 排序顺序(asc/desc)
 */
order?: string;
};

export type GetAdminUsers200AllOf = {
  data?: HandlerUserListResponse;
};

export type GetAdminUsers200 = HandlersResponseData & GetAdminUsers200AllOf;

export type PostAdminUsersBatchDelete200AllOf = {
  data?: HandlerBatchUserResult;
};

export type PostAdminUsersBatchDelete200 = HandlersResponseData & PostAdminUsersBatchDelete200AllOf;

export type PutAdminUsersBatchStatus200AllOf = {
  data?: HandlerBatchUserResult;
};

export type PutAdminUsersBatchStatus200 = HandlersResponseData & PutAdminUsersBatchStatus200AllOf;

export type GetAdminUsersId200AllOf = {
  data?: HandlerUserResponse;
};

export type GetAdminUsersId200 = HandlersResponseData & GetAdminUsersId200AllOf;

export type PutAdminUsersIdBody = { [key: string]: unknown };

export type PutAdminUsersId200AllOf = {
  data?: HandlerUserResponse;
};

export type PutAdminUsersId200 = HandlersResponseData & PutAdminUsersId200AllOf;

export type DeleteAdminUsersId200AllOf = {
  data?: string;
};

export type DeleteAdminUsersId200 = HandlersResponseData & DeleteAdminUsersId200AllOf;

export type GetAdminUsersIdRechargeOrdersParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 订单状态
 */
status?: string;
};

export type GetAdminUsersIdRechargeOrders200AllOf = {
  data?: AdminRechargeOrdersResponse;
};

export type GetAdminUsersIdRechargeOrders200 = HandlersResponseData & GetAdminUsersIdRechargeOrders200AllOf;

export type GetAdminUsersIdTransactionsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 交易类型
 */
type?: string;
};

export type GetAiProviders200 = { [key: string]: unknown };

export type GetAnnouncementsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
};

export type GetAnnouncements200 = { [key: string]: unknown };

export type GetAnnouncements500 = { [key: string]: unknown };

export type GetAnnouncementsLatest200 = { [key: string]: unknown };

export type GetAnnouncementsLatest500 = { [key: string]: unknown };

export type GetAnnouncementsId200 = { [key: string]: unknown };

export type GetAnnouncementsId400 = { [key: string]: unknown };

export type GetAnnouncementsId404 = { [key: string]: unknown };

export type PostApiV1CallbackWechat200 = {[key: string]: string};

export type PostApiV1CallbackWechat400 = {[key: string]: string};

export type PostApiV1CallbackWechat500 = {[key: string]: string};

export type PostAuthLogin200AllOf = {
  data?: IdentityTokenResponse;
};

export type PostAuthLogin200 = HandlersResponseData & PostAuthLogin200AllOf;

export type PostAuthLoginPhone200AllOf = {
  data?: IdentityTokenResponse;
};

export type PostAuthLoginPhone200 = HandlersResponseData & PostAuthLoginPhone200AllOf;

export type PostAuthRefresh200AllOf = {
  data?: IdentityTokenResponse;
};

export type PostAuthRefresh200 = HandlersResponseData & PostAuthRefresh200AllOf;

export type PostAuthRegister200AllOf = {
  data?: IdentityTokenResponse;
};

export type PostAuthRegister200 = HandlersResponseData & PostAuthRegister200AllOf;

export type PostAuthRegisterPhone200AllOf = {
  data?: IdentityTokenResponse;
};

export type PostAuthRegisterPhone200 = HandlersResponseData & PostAuthRegisterPhone200AllOf;

export type PostAuthVerifyCode200AllOf = {
  data?: IdentityTokenResponse;
};

export type PostAuthVerifyCode200 = HandlersResponseData & PostAuthVerifyCode200AllOf;

export type PutCommentsCommentId200 = { [key: string]: unknown };

export type PutCommentsCommentId400 = { [key: string]: unknown };

export type PutCommentsCommentId403 = { [key: string]: unknown };

export type PutCommentsCommentId404 = { [key: string]: unknown };

export type PutCommentsCommentId500 = { [key: string]: unknown };

export type DeleteCommentsCommentId200 = { [key: string]: unknown };

export type DeleteCommentsCommentId400 = { [key: string]: unknown };

export type DeleteCommentsCommentId403 = { [key: string]: unknown };

export type DeleteCommentsCommentId404 = { [key: string]: unknown };

export type DeleteCommentsCommentId500 = { [key: string]: unknown };

export type PostCommentsCommentIdLike200 = { [key: string]: unknown };

export type PostCommentsCommentIdLike400 = { [key: string]: unknown };

export type PostCommentsCommentIdLike404 = { [key: string]: unknown };

export type PostCommentsCommentIdLike500 = { [key: string]: unknown };

export type GetCommentsTargetTypeTargetIdParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 排序字段
 */
sortBy?: string;
/**
 * 排序方向
 */
sortOrder?: GetCommentsTargetTypeTargetIdSortOrder;
};

export type GetCommentsTargetTypeTargetIdSortOrder = typeof GetCommentsTargetTypeTargetIdSortOrder[keyof typeof GetCommentsTargetTypeTargetIdSortOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCommentsTargetTypeTargetIdSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetCommentsTargetTypeTargetId200 = { [key: string]: unknown };

export type GetCommentsTargetTypeTargetId400 = { [key: string]: unknown };

export type GetCommentsTargetTypeTargetId500 = { [key: string]: unknown };

export type PostCommentsTargetTypeTargetId201 = { [key: string]: unknown };

export type PostCommentsTargetTypeTargetId400 = { [key: string]: unknown };

export type PostCommentsTargetTypeTargetId404 = { [key: string]: unknown };

export type PostCommentsTargetTypeTargetId500 = { [key: string]: unknown };

export type GetConfigActivity200 = { [key: string]: unknown };

export type GetConfigActivity500 = { [key: string]: unknown };

export type GetConfigHelpCenter200AllOf = {
  data?: HandlersHelpCenterContent;
};

export type GetConfigHelpCenter200 = HandlersResponseData & GetConfigHelpCenter200AllOf;

export type GetConfigPricing200 = { [key: string]: unknown };

export type GetConfigPricing500 = { [key: string]: unknown };

export type GetDiscoverScenesParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 分类
 */
category?: string;
/**
 * 标签（JSON数组字符串）
 */
tags?: string;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 排序字段
 */
sortBy?: GetDiscoverScenesSortBy;
/**
 * 排序方向
 */
order?: GetDiscoverScenesOrder;
};

export type GetDiscoverScenesSortBy = typeof GetDiscoverScenesSortBy[keyof typeof GetDiscoverScenesSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDiscoverScenesSortBy = {
  plays: 'plays',
  hot: 'hot',
  likes: 'likes',
  rating: 'rating',
  created_at: 'created_at',
  updated_at: 'updated_at',
} as const;

export type GetDiscoverScenesOrder = typeof GetDiscoverScenesOrder[keyof typeof GetDiscoverScenesOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDiscoverScenesOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetDiscoverScenes200 = { [key: string]: unknown };

export type GetDiscoverScenes500 = { [key: string]: unknown };

export type PostDiscoverSearch200 = { [key: string]: unknown };

export type PostDiscoverSearch400 = { [key: string]: unknown };

export type PostDiscoverSearch500 = { [key: string]: unknown };

export type GetDiscoverTrending200 = { [key: string]: unknown };

export type GetDiscoverTrending500 = { [key: string]: unknown };

export type PostEnginePlayPreview200 = { [key: string]: unknown };

export type PostEnginePlayPreview400 = { [key: string]: unknown };

export type PostEnginePlayPreview401 = { [key: string]: unknown };

export type PostEnginePlayPreview403 = { [key: string]: unknown };

export type PostEnginePlayPreview500 = { [key: string]: unknown };

export type GetEnginePlaySessionsSessionId200 = { [key: string]: unknown };

export type GetEnginePlaySessionsSessionId400 = { [key: string]: unknown };

export type GetEnginePlaySessionsSessionId401 = { [key: string]: unknown };

export type GetEnginePlaySessionsSessionId403 = { [key: string]: unknown };

export type GetEnginePlaySessionsSessionId404 = { [key: string]: unknown };

export type GetEnginePlaySessionsSessionId500 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdEnd200 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdEnd400 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdEnd401 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdEnd403 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdEnd404 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdEnd500 = { [key: string]: unknown };

export type GetEnginePlaySessionsSessionIdMessagesParams = {
/**
 * 每次获取数量（默认20，最大100）
 */
limit?: number;
/**
 * 分页游标（Base64编码，从上一页响应获取）
 */
cursor?: string;
/**
 * 排序方向: asc(从旧到新) | desc(从新到旧，默认)
 */
order?: string;
/**
 * 是否返回session信息（默认true）
 */
includeSession?: boolean;
};

export type PostEnginePlaySessionsSessionIdRestart200 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdRestart400 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdRestart401 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdRestart403 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdRestart404 = { [key: string]: unknown };

export type PostEnginePlaySessionsSessionIdRestart500 = { [key: string]: unknown };

export type PostEnginePlayStart200 = { [key: string]: unknown };

export type PostEnginePlayStart400 = { [key: string]: unknown };

export type PostEnginePlayStart401 = { [key: string]: unknown };

export type PostEnginePlayStart500 = { [key: string]: unknown };

export type GetEnginePlayTokenStatsParams = {
/**
 * 引擎ID
 */
engineId: string;
/**
 * 会话ID（可选）
 */
sessionId?: string;
};

export type GetEnginePlayTokenStats200 = { [key: string]: unknown };

export type GetEnginePlayTokenStats400 = { [key: string]: unknown };

export type GetEnginePlayTokenStats403 = { [key: string]: unknown };

export type GetEnginePlayTokenStats404 = { [key: string]: unknown };

export type GetEnginePlayTokenStats500 = { [key: string]: unknown };

export type GetEnginesParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 分类
 */
category?: string;
/**
 * 标签
 */
tags?: string;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 排序字段
 */
sort?: GetEnginesSort;
/**
 * 排序方向
 */
order?: GetEnginesOrder;
};

export type GetEnginesSort = typeof GetEnginesSort[keyof typeof GetEnginesSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEnginesSort = {
  plays: 'plays',
  hot: 'hot',
  likes: 'likes',
  rating: 'rating',
  created_at: 'created_at',
  updated_at: 'updated_at',
} as const;

export type GetEnginesOrder = typeof GetEnginesOrder[keyof typeof GetEnginesOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEnginesOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetEngines200 = { [key: string]: unknown };

export type GetEngines500 = { [key: string]: unknown };

export type PostEngines201 = { [key: string]: unknown };

export type PostEngines400 = { [key: string]: unknown };

export type PostEngines401 = { [key: string]: unknown };

export type PostEngines500 = { [key: string]: unknown };

export type GetEnginesMyParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 分类
 */
category?: string;
/**
 * 状态
 */
status?: string;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 排序字段
 */
sort?: string;
/**
 * 排序方向
 */
order?: GetEnginesMyOrder;
/**
 * 版本类型 (draft/reviewing/published)
 */
vType?: string;
};

export type GetEnginesMyOrder = typeof GetEnginesMyOrder[keyof typeof GetEnginesMyOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEnginesMyOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetEnginesMy200 = { [key: string]: unknown };

export type GetEnginesMy401 = { [key: string]: unknown };

export type GetEnginesMy500 = { [key: string]: unknown };

export type GetEnginesIdParams = {
/**
 * 版本类型 (draft/reviewing/published)
 */
vType?: string;
};

export type GetEnginesId200 = { [key: string]: unknown };

export type GetEnginesId400 = { [key: string]: unknown };

export type GetEnginesId401 = { [key: string]: unknown };

export type GetEnginesId404 = { [key: string]: unknown };

export type GetEnginesId500 = { [key: string]: unknown };

export type PutEnginesId200 = { [key: string]: unknown };

export type PutEnginesId400 = { [key: string]: unknown };

export type PutEnginesId401 = { [key: string]: unknown };

export type PutEnginesId403 = { [key: string]: unknown };

export type PutEnginesId404 = { [key: string]: unknown };

export type PutEnginesId500 = { [key: string]: unknown };

export type DeleteEnginesId200 = { [key: string]: unknown };

export type DeleteEnginesId400 = { [key: string]: unknown };

export type DeleteEnginesId401 = { [key: string]: unknown };

export type DeleteEnginesId403 = { [key: string]: unknown };

export type DeleteEnginesId404 = { [key: string]: unknown };

export type DeleteEnginesId500 = { [key: string]: unknown };

export type GetEnginesIdPreset200 = { [key: string]: unknown };

export type GetEnginesIdPreset400 = { [key: string]: unknown };

export type GetEnginesIdPreset404 = { [key: string]: unknown };

export type PutEnginesIdPreset200 = { [key: string]: unknown };

export type PutEnginesIdPreset400 = { [key: string]: unknown };

export type PutEnginesIdPreset500 = { [key: string]: unknown };

export type PutEnginesIdPublish200 = { [key: string]: unknown };

export type PutEnginesIdPublish400 = { [key: string]: unknown };

export type PutEnginesIdPublish401 = { [key: string]: unknown };

export type PutEnginesIdPublish403 = { [key: string]: unknown };

export type PutEnginesIdPublish404 = { [key: string]: unknown };

export type PutEnginesIdPublish500 = { [key: string]: unknown };

export type PutEnginesIdUnpublish200 = { [key: string]: unknown };

export type PutEnginesIdUnpublish400 = { [key: string]: unknown };

export type PutEnginesIdUnpublish401 = { [key: string]: unknown };

export type PutEnginesIdUnpublish403 = { [key: string]: unknown };

export type PutEnginesIdUnpublish404 = { [key: string]: unknown };

export type PutEnginesIdUnpublish500 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoImport200 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoImport400 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoImport401 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoImport403 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoImport404 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoImport500 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoValidateImport200 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoValidateImport400 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoValidateImport404 = { [key: string]: unknown };

export type PostEnginesIdWorldInfoValidateImport500 = { [key: string]: unknown };

export type PostGuestEnginePlaySessionsSessionIdChoice200 = { [key: string]: unknown };

export type PostGuestEnginePlaySessionsSessionIdChoice400 = { [key: string]: unknown };

export type PostGuestEnginePlaySessionsSessionIdChoice403 = { [key: string]: unknown };

export type PostGuestEnginePlaySessionsSessionIdChoice404 = { [key: string]: unknown };

export type PostGuestEnginePlaySessionsSessionIdChoice500 = { [key: string]: unknown };

export type PostGuestEnginePlayStart200 = { [key: string]: unknown };

export type PostGuestEnginePlayStart400 = { [key: string]: unknown };

export type PostGuestEnginePlayStart403 = { [key: string]: unknown };

export type PostGuestEnginePlayStart500 = { [key: string]: unknown };

export type PostGuestRegister200 = { [key: string]: unknown };

export type PostGuestRegister400 = { [key: string]: unknown };

export type PostGuestRegister500 = { [key: string]: unknown };

export type GetGuestStatus200 = { [key: string]: unknown };

export type GetGuestStatus400 = { [key: string]: unknown };

export type GetGuestStatus500 = { [key: string]: unknown };

export type GetHealth200 = {[key: string]: string};

export type GetMeMessagesParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
};

export type PutMemoryCharacterId200 = { [key: string]: unknown };

export type PutMemoryCharacterId400 = { [key: string]: unknown };

export type PutMemoryCharacterId500 = { [key: string]: unknown };

export type PutMemoryItemId200 = { [key: string]: unknown };

export type PutMemoryItemId400 = { [key: string]: unknown };

export type PutMemoryItemId500 = { [key: string]: unknown };

export type PutMemoryRelationshipId200 = { [key: string]: unknown };

export type PutMemoryRelationshipId400 = { [key: string]: unknown };

export type PutMemoryRelationshipId500 = { [key: string]: unknown };

export type GetMemorySessionsSessionIdParams = {
/**
 * 轮次号（可选）
 */
roundNumber?: number;
/**
 * 是否包含非激活记录
 */
includeInactive?: boolean;
};

export type GetMemorySessionsSessionId200 = { [key: string]: unknown };

export type GetMemorySessionsSessionId400 = { [key: string]: unknown };

export type GetMemorySessionsSessionId500 = { [key: string]: unknown };

export type PutMemoryTaskId200 = { [key: string]: unknown };

export type PutMemoryTaskId400 = { [key: string]: unknown };

export type PutMemoryTaskId500 = { [key: string]: unknown };

export type PutMemoryTimespaceId200 = { [key: string]: unknown };

export type PutMemoryTimespaceId400 = { [key: string]: unknown };

export type PutMemoryTimespaceId500 = { [key: string]: unknown };

export type DeleteMemoryTableId200 = { [key: string]: unknown };

export type DeleteMemoryTableId400 = { [key: string]: unknown };

export type DeleteMemoryTableId500 = { [key: string]: unknown };

export type GetPaymentBalance200AllOf = {
  data?: HandlerBalanceResponse;
};

export type GetPaymentBalance200 = HandlersResponseData & GetPaymentBalance200AllOf;

export type GetPaymentCheckBalance200AllOf = {
  data?: HandlerCheckBalanceResponse;
};

export type GetPaymentCheckBalance200 = HandlersResponseData & GetPaymentCheckBalance200AllOf;

export type GetPaymentConfigParams = {
/**
 * 配置分类
 */
category?: string;
};

export type GetPaymentConfig200AllOf = {
  data?: HandlerSystemConfigResponse;
};

export type GetPaymentConfig200 = HandlersResponseData & GetPaymentConfig200AllOf;

export type PostPaymentOrder201AllOf = {
  data?: HandlerCreateOrderResponse;
};

export type PostPaymentOrder201 = HandlersResponseData & PostPaymentOrder201AllOf;

export type GetPaymentOrderOrderNoStatus200AllOf = {
  data?: HandlerPaymentStatusResponse;
};

export type GetPaymentOrderOrderNoStatus200 = HandlersResponseData & GetPaymentOrderOrderNoStatus200AllOf;

export type GetPaymentPasses200 = { [key: string]: unknown };

export type GetPaymentPasses401 = { [key: string]: unknown };

export type GetPaymentPasses500 = { [key: string]: unknown };

export type PostPaymentPassesValidateBody = {
  passType?: string;
};

export type PostPaymentPassesValidate200 = { [key: string]: unknown };

export type PostPaymentPassesValidate400 = { [key: string]: unknown };

export type PostPaymentPassesValidate401 = { [key: string]: unknown };

export type PostPaymentPassesValidate500 = { [key: string]: unknown };

export type GetPaymentPricing200 = { [key: string]: unknown };

export type GetPaymentPricing500 = { [key: string]: unknown };

export type GetPaymentTransactionsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
};

export type GetPaymentTransactions200AllOf = {
  data?: HandlerTransactionHistoryResponse;
};

export type GetPaymentTransactions200 = HandlersResponseData & GetPaymentTransactions200AllOf;

export type GetPromptPresets200 = { [key: string]: unknown };

export type GetPromptPresets500 = { [key: string]: unknown };

export type GetPromptPresetsId200 = { [key: string]: unknown };

export type GetPromptPresetsId400 = { [key: string]: unknown };

export type GetPromptPresetsId404 = { [key: string]: unknown };

export type GetPublicPriceConfigsExchangeRate200AllOfData = { [key: string]: unknown };

export type GetPublicPriceConfigsExchangeRate200AllOf = {
  data?: GetPublicPriceConfigsExchangeRate200AllOfData;
};

export type GetPublicPriceConfigsExchangeRate200 = HandlersResponseData & GetPublicPriceConfigsExchangeRate200AllOf;

export type GetSuperAdminAdmins200 = { [key: string]: unknown };

export type PutSuperAdminAdminsIdPermissions200 = { [key: string]: unknown };

export type PostUploadAvatarBody = {
  /** 头像文件 */
  avatar: Blob;
};

export type PostUploadAvatar200 = { [key: string]: unknown };

export type PostUploadAvatar400 = { [key: string]: unknown };

export type PostUploadAvatar500 = { [key: string]: unknown };

export type PostUploadEngineEngineIdBackgroundBody = {
  /** 背景图片 */
  image: Blob;
};

export type PostUploadEngineEngineIdBackground200 = { [key: string]: unknown };

export type PostUploadEngineEngineIdBackground400 = { [key: string]: unknown };

export type PostUploadEngineEngineIdBackground500 = { [key: string]: unknown };

export type PostUploadEngineEngineIdImageBody = {
  /** 封面图片 */
  image: Blob;
};

export type PostUploadEngineEngineIdImage200 = { [key: string]: unknown };

export type PostUploadEngineEngineIdImage400 = { [key: string]: unknown };

export type PostUploadEngineEngineIdImage500 = { [key: string]: unknown };

export type PostUploadFileBody = {
  /** 文件 */
  file: Blob;
};

export type PostUploadFile200 = { [key: string]: unknown };

export type PostUploadFile400 = { [key: string]: unknown };

export type PostUploadFile500 = { [key: string]: unknown };

export type DeleteUploadFileKey200 = { [key: string]: unknown };

export type DeleteUploadFileKey400 = { [key: string]: unknown };

export type DeleteUploadFileKey403 = { [key: string]: unknown };

export type DeleteUploadFileKey500 = { [key: string]: unknown };

export type GetUsersInviteCode200AllOf = {
  data?: HandlerInviteCodeResponse;
};

export type GetUsersInviteCode200 = HandlersResponseData & GetUsersInviteCode200AllOf;

export type GetUsersInviteRecordsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
pageSize?: number;
};

export type GetUsersInviteRecords200AllOf = {
  data?: HandlerInviteRecordsResponse;
};

export type GetUsersInviteRecords200 = HandlersResponseData & GetUsersInviteRecords200AllOf;

export type GetWorkshopEnginesParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
/**
 * 分类
 */
category?: string;
/**
 * 搜索关键词
 */
search?: string;
/**
 * 排序字段
 */
sort?: string;
/**
 * 排序方向
 */
order?: GetWorkshopEnginesOrder;
};

export type GetWorkshopEnginesOrder = typeof GetWorkshopEnginesOrder[keyof typeof GetWorkshopEnginesOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWorkshopEnginesOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type GetWorkshopEngines200 = { [key: string]: unknown };

export type GetWorkshopEngines500 = { [key: string]: unknown };

export type GetWorkshopEnginesId200 = { [key: string]: unknown };

export type GetWorkshopEnginesId400 = { [key: string]: unknown };

export type GetWorkshopEnginesId404 = { [key: string]: unknown };

export type PostWorkshopEnginesIdBookmark200 = { [key: string]: unknown };

export type PostWorkshopEnginesIdBookmark400 = { [key: string]: unknown };

export type PostWorkshopEnginesIdBookmark500 = { [key: string]: unknown };

export type GetWorkshopEnginesIdCommentsParams = {
/**
 * 页码
 */
page?: number;
/**
 * 每页数量
 */
limit?: number;
};

export type GetWorkshopEnginesIdComments200 = { [key: string]: unknown };

export type GetWorkshopEnginesIdComments400 = { [key: string]: unknown };

export type GetWorkshopEnginesIdComments404 = { [key: string]: unknown };

export type GetWorkshopEnginesIdComments500 = { [key: string]: unknown };

export type PostWorkshopEnginesIdComments201 = { [key: string]: unknown };

export type PostWorkshopEnginesIdComments400 = { [key: string]: unknown };

export type PostWorkshopEnginesIdComments404 = { [key: string]: unknown };

export type PostWorkshopEnginesIdComments500 = { [key: string]: unknown };

export type PostWorkshopEnginesIdLike200 = { [key: string]: unknown };

export type PostWorkshopEnginesIdLike400 = { [key: string]: unknown };

export type PostWorkshopEnginesIdLike404 = { [key: string]: unknown };

export type PostWorkshopEnginesIdLike500 = { [key: string]: unknown };

/**
 * 管理员获取所有公告列表，支持搜索和状态筛选
 * @summary 获取公告列表
 */
export const getAdminAnnouncements = (
    params?: GetAdminAnnouncementsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminAnnouncements200>(
      {url: `/admin/announcements`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminAnnouncementsQueryKey = (params?: GetAdminAnnouncementsParams,) => {
    return [
    `/admin/announcements`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminAnnouncementsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = HandlersResponseData>(params?: GetAdminAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAnnouncementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAnnouncements>>> = ({ signal }) => getAdminAnnouncements(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAnnouncements>>>
export type GetAdminAnnouncementsQueryError = HandlersResponseData


export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminAnnouncementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getAdminAnnouncements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = HandlersResponseData>(
 params?: GetAdminAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getAdminAnnouncements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = HandlersResponseData>(
 params?: GetAdminAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取公告列表
 */

export function useGetAdminAnnouncements<TData = Awaited<ReturnType<typeof getAdminAnnouncements>>, TError = HandlersResponseData>(
 params?: GetAdminAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncements>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAnnouncementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员创建新的系统公告
 * @summary 创建公告
 */
export const postAdminAnnouncements = (
    adminCreateAnnouncementRequest: AdminCreateAnnouncementRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<ModelsAnnouncement>(
      {url: `/admin/announcements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCreateAnnouncementRequest, signal
    },
      );
    }
  


export const getPostAdminAnnouncementsMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminAnnouncements>>, TError,{data: AdminCreateAnnouncementRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminAnnouncements>>, TError,{data: AdminCreateAnnouncementRequest}, TContext> => {

const mutationKey = ['postAdminAnnouncements'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminAnnouncements>>, {data: AdminCreateAnnouncementRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminAnnouncements(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminAnnouncementsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminAnnouncements>>>
    export type PostAdminAnnouncementsMutationBody = AdminCreateAnnouncementRequest
    export type PostAdminAnnouncementsMutationError = HandlersResponseData

    /**
 * @summary 创建公告
 */
export const usePostAdminAnnouncements = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminAnnouncements>>, TError,{data: AdminCreateAnnouncementRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminAnnouncements>>,
        TError,
        {data: AdminCreateAnnouncementRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminAnnouncementsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员通过 ID 获取公告详细信息
 * @summary 获取公告详情
 */
export const getAdminAnnouncementsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<ModelsAnnouncement>(
      {url: `/admin/announcements/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminAnnouncementsIdQueryKey = (id?: string,) => {
    return [
    `/admin/announcements/${id}`
    ] as const;
    }

    
export const getGetAdminAnnouncementsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError = HandlersResponseData>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAnnouncementsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAnnouncementsId>>> = ({ signal }) => getAdminAnnouncementsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAnnouncementsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAnnouncementsId>>>
export type GetAdminAnnouncementsIdQueryError = HandlersResponseData


export function useGetAdminAnnouncementsId<TData = Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError = HandlersResponseData>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAnnouncementsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminAnnouncementsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAnnouncementsId<TData = Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAnnouncementsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminAnnouncementsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAnnouncementsId<TData = Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取公告详情
 */

export function useGetAdminAnnouncementsId<TData = Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAnnouncementsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAnnouncementsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员更新现有公告的信息
 * @summary 更新公告
 */
export const putAdminAnnouncementsId = (
    id: string,
    adminUpdateAnnouncementRequest: AdminUpdateAnnouncementRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/announcements/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateAnnouncementRequest
    },
      );
    }
  


export const getPutAdminAnnouncementsIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminAnnouncementsId>>, TError,{id: string;data: AdminUpdateAnnouncementRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminAnnouncementsId>>, TError,{id: string;data: AdminUpdateAnnouncementRequest}, TContext> => {

const mutationKey = ['putAdminAnnouncementsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminAnnouncementsId>>, {id: string;data: AdminUpdateAnnouncementRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminAnnouncementsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminAnnouncementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminAnnouncementsId>>>
    export type PutAdminAnnouncementsIdMutationBody = AdminUpdateAnnouncementRequest
    export type PutAdminAnnouncementsIdMutationError = HandlersResponseData

    /**
 * @summary 更新公告
 */
export const usePutAdminAnnouncementsId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminAnnouncementsId>>, TError,{id: string;data: AdminUpdateAnnouncementRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminAnnouncementsId>>,
        TError,
        {id: string;data: AdminUpdateAnnouncementRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminAnnouncementsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员删除指定的公告
 * @summary 删除公告
 */
export const deleteAdminAnnouncementsId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/announcements/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminAnnouncementsIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAnnouncementsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAnnouncementsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminAnnouncementsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminAnnouncementsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminAnnouncementsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminAnnouncementsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminAnnouncementsId>>>
    
    export type DeleteAdminAnnouncementsIdMutationError = HandlersResponseData

    /**
 * @summary 删除公告
 */
export const useDeleteAdminAnnouncementsId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminAnnouncementsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminAnnouncementsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminAnnouncementsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员查询管理端操作审计日志，支持按操作人/动作/资源/状态/时间/关键词筛选与分页
 * @summary 获取审计日志
 */
export const getAdminAuditLogs = (
    params?: GetAdminAuditLogsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminAuditLogs200>(
      {url: `/admin/audit-logs`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminAuditLogsQueryKey = (params?: GetAdminAuditLogsParams,) => {
    return [
    `/admin/audit-logs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAuditLogs>>, TError = HandlersResponseData>(params?: GetAdminAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAuditLogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAuditLogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAuditLogs>>> = ({ signal }) => getAdminAuditLogs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAuditLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAuditLogs>>>
export type GetAdminAuditLogsQueryError = HandlersResponseData


export function useGetAdminAuditLogs<TData = Awaited<ReturnType<typeof getAdminAuditLogs>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminAuditLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAuditLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getAdminAuditLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAuditLogs<TData = Awaited<ReturnType<typeof getAdminAuditLogs>>, TError = HandlersResponseData>(
 params?: GetAdminAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAuditLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof getAdminAuditLogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminAuditLogs<TData = Awaited<ReturnType<typeof getAdminAuditLogs>>, TError = HandlersResponseData>(
 params?: GetAdminAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAuditLogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取审计日志
 */

export function useGetAdminAuditLogs<TData = Awaited<ReturnType<typeof getAdminAuditLogs>>, TError = HandlersResponseData>(
 params?: GetAdminAuditLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminAuditLogs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminAuditLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员获取消费记录列表，支持分页和多维度筛选
 * @summary 获取消费记录
 */
export const getAdminConsumptionRecords = (
    params?: GetAdminConsumptionRecordsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminConsumptionRecords200>(
      {url: `/admin/consumption-records`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminConsumptionRecordsQueryKey = (params?: GetAdminConsumptionRecordsParams,) => {
    return [
    `/admin/consumption-records`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminConsumptionRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError = GetAdminConsumptionRecords500>(params?: GetAdminConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminConsumptionRecordsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminConsumptionRecords>>> = ({ signal }) => getAdminConsumptionRecords(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminConsumptionRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminConsumptionRecords>>>
export type GetAdminConsumptionRecordsQueryError = GetAdminConsumptionRecords500


export function useGetAdminConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError = GetAdminConsumptionRecords500>(
 params: undefined |  GetAdminConsumptionRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminConsumptionRecords>>,
          TError,
          Awaited<ReturnType<typeof getAdminConsumptionRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError = GetAdminConsumptionRecords500>(
 params?: GetAdminConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminConsumptionRecords>>,
          TError,
          Awaited<ReturnType<typeof getAdminConsumptionRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError = GetAdminConsumptionRecords500>(
 params?: GetAdminConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取消费记录
 */

export function useGetAdminConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError = GetAdminConsumptionRecords500>(
 params?: GetAdminConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionRecords>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminConsumptionRecordsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员获取消费统计数据，支持按作者、引擎和时间范围筛选
 * @summary 获取消费统计
 */
export const getAdminConsumptionStats = (
    params?: GetAdminConsumptionStatsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminConsumptionStats200>(
      {url: `/admin/consumption-stats`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminConsumptionStatsQueryKey = (params?: GetAdminConsumptionStatsParams,) => {
    return [
    `/admin/consumption-stats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminConsumptionStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError = HandlersResponseData>(params?: GetAdminConsumptionStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminConsumptionStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminConsumptionStats>>> = ({ signal }) => getAdminConsumptionStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminConsumptionStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminConsumptionStats>>>
export type GetAdminConsumptionStatsQueryError = HandlersResponseData


export function useGetAdminConsumptionStats<TData = Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminConsumptionStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminConsumptionStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminConsumptionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminConsumptionStats<TData = Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError = HandlersResponseData>(
 params?: GetAdminConsumptionStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminConsumptionStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminConsumptionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminConsumptionStats<TData = Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError = HandlersResponseData>(
 params?: GetAdminConsumptionStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取消费统计
 */

export function useGetAdminConsumptionStats<TData = Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError = HandlersResponseData>(
 params?: GetAdminConsumptionStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminConsumptionStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminConsumptionStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员获取内容列表（主要是引擎），支持搜索、分页和状态筛选
 * @summary 获取内容列表
 */
export const getAdminContent = (
    params?: GetAdminContentParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminContent200>(
      {url: `/admin/content`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminContentQueryKey = (params?: GetAdminContentParams,) => {
    return [
    `/admin/content`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminContentQueryOptions = <TData = Awaited<ReturnType<typeof getAdminContent>>, TError = HandlersResponseData>(params?: GetAdminContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminContentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminContent>>> = ({ signal }) => getAdminContent(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminContentQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminContent>>>
export type GetAdminContentQueryError = HandlersResponseData


export function useGetAdminContent<TData = Awaited<ReturnType<typeof getAdminContent>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminContentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContent>>,
          TError,
          Awaited<ReturnType<typeof getAdminContent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContent<TData = Awaited<ReturnType<typeof getAdminContent>>, TError = HandlersResponseData>(
 params?: GetAdminContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminContent>>,
          TError,
          Awaited<ReturnType<typeof getAdminContent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminContent<TData = Awaited<ReturnType<typeof getAdminContent>>, TError = HandlersResponseData>(
 params?: GetAdminContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取内容列表
 */

export function useGetAdminContent<TData = Awaited<ReturnType<typeof getAdminContent>>, TError = HandlersResponseData>(
 params?: GetAdminContentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminContent>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminContentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员更新内容的基础信息
 * @summary 更新内容信息
 */
export const putAdminContentId = (
    id: string,
    adminUpdateContentRequest: AdminUpdateContentRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/content/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateContentRequest
    },
      );
    }
  


export const getPutAdminContentIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminContentId>>, TError,{id: string;data: AdminUpdateContentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminContentId>>, TError,{id: string;data: AdminUpdateContentRequest}, TContext> => {

const mutationKey = ['putAdminContentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminContentId>>, {id: string;data: AdminUpdateContentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminContentId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminContentIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminContentId>>>
    export type PutAdminContentIdMutationBody = AdminUpdateContentRequest
    export type PutAdminContentIdMutationError = HandlersResponseData

    /**
 * @summary 更新内容信息
 */
export const usePutAdminContentId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminContentId>>, TError,{id: string;data: AdminUpdateContentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminContentId>>,
        TError,
        {id: string;data: AdminUpdateContentRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminContentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员删除指定的内容
 * @summary 删除内容
 */
export const deleteAdminContentId = (
    id: string,
    params?: DeleteAdminContentIdParams,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/content/${id}`, method: 'DELETE',
        params
    },
      );
    }
  


export const getDeleteAdminContentIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminContentId>>, TError,{id: string;params?: DeleteAdminContentIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminContentId>>, TError,{id: string;params?: DeleteAdminContentIdParams}, TContext> => {

const mutationKey = ['deleteAdminContentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminContentId>>, {id: string;params?: DeleteAdminContentIdParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteAdminContentId(id,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminContentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminContentId>>>
    
    export type DeleteAdminContentIdMutationError = HandlersResponseData

    /**
 * @summary 删除内容
 */
export const useDeleteAdminContentId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminContentId>>, TError,{id: string;params?: DeleteAdminContentIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminContentId>>,
        TError,
        {id: string;params?: DeleteAdminContentIdParams},
        TContext
      > => {

      const mutationOptions = getDeleteAdminContentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员更新内容的状态（如发布、草稿、下架等）
 * @summary 更新内容状态
 */
export const postAdminContentIdStatus = (
    id: string,
    adminUpdateContentStatusRequest: AdminUpdateContentStatusRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminContentIdStatus200>(
      {url: `/admin/content/${id}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateContentStatusRequest, signal
    },
      );
    }
  


export const getPostAdminContentIdStatusMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminContentIdStatus>>, TError,{id: string;data: AdminUpdateContentStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminContentIdStatus>>, TError,{id: string;data: AdminUpdateContentStatusRequest}, TContext> => {

const mutationKey = ['postAdminContentIdStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminContentIdStatus>>, {id: string;data: AdminUpdateContentStatusRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postAdminContentIdStatus(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminContentIdStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminContentIdStatus>>>
    export type PostAdminContentIdStatusMutationBody = AdminUpdateContentStatusRequest
    export type PostAdminContentIdStatusMutationError = HandlersResponseData

    /**
 * @summary 更新内容状态
 */
export const usePostAdminContentIdStatus = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminContentIdStatus>>, TError,{id: string;data: AdminUpdateContentStatusRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminContentIdStatus>>,
        TError,
        {id: string;data: AdminUpdateContentStatusRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminContentIdStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取创作者收益记录列表，支持分页和筛选
 * @summary 获取创作者收益记录（管理员）
 */
export const getAdminCreatorEarnings = (
    params?: GetAdminCreatorEarningsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminCreatorEarnings200>(
      {url: `/admin/creator-earnings`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminCreatorEarningsQueryKey = (params?: GetAdminCreatorEarningsParams,) => {
    return [
    `/admin/creator-earnings`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminCreatorEarningsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError = GetAdminCreatorEarnings500>(params?: GetAdminCreatorEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCreatorEarningsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCreatorEarnings>>> = ({ signal }) => getAdminCreatorEarnings(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminCreatorEarningsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCreatorEarnings>>>
export type GetAdminCreatorEarningsQueryError = GetAdminCreatorEarnings500


export function useGetAdminCreatorEarnings<TData = Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError = GetAdminCreatorEarnings500>(
 params: undefined |  GetAdminCreatorEarningsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorEarnings>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorEarnings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorEarnings<TData = Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError = GetAdminCreatorEarnings500>(
 params?: GetAdminCreatorEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorEarnings>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorEarnings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorEarnings<TData = Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError = GetAdminCreatorEarnings500>(
 params?: GetAdminCreatorEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取创作者收益记录（管理员）
 */

export function useGetAdminCreatorEarnings<TData = Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError = GetAdminCreatorEarnings500>(
 params?: GetAdminCreatorEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarnings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCreatorEarningsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员根据指定结算日期计算创作者收益
 * @summary 计算创作者收益
 */
export const postAdminCreatorEarningsCalculate = (
    handlersCalculateCreatorEarningsRequest: HandlersCalculateCreatorEarningsRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminCreatorEarningsCalculate200>(
      {url: `/admin/creator-earnings/calculate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersCalculateCreatorEarningsRequest, signal
    },
      );
    }
  


export const getPostAdminCreatorEarningsCalculateMutationOptions = <TError = PostAdminCreatorEarningsCalculate400 | PostAdminCreatorEarningsCalculate500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsCalculate>>, TError,{data: HandlersCalculateCreatorEarningsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsCalculate>>, TError,{data: HandlersCalculateCreatorEarningsRequest}, TContext> => {

const mutationKey = ['postAdminCreatorEarningsCalculate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreatorEarningsCalculate>>, {data: HandlersCalculateCreatorEarningsRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminCreatorEarningsCalculate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreatorEarningsCalculateMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreatorEarningsCalculate>>>
    export type PostAdminCreatorEarningsCalculateMutationBody = HandlersCalculateCreatorEarningsRequest
    export type PostAdminCreatorEarningsCalculateMutationError = PostAdminCreatorEarningsCalculate400 | PostAdminCreatorEarningsCalculate500

    /**
 * @summary 计算创作者收益
 */
export const usePostAdminCreatorEarningsCalculate = <TError = PostAdminCreatorEarningsCalculate400 | PostAdminCreatorEarningsCalculate500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsCalculate>>, TError,{data: HandlersCalculateCreatorEarningsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminCreatorEarningsCalculate>>,
        TError,
        {data: HandlersCalculateCreatorEarningsRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminCreatorEarningsCalculateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员处理创作者收益的发放
 * @summary 处理创作者收益发放
 */
export const postAdminCreatorEarningsProcess = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminCreatorEarningsProcess200>(
      {url: `/admin/creator-earnings/process`, method: 'POST', signal
    },
      );
    }
  


export const getPostAdminCreatorEarningsProcessMutationOptions = <TError = PostAdminCreatorEarningsProcess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsProcess>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsProcess>>, TError,void, TContext> => {

const mutationKey = ['postAdminCreatorEarningsProcess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreatorEarningsProcess>>, void> = () => {
          

          return  postAdminCreatorEarningsProcess()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreatorEarningsProcessMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreatorEarningsProcess>>>
    
    export type PostAdminCreatorEarningsProcessMutationError = PostAdminCreatorEarningsProcess500

    /**
 * @summary 处理创作者收益发放
 */
export const usePostAdminCreatorEarningsProcess = <TError = PostAdminCreatorEarningsProcess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsProcess>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminCreatorEarningsProcess>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAdminCreatorEarningsProcessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 按状态(held/under_review/approved/paid/rejected)分页拉取创作者收益，供人工审核
 * @summary 创作者收益审核队列
 */
export const getAdminCreatorEarningsReviewQueue = (
    params?: GetAdminCreatorEarningsReviewQueueParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminCreatorEarningsReviewQueue200>(
      {url: `/admin/creator-earnings/review-queue`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminCreatorEarningsReviewQueueQueryKey = (params?: GetAdminCreatorEarningsReviewQueueParams,) => {
    return [
    `/admin/creator-earnings/review-queue`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminCreatorEarningsReviewQueueQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError = unknown>(params?: GetAdminCreatorEarningsReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCreatorEarningsReviewQueueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>> = ({ signal }) => getAdminCreatorEarningsReviewQueue(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminCreatorEarningsReviewQueueQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>>
export type GetAdminCreatorEarningsReviewQueueQueryError = unknown


export function useGetAdminCreatorEarningsReviewQueue<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError = unknown>(
 params: undefined |  GetAdminCreatorEarningsReviewQueueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorEarningsReviewQueue<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError = unknown>(
 params?: GetAdminCreatorEarningsReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorEarningsReviewQueue<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError = unknown>(
 params?: GetAdminCreatorEarningsReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 创作者收益审核队列
 */

export function useGetAdminCreatorEarningsReviewQueue<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError = unknown>(
 params?: GetAdminCreatorEarningsReviewQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsReviewQueue>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCreatorEarningsReviewQueueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 人工通过或驳回一条持有/待审中的创作者收益；只改状态不发钱，发放仍由结算任务统一执行
 * @summary 审核单条创作者收益
 */
export const postAdminCreatorEarningsReviewId = (
    id: string,
    handlerReviewCreatorEarningRequest: HandlerReviewCreatorEarningRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/creator-earnings/review/${id}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlerReviewCreatorEarningRequest, signal
    },
      );
    }
  


export const getPostAdminCreatorEarningsReviewIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsReviewId>>, TError,{id: string;data: HandlerReviewCreatorEarningRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsReviewId>>, TError,{id: string;data: HandlerReviewCreatorEarningRequest}, TContext> => {

const mutationKey = ['postAdminCreatorEarningsReviewId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminCreatorEarningsReviewId>>, {id: string;data: HandlerReviewCreatorEarningRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postAdminCreatorEarningsReviewId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminCreatorEarningsReviewIdMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminCreatorEarningsReviewId>>>
    export type PostAdminCreatorEarningsReviewIdMutationBody = HandlerReviewCreatorEarningRequest
    export type PostAdminCreatorEarningsReviewIdMutationError = unknown

    /**
 * @summary 审核单条创作者收益
 */
export const usePostAdminCreatorEarningsReviewId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminCreatorEarningsReviewId>>, TError,{id: string;data: HandlerReviewCreatorEarningRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminCreatorEarningsReviewId>>,
        TError,
        {id: string;data: HandlerReviewCreatorEarningRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminCreatorEarningsReviewIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 按状态分桶汇总 creator_earnings 总额，供管理端概览卡片使用
 * @summary 创作者收益统计
 */
export const getAdminCreatorEarningsStats = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminCreatorEarningsStats200>(
      {url: `/admin/creator-earnings/stats`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminCreatorEarningsStatsQueryKey = () => {
    return [
    `/admin/creator-earnings/stats`
    ] as const;
    }

    
export const getGetAdminCreatorEarningsStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCreatorEarningsStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>> = ({ signal }) => getAdminCreatorEarningsStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminCreatorEarningsStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>>
export type GetAdminCreatorEarningsStatsQueryError = unknown


export function useGetAdminCreatorEarningsStats<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorEarningsStats<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorEarningsStats<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 创作者收益统计
 */

export function useGetAdminCreatorEarningsStats<TData = Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorEarningsStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCreatorEarningsStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员获取创作者分成配置信息
 * @summary 获取创作者分成配置
 */
export const getAdminCreatorSplitConfig = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminCreatorSplitConfig200>(
      {url: `/admin/creator-split-config`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminCreatorSplitConfigQueryKey = () => {
    return [
    `/admin/creator-split-config`
    ] as const;
    }

    
export const getGetAdminCreatorSplitConfigQueryOptions = <TData = Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError = GetAdminCreatorSplitConfig500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminCreatorSplitConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>> = ({ signal }) => getAdminCreatorSplitConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminCreatorSplitConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>>
export type GetAdminCreatorSplitConfigQueryError = GetAdminCreatorSplitConfig500


export function useGetAdminCreatorSplitConfig<TData = Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError = GetAdminCreatorSplitConfig500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorSplitConfig<TData = Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError = GetAdminCreatorSplitConfig500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>,
          TError,
          Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminCreatorSplitConfig<TData = Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError = GetAdminCreatorSplitConfig500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取创作者分成配置
 */

export function useGetAdminCreatorSplitConfig<TData = Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError = GetAdminCreatorSplitConfig500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminCreatorSplitConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminCreatorSplitConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员更新创作者分成配置
 * @summary 更新创作者分成配置
 */
export const putAdminCreatorSplitConfig = (
    handlersUpdateCreatorSplitConfigRequest: HandlersUpdateCreatorSplitConfigRequest,
 ) => {
      
      
      return origin_point_engine_api<PutAdminCreatorSplitConfig200>(
      {url: `/admin/creator-split-config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersUpdateCreatorSplitConfigRequest
    },
      );
    }
  


export const getPutAdminCreatorSplitConfigMutationOptions = <TError = PutAdminCreatorSplitConfig400 | PutAdminCreatorSplitConfig500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminCreatorSplitConfig>>, TError,{data: HandlersUpdateCreatorSplitConfigRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminCreatorSplitConfig>>, TError,{data: HandlersUpdateCreatorSplitConfigRequest}, TContext> => {

const mutationKey = ['putAdminCreatorSplitConfig'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminCreatorSplitConfig>>, {data: HandlersUpdateCreatorSplitConfigRequest}> = (props) => {
          const {data} = props ?? {};

          return  putAdminCreatorSplitConfig(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminCreatorSplitConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminCreatorSplitConfig>>>
    export type PutAdminCreatorSplitConfigMutationBody = HandlersUpdateCreatorSplitConfigRequest
    export type PutAdminCreatorSplitConfigMutationError = PutAdminCreatorSplitConfig400 | PutAdminCreatorSplitConfig500

    /**
 * @summary 更新创作者分成配置
 */
export const usePutAdminCreatorSplitConfig = <TError = PutAdminCreatorSplitConfig400 | PutAdminCreatorSplitConfig500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminCreatorSplitConfig>>, TError,{data: HandlersUpdateCreatorSplitConfigRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminCreatorSplitConfig>>,
        TError,
        {data: HandlersUpdateCreatorSplitConfigRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminCreatorSplitConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员强制下架指定的引擎
 * @summary 管理员下架引擎
 */
export const postAdminEnginesIdUnpublish = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminEnginesIdUnpublish200>(
      {url: `/admin/engines/${id}/unpublish`, method: 'POST', signal
    },
      );
    }
  


export const getPostAdminEnginesIdUnpublishMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEnginesIdUnpublish>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminEnginesIdUnpublish>>, TError,{id: string}, TContext> => {

const mutationKey = ['postAdminEnginesIdUnpublish'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminEnginesIdUnpublish>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postAdminEnginesIdUnpublish(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminEnginesIdUnpublishMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminEnginesIdUnpublish>>>
    
    export type PostAdminEnginesIdUnpublishMutationError = HandlersResponseData

    /**
 * @summary 管理员下架引擎
 */
export const usePostAdminEnginesIdUnpublish = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminEnginesIdUnpublish>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminEnginesIdUnpublish>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostAdminEnginesIdUnpublishMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 清理指定天数前未访问的游客会话
 * @summary 清理过期游客会话
 */
export const postAdminGuestCleanup = (
    handlersCleanupExpiredSessionsRequest: HandlersCleanupExpiredSessionsRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminGuestCleanup200>(
      {url: `/admin/guest/cleanup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersCleanupExpiredSessionsRequest, signal
    },
      );
    }
  


export const getPostAdminGuestCleanupMutationOptions = <TError = PostAdminGuestCleanup400 | PostAdminGuestCleanup500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGuestCleanup>>, TError,{data: HandlersCleanupExpiredSessionsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminGuestCleanup>>, TError,{data: HandlersCleanupExpiredSessionsRequest}, TContext> => {

const mutationKey = ['postAdminGuestCleanup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminGuestCleanup>>, {data: HandlersCleanupExpiredSessionsRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminGuestCleanup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminGuestCleanupMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminGuestCleanup>>>
    export type PostAdminGuestCleanupMutationBody = HandlersCleanupExpiredSessionsRequest
    export type PostAdminGuestCleanupMutationError = PostAdminGuestCleanup400 | PostAdminGuestCleanup500

    /**
 * @summary 清理过期游客会话
 */
export const usePostAdminGuestCleanup = <TError = PostAdminGuestCleanup400 | PostAdminGuestCleanup500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGuestCleanup>>, TError,{data: HandlersCleanupExpiredSessionsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminGuestCleanup>>,
        TError,
        {data: HandlersCleanupExpiredSessionsRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminGuestCleanupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 清理所有游客会话（谨慎使用）
 * @summary 清理所有游客会话
 */
export const postAdminGuestCleanupAll = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminGuestCleanupAll200>(
      {url: `/admin/guest/cleanup-all`, method: 'POST', signal
    },
      );
    }
  


export const getPostAdminGuestCleanupAllMutationOptions = <TError = PostAdminGuestCleanupAll500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGuestCleanupAll>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminGuestCleanupAll>>, TError,void, TContext> => {

const mutationKey = ['postAdminGuestCleanupAll'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminGuestCleanupAll>>, void> = () => {
          

          return  postAdminGuestCleanupAll()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminGuestCleanupAllMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminGuestCleanupAll>>>
    
    export type PostAdminGuestCleanupAllMutationError = PostAdminGuestCleanupAll500

    /**
 * @summary 清理所有游客会话
 */
export const usePostAdminGuestCleanupAll = <TError = PostAdminGuestCleanupAll500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminGuestCleanupAll>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminGuestCleanupAll>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAdminGuestCleanupAllMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取游客系统的统计数据，包括总游客数、活跃会话数、轮次使用情况等
 * @summary 获取游客统计数据
 */
export const getAdminGuestMetrics = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminGuestMetrics200>(
      {url: `/admin/guest/metrics`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminGuestMetricsQueryKey = () => {
    return [
    `/admin/guest/metrics`
    ] as const;
    }

    
export const getGetAdminGuestMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError = GetAdminGuestMetrics500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminGuestMetricsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminGuestMetrics>>> = ({ signal }) => getAdminGuestMetrics(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminGuestMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminGuestMetrics>>>
export type GetAdminGuestMetricsQueryError = GetAdminGuestMetrics500


export function useGetAdminGuestMetrics<TData = Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError = GetAdminGuestMetrics500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGuestMetrics>>,
          TError,
          Awaited<ReturnType<typeof getAdminGuestMetrics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminGuestMetrics<TData = Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError = GetAdminGuestMetrics500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminGuestMetrics>>,
          TError,
          Awaited<ReturnType<typeof getAdminGuestMetrics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminGuestMetrics<TData = Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError = GetAdminGuestMetrics500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取游客统计数据
 */

export function useGetAdminGuestMetrics<TData = Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError = GetAdminGuestMetrics500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminGuestMetrics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminGuestMetricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员编辑帮助中心 FAQ 正文与 QQ 群链接，保存后即时生效（飞书等文档链接写进正文）
 * @summary 更新帮助中心内容
 */
export const putAdminHelpCenter = (
    adminUpdateHelpCenterRequest: AdminUpdateHelpCenterRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/help-center`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateHelpCenterRequest
    },
      );
    }
  


export const getPutAdminHelpCenterMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminHelpCenter>>, TError,{data: AdminUpdateHelpCenterRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminHelpCenter>>, TError,{data: AdminUpdateHelpCenterRequest}, TContext> => {

const mutationKey = ['putAdminHelpCenter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminHelpCenter>>, {data: AdminUpdateHelpCenterRequest}> = (props) => {
          const {data} = props ?? {};

          return  putAdminHelpCenter(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminHelpCenterMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminHelpCenter>>>
    export type PutAdminHelpCenterMutationBody = AdminUpdateHelpCenterRequest
    export type PutAdminHelpCenterMutationError = HandlersResponseData

    /**
 * @summary 更新帮助中心内容
 */
export const usePutAdminHelpCenter = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminHelpCenter>>, TError,{data: AdminUpdateHelpCenterRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminHelpCenter>>,
        TError,
        {data: AdminUpdateHelpCenterRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminHelpCenterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取所有激励配置列表
 * @summary 获取激励配置列表
 */
export const getAdminIncentiveConfigs = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminIncentiveConfigs200>(
      {url: `/admin/incentive-configs`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminIncentiveConfigsQueryKey = () => {
    return [
    `/admin/incentive-configs`
    ] as const;
    }

    
export const getGetAdminIncentiveConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError = GetAdminIncentiveConfigs500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminIncentiveConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>> = ({ signal }) => getAdminIncentiveConfigs(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminIncentiveConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>>
export type GetAdminIncentiveConfigsQueryError = GetAdminIncentiveConfigs500


export function useGetAdminIncentiveConfigs<TData = Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError = GetAdminIncentiveConfigs500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIncentiveConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminIncentiveConfigs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIncentiveConfigs<TData = Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError = GetAdminIncentiveConfigs500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIncentiveConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminIncentiveConfigs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIncentiveConfigs<TData = Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError = GetAdminIncentiveConfigs500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取激励配置列表
 */

export function useGetAdminIncentiveConfigs<TData = Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError = GetAdminIncentiveConfigs500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveConfigs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminIncentiveConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员创建新的激励配置（每种类型唯一）
 * @summary 创建激励配置
 */
export const postAdminIncentiveConfigs = (
    handlersCreateIncentiveConfigRequest: HandlersCreateIncentiveConfigRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminIncentiveConfigs200>(
      {url: `/admin/incentive-configs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersCreateIncentiveConfigRequest, signal
    },
      );
    }
  


export const getPostAdminIncentiveConfigsMutationOptions = <TError = PostAdminIncentiveConfigs400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIncentiveConfigs>>, TError,{data: HandlersCreateIncentiveConfigRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminIncentiveConfigs>>, TError,{data: HandlersCreateIncentiveConfigRequest}, TContext> => {

const mutationKey = ['postAdminIncentiveConfigs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminIncentiveConfigs>>, {data: HandlersCreateIncentiveConfigRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminIncentiveConfigs(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminIncentiveConfigsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminIncentiveConfigs>>>
    export type PostAdminIncentiveConfigsMutationBody = HandlersCreateIncentiveConfigRequest
    export type PostAdminIncentiveConfigsMutationError = PostAdminIncentiveConfigs400

    /**
 * @summary 创建激励配置
 */
export const usePostAdminIncentiveConfigs = <TError = PostAdminIncentiveConfigs400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIncentiveConfigs>>, TError,{data: HandlersCreateIncentiveConfigRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminIncentiveConfigs>>,
        TError,
        {data: HandlersCreateIncentiveConfigRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminIncentiveConfigsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员更新指定激励配置的信息
 * @summary 更新激励配置
 */
export const putAdminIncentiveConfigsId = (
    id: string,
    handlersUpdateIncentiveConfigRequest: HandlersUpdateIncentiveConfigRequest,
 ) => {
      
      
      return origin_point_engine_api<PutAdminIncentiveConfigsId200>(
      {url: `/admin/incentive-configs/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersUpdateIncentiveConfigRequest
    },
      );
    }
  


export const getPutAdminIncentiveConfigsIdMutationOptions = <TError = PutAdminIncentiveConfigsId400 | PutAdminIncentiveConfigsId404 | PutAdminIncentiveConfigsId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminIncentiveConfigsId>>, TError,{id: string;data: HandlersUpdateIncentiveConfigRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminIncentiveConfigsId>>, TError,{id: string;data: HandlersUpdateIncentiveConfigRequest}, TContext> => {

const mutationKey = ['putAdminIncentiveConfigsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminIncentiveConfigsId>>, {id: string;data: HandlersUpdateIncentiveConfigRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminIncentiveConfigsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminIncentiveConfigsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminIncentiveConfigsId>>>
    export type PutAdminIncentiveConfigsIdMutationBody = HandlersUpdateIncentiveConfigRequest
    export type PutAdminIncentiveConfigsIdMutationError = PutAdminIncentiveConfigsId400 | PutAdminIncentiveConfigsId404 | PutAdminIncentiveConfigsId500

    /**
 * @summary 更新激励配置
 */
export const usePutAdminIncentiveConfigsId = <TError = PutAdminIncentiveConfigsId400 | PutAdminIncentiveConfigsId404 | PutAdminIncentiveConfigsId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminIncentiveConfigsId>>, TError,{id: string;data: HandlersUpdateIncentiveConfigRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminIncentiveConfigsId>>,
        TError,
        {id: string;data: HandlersUpdateIncentiveConfigRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminIncentiveConfigsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员删除指定的激励配置
 * @summary 删除激励配置
 */
export const deleteAdminIncentiveConfigsId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<DeleteAdminIncentiveConfigsId200>(
      {url: `/admin/incentive-configs/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminIncentiveConfigsIdMutationOptions = <TError = DeleteAdminIncentiveConfigsId400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminIncentiveConfigsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminIncentiveConfigsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminIncentiveConfigsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminIncentiveConfigsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminIncentiveConfigsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminIncentiveConfigsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminIncentiveConfigsId>>>
    
    export type DeleteAdminIncentiveConfigsIdMutationError = DeleteAdminIncentiveConfigsId400

    /**
 * @summary 删除激励配置
 */
export const useDeleteAdminIncentiveConfigsId = <TError = DeleteAdminIncentiveConfigsId400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminIncentiveConfigsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminIncentiveConfigsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminIncentiveConfigsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取全平台激励记录，支持类型/状态/作者筛选与分页
 * @summary 获取激励记录列表
 */
export const getAdminIncentiveRecords = (
    params?: GetAdminIncentiveRecordsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminIncentiveRecords200>(
      {url: `/admin/incentive-records`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminIncentiveRecordsQueryKey = (params?: GetAdminIncentiveRecordsParams,) => {
    return [
    `/admin/incentive-records`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminIncentiveRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError = GetAdminIncentiveRecords500>(params?: GetAdminIncentiveRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminIncentiveRecordsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminIncentiveRecords>>> = ({ signal }) => getAdminIncentiveRecords(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminIncentiveRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminIncentiveRecords>>>
export type GetAdminIncentiveRecordsQueryError = GetAdminIncentiveRecords500


export function useGetAdminIncentiveRecords<TData = Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError = GetAdminIncentiveRecords500>(
 params: undefined |  GetAdminIncentiveRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIncentiveRecords>>,
          TError,
          Awaited<ReturnType<typeof getAdminIncentiveRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIncentiveRecords<TData = Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError = GetAdminIncentiveRecords500>(
 params?: GetAdminIncentiveRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIncentiveRecords>>,
          TError,
          Awaited<ReturnType<typeof getAdminIncentiveRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIncentiveRecords<TData = Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError = GetAdminIncentiveRecords500>(
 params?: GetAdminIncentiveRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取激励记录列表
 */

export function useGetAdminIncentiveRecords<TData = Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError = GetAdminIncentiveRecords500>(
 params?: GetAdminIncentiveRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveRecords>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminIncentiveRecordsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员处理指定激励记录的发放
 * @summary 处理激励发放
 */
export const postAdminIncentiveRecordsIdProcess = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminIncentiveRecordsIdProcess200>(
      {url: `/admin/incentive-records/${id}/process`, method: 'POST', signal
    },
      );
    }
  


export const getPostAdminIncentiveRecordsIdProcessMutationOptions = <TError = PostAdminIncentiveRecordsIdProcess400 | PostAdminIncentiveRecordsIdProcess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIncentiveRecordsIdProcess>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminIncentiveRecordsIdProcess>>, TError,{id: string}, TContext> => {

const mutationKey = ['postAdminIncentiveRecordsIdProcess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminIncentiveRecordsIdProcess>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postAdminIncentiveRecordsIdProcess(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminIncentiveRecordsIdProcessMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminIncentiveRecordsIdProcess>>>
    
    export type PostAdminIncentiveRecordsIdProcessMutationError = PostAdminIncentiveRecordsIdProcess400 | PostAdminIncentiveRecordsIdProcess500

    /**
 * @summary 处理激励发放
 */
export const usePostAdminIncentiveRecordsIdProcess = <TError = PostAdminIncentiveRecordsIdProcess400 | PostAdminIncentiveRecordsIdProcess500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminIncentiveRecordsIdProcess>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminIncentiveRecordsIdProcess>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostAdminIncentiveRecordsIdProcessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取全平台激励汇总（记录数、各状态计数、已发放元点、配置数）
 * @summary 获取激励汇总统计
 */
export const getAdminIncentiveStats = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminIncentiveStats200>(
      {url: `/admin/incentive-stats`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminIncentiveStatsQueryKey = () => {
    return [
    `/admin/incentive-stats`
    ] as const;
    }

    
export const getGetAdminIncentiveStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError = GetAdminIncentiveStats500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminIncentiveStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminIncentiveStats>>> = ({ signal }) => getAdminIncentiveStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminIncentiveStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminIncentiveStats>>>
export type GetAdminIncentiveStatsQueryError = GetAdminIncentiveStats500


export function useGetAdminIncentiveStats<TData = Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError = GetAdminIncentiveStats500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIncentiveStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminIncentiveStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIncentiveStats<TData = Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError = GetAdminIncentiveStats500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIncentiveStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminIncentiveStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminIncentiveStats<TData = Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError = GetAdminIncentiveStats500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取激励汇总统计
 */

export function useGetAdminIncentiveStats<TData = Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError = GetAdminIncentiveStats500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminIncentiveStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminIncentiveStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员发放元点，支持批量发放，并自动记录发放流水
 * @summary 发放元点
 */
export const postAdminPointsDistribute = (
    adminDistributePointsRequest: AdminDistributePointsRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<AdminDistributePointsResult>(
      {url: `/admin/points/distribute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminDistributePointsRequest, signal
    },
      );
    }
  


export const getPostAdminPointsDistributeMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPointsDistribute>>, TError,{data: AdminDistributePointsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminPointsDistribute>>, TError,{data: AdminDistributePointsRequest}, TContext> => {

const mutationKey = ['postAdminPointsDistribute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminPointsDistribute>>, {data: AdminDistributePointsRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminPointsDistribute(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminPointsDistributeMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminPointsDistribute>>>
    export type PostAdminPointsDistributeMutationBody = AdminDistributePointsRequest
    export type PostAdminPointsDistributeMutationError = HandlersResponseData

    /**
 * @summary 发放元点
 */
export const usePostAdminPointsDistribute = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPointsDistribute>>, TError,{data: AdminDistributePointsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminPointsDistribute>>,
        TError,
        {data: AdminDistributePointsRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminPointsDistributeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取系统配置列表，支持分类、搜索和分页
 * @summary 获取系统配置列表
 */
export const getAdminPriceConfigs = (
    params?: GetAdminPriceConfigsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminPriceConfigs200>(
      {url: `/admin/price-configs`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminPriceConfigsQueryKey = (params?: GetAdminPriceConfigsParams,) => {
    return [
    `/admin/price-configs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminPriceConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError = HandlersResponseData>(params?: GetAdminPriceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPriceConfigsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPriceConfigs>>> = ({ signal }) => getAdminPriceConfigs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPriceConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPriceConfigs>>>
export type GetAdminPriceConfigsQueryError = HandlersResponseData


export function useGetAdminPriceConfigs<TData = Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminPriceConfigsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPriceConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminPriceConfigs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPriceConfigs<TData = Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError = HandlersResponseData>(
 params?: GetAdminPriceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPriceConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAdminPriceConfigs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPriceConfigs<TData = Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError = HandlersResponseData>(
 params?: GetAdminPriceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取系统配置列表
 */

export function useGetAdminPriceConfigs<TData = Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError = HandlersResponseData>(
 params?: GetAdminPriceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigs>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPriceConfigsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员创建一个新的系统配置项
 * @summary 创建系统配置
 */
export const postAdminPriceConfigs = (
    adminCreateSystemConfigRequest: AdminCreateSystemConfigRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminPriceConfigs200>(
      {url: `/admin/price-configs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCreateSystemConfigRequest, signal
    },
      );
    }
  


export const getPostAdminPriceConfigsMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPriceConfigs>>, TError,{data: AdminCreateSystemConfigRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminPriceConfigs>>, TError,{data: AdminCreateSystemConfigRequest}, TContext> => {

const mutationKey = ['postAdminPriceConfigs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminPriceConfigs>>, {data: AdminCreateSystemConfigRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminPriceConfigs(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminPriceConfigsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminPriceConfigs>>>
    export type PostAdminPriceConfigsMutationBody = AdminCreateSystemConfigRequest
    export type PostAdminPriceConfigsMutationError = HandlersResponseData

    /**
 * @summary 创建系统配置
 */
export const usePostAdminPriceConfigs = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPriceConfigs>>, TError,{data: AdminCreateSystemConfigRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminPriceConfigs>>,
        TError,
        {data: AdminCreateSystemConfigRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminPriceConfigsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取所有系统配置的分类列表
 * @summary 获取系统配置分类
 */
export const getAdminPriceConfigsCategories = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminPriceConfigsCategories200>(
      {url: `/admin/price-configs/categories`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminPriceConfigsCategoriesQueryKey = () => {
    return [
    `/admin/price-configs/categories`
    ] as const;
    }

    
export const getGetAdminPriceConfigsCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPriceConfigsCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>> = ({ signal }) => getAdminPriceConfigsCategories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPriceConfigsCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>>
export type GetAdminPriceConfigsCategoriesQueryError = HandlersResponseData


export function useGetAdminPriceConfigsCategories<TData = Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>,
          TError,
          Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPriceConfigsCategories<TData = Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>,
          TError,
          Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPriceConfigsCategories<TData = Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取系统配置分类
 */

export function useGetAdminPriceConfigsCategories<TData = Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsCategories>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPriceConfigsCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员通过 ID 获取系统配置详细信息
 * @summary 获取系统配置详情
 */
export const getAdminPriceConfigsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminPriceConfigsId200>(
      {url: `/admin/price-configs/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminPriceConfigsIdQueryKey = (id?: string,) => {
    return [
    `/admin/price-configs/${id}`
    ] as const;
    }

    
export const getGetAdminPriceConfigsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError = HandlersResponseData>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPriceConfigsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPriceConfigsId>>> = ({ signal }) => getAdminPriceConfigsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPriceConfigsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPriceConfigsId>>>
export type GetAdminPriceConfigsIdQueryError = HandlersResponseData


export function useGetAdminPriceConfigsId<TData = Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError = HandlersResponseData>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPriceConfigsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminPriceConfigsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPriceConfigsId<TData = Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPriceConfigsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminPriceConfigsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPriceConfigsId<TData = Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取系统配置详情
 */

export function useGetAdminPriceConfigsId<TData = Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPriceConfigsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPriceConfigsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员更新现有的系统配置项
 * @summary 更新系统配置
 */
export const putAdminPriceConfigsId = (
    id: string,
    adminUpdateSystemConfigRequest: AdminUpdateSystemConfigRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/price-configs/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateSystemConfigRequest
    },
      );
    }
  


export const getPutAdminPriceConfigsIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPriceConfigsId>>, TError,{id: string;data: AdminUpdateSystemConfigRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminPriceConfigsId>>, TError,{id: string;data: AdminUpdateSystemConfigRequest}, TContext> => {

const mutationKey = ['putAdminPriceConfigsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminPriceConfigsId>>, {id: string;data: AdminUpdateSystemConfigRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminPriceConfigsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminPriceConfigsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminPriceConfigsId>>>
    export type PutAdminPriceConfigsIdMutationBody = AdminUpdateSystemConfigRequest
    export type PutAdminPriceConfigsIdMutationError = HandlersResponseData

    /**
 * @summary 更新系统配置
 */
export const usePutAdminPriceConfigsId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPriceConfigsId>>, TError,{id: string;data: AdminUpdateSystemConfigRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminPriceConfigsId>>,
        TError,
        {id: string;data: AdminUpdateSystemConfigRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminPriceConfigsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员删除指定的系统配置项
 * @summary 删除系统配置
 */
export const deleteAdminPriceConfigsId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/price-configs/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminPriceConfigsIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPriceConfigsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPriceConfigsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminPriceConfigsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminPriceConfigsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminPriceConfigsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminPriceConfigsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminPriceConfigsId>>>
    
    export type DeleteAdminPriceConfigsIdMutationError = HandlersResponseData

    /**
 * @summary 删除系统配置
 */
export const useDeleteAdminPriceConfigsId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPriceConfigsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminPriceConfigsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminPriceConfigsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理端获取提示词条目列表，支持按标签筛选
 * @summary 获取提示词列表
 */
export const getAdminPromptItems = (
    params?: GetAdminPromptItemsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminPromptItems200>(
      {url: `/admin/prompt-items`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminPromptItemsQueryKey = (params?: GetAdminPromptItemsParams,) => {
    return [
    `/admin/prompt-items`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminPromptItemsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPromptItems>>, TError = GetAdminPromptItems500>(params?: GetAdminPromptItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPromptItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPromptItems>>> = ({ signal }) => getAdminPromptItems(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPromptItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPromptItems>>>
export type GetAdminPromptItemsQueryError = GetAdminPromptItems500


export function useGetAdminPromptItems<TData = Awaited<ReturnType<typeof getAdminPromptItems>>, TError = GetAdminPromptItems500>(
 params: undefined |  GetAdminPromptItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptItems>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptItems>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptItems<TData = Awaited<ReturnType<typeof getAdminPromptItems>>, TError = GetAdminPromptItems500>(
 params?: GetAdminPromptItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptItems>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptItems>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptItems<TData = Awaited<ReturnType<typeof getAdminPromptItems>>, TError = GetAdminPromptItems500>(
 params?: GetAdminPromptItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItems>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取提示词列表
 */

export function useGetAdminPromptItems<TData = Awaited<ReturnType<typeof getAdminPromptItems>>, TError = GetAdminPromptItems500>(
 params?: GetAdminPromptItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItems>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPromptItemsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 创建一个新的提示词条目
 * @summary 创建提示词
 */
export const postAdminPromptItems = (
    adminCreatePromptItemRequest: AdminCreatePromptItemRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<ModelsPromptItem>(
      {url: `/admin/prompt-items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCreatePromptItemRequest, signal
    },
      );
    }
  


export const getPostAdminPromptItemsMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPromptItems>>, TError,{data: AdminCreatePromptItemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminPromptItems>>, TError,{data: AdminCreatePromptItemRequest}, TContext> => {

const mutationKey = ['postAdminPromptItems'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminPromptItems>>, {data: AdminCreatePromptItemRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminPromptItems(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminPromptItemsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminPromptItems>>>
    export type PostAdminPromptItemsMutationBody = AdminCreatePromptItemRequest
    export type PostAdminPromptItemsMutationError = HandlersResponseData

    /**
 * @summary 创建提示词
 */
export const usePostAdminPromptItems = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPromptItems>>, TError,{data: AdminCreatePromptItemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminPromptItems>>,
        TError,
        {data: AdminCreatePromptItemRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminPromptItemsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 根据ID获取单个提示词条目
 * @summary 获取提示词详情
 */
export const getAdminPromptItemsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<ModelsPromptItem>(
      {url: `/admin/prompt-items/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminPromptItemsIdQueryKey = (id?: string,) => {
    return [
    `/admin/prompt-items/${id}`
    ] as const;
    }

    
export const getGetAdminPromptItemsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError = HandlersResponseData>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPromptItemsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPromptItemsId>>> = ({ signal }) => getAdminPromptItemsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPromptItemsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPromptItemsId>>>
export type GetAdminPromptItemsIdQueryError = HandlersResponseData


export function useGetAdminPromptItemsId<TData = Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError = HandlersResponseData>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptItemsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptItemsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptItemsId<TData = Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptItemsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptItemsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptItemsId<TData = Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取提示词详情
 */

export function useGetAdminPromptItemsId<TData = Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptItemsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPromptItemsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 更新现有的提示词条目
 * @summary 更新提示词
 */
export const putAdminPromptItemsId = (
    id: string,
    adminUpdatePromptItemRequest: AdminUpdatePromptItemRequest,
 ) => {
      
      
      return origin_point_engine_api<ModelsPromptItem>(
      {url: `/admin/prompt-items/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdatePromptItemRequest
    },
      );
    }
  


export const getPutAdminPromptItemsIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPromptItemsId>>, TError,{id: string;data: AdminUpdatePromptItemRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminPromptItemsId>>, TError,{id: string;data: AdminUpdatePromptItemRequest}, TContext> => {

const mutationKey = ['putAdminPromptItemsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminPromptItemsId>>, {id: string;data: AdminUpdatePromptItemRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminPromptItemsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminPromptItemsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminPromptItemsId>>>
    export type PutAdminPromptItemsIdMutationBody = AdminUpdatePromptItemRequest
    export type PutAdminPromptItemsIdMutationError = HandlersResponseData

    /**
 * @summary 更新提示词
 */
export const usePutAdminPromptItemsId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPromptItemsId>>, TError,{id: string;data: AdminUpdatePromptItemRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminPromptItemsId>>,
        TError,
        {id: string;data: AdminUpdatePromptItemRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminPromptItemsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 物理删除指定的提示词条目
 * @summary 删除提示词
 */
export const deleteAdminPromptItemsId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/prompt-items/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminPromptItemsIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPromptItemsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPromptItemsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminPromptItemsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminPromptItemsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminPromptItemsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminPromptItemsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminPromptItemsId>>>
    
    export type DeleteAdminPromptItemsIdMutationError = HandlersResponseData

    /**
 * @summary 删除提示词
 */
export const useDeleteAdminPromptItemsId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPromptItemsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminPromptItemsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminPromptItemsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取所有预设模板，包含完整信息
 * @summary 获取预设模板列表（管理端）
 */
export const getAdminPromptPresets = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminPromptPresets200>(
      {url: `/admin/prompt-presets`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminPromptPresetsQueryKey = () => {
    return [
    `/admin/prompt-presets`
    ] as const;
    }

    
export const getGetAdminPromptPresetsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPromptPresets>>, TError = GetAdminPromptPresets500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPromptPresetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPromptPresets>>> = ({ signal }) => getAdminPromptPresets(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPromptPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPromptPresets>>>
export type GetAdminPromptPresetsQueryError = GetAdminPromptPresets500


export function useGetAdminPromptPresets<TData = Awaited<ReturnType<typeof getAdminPromptPresets>>, TError = GetAdminPromptPresets500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptPresets>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptPresets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptPresets<TData = Awaited<ReturnType<typeof getAdminPromptPresets>>, TError = GetAdminPromptPresets500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptPresets>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptPresets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptPresets<TData = Awaited<ReturnType<typeof getAdminPromptPresets>>, TError = GetAdminPromptPresets500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取预设模板列表（管理端）
 */

export function useGetAdminPromptPresets<TData = Awaited<ReturnType<typeof getAdminPromptPresets>>, TError = GetAdminPromptPresets500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresets>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPromptPresetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 创建一个新的预设模板
 * @summary 创建预设模板（管理端）
 */
export const postAdminPromptPresets = (
    handlersCreatePromptPresetRequest: HandlersCreatePromptPresetRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<ModelsPresetTemplate>(
      {url: `/admin/prompt-presets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersCreatePromptPresetRequest, signal
    },
      );
    }
  


export const getPostAdminPromptPresetsMutationOptions = <TError = PostAdminPromptPresets400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPromptPresets>>, TError,{data: HandlersCreatePromptPresetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminPromptPresets>>, TError,{data: HandlersCreatePromptPresetRequest}, TContext> => {

const mutationKey = ['postAdminPromptPresets'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminPromptPresets>>, {data: HandlersCreatePromptPresetRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminPromptPresets(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminPromptPresetsMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminPromptPresets>>>
    export type PostAdminPromptPresetsMutationBody = HandlersCreatePromptPresetRequest
    export type PostAdminPromptPresetsMutationError = PostAdminPromptPresets400

    /**
 * @summary 创建预设模板（管理端）
 */
export const usePostAdminPromptPresets = <TError = PostAdminPromptPresets400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminPromptPresets>>, TError,{data: HandlersCreatePromptPresetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminPromptPresets>>,
        TError,
        {data: HandlersCreatePromptPresetRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminPromptPresetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取单个预设模板，包含关联的提示词列表
 * @summary 获取预设模板详情（管理端）
 */
export const getAdminPromptPresetsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminPromptPresetsId200>(
      {url: `/admin/prompt-presets/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminPromptPresetsIdQueryKey = (id?: string,) => {
    return [
    `/admin/prompt-presets/${id}`
    ] as const;
    }

    
export const getGetAdminPromptPresetsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError = GetAdminPromptPresetsId400 | GetAdminPromptPresetsId404>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPromptPresetsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPromptPresetsId>>> = ({ signal }) => getAdminPromptPresetsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPromptPresetsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPromptPresetsId>>>
export type GetAdminPromptPresetsIdQueryError = GetAdminPromptPresetsId400 | GetAdminPromptPresetsId404


export function useGetAdminPromptPresetsId<TData = Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError = GetAdminPromptPresetsId400 | GetAdminPromptPresetsId404>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptPresetsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptPresetsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptPresetsId<TData = Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError = GetAdminPromptPresetsId400 | GetAdminPromptPresetsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPromptPresetsId>>,
          TError,
          Awaited<ReturnType<typeof getAdminPromptPresetsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPromptPresetsId<TData = Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError = GetAdminPromptPresetsId400 | GetAdminPromptPresetsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取预设模板详情（管理端）
 */

export function useGetAdminPromptPresetsId<TData = Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError = GetAdminPromptPresetsId400 | GetAdminPromptPresetsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPromptPresetsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPromptPresetsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 更新现有的预设模板
 * @summary 更新预设模板（管理端）
 */
export const putAdminPromptPresetsId = (
    id: string,
    handlersUpdatePromptPresetRequest: HandlersUpdatePromptPresetRequest,
 ) => {
      
      
      return origin_point_engine_api<ModelsPresetTemplate>(
      {url: `/admin/prompt-presets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersUpdatePromptPresetRequest
    },
      );
    }
  


export const getPutAdminPromptPresetsIdMutationOptions = <TError = PutAdminPromptPresetsId400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPromptPresetsId>>, TError,{id: string;data: HandlersUpdatePromptPresetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminPromptPresetsId>>, TError,{id: string;data: HandlersUpdatePromptPresetRequest}, TContext> => {

const mutationKey = ['putAdminPromptPresetsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminPromptPresetsId>>, {id: string;data: HandlersUpdatePromptPresetRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminPromptPresetsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminPromptPresetsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminPromptPresetsId>>>
    export type PutAdminPromptPresetsIdMutationBody = HandlersUpdatePromptPresetRequest
    export type PutAdminPromptPresetsIdMutationError = PutAdminPromptPresetsId400

    /**
 * @summary 更新预设模板（管理端）
 */
export const usePutAdminPromptPresetsId = <TError = PutAdminPromptPresetsId400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminPromptPresetsId>>, TError,{id: string;data: HandlersUpdatePromptPresetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminPromptPresetsId>>,
        TError,
        {id: string;data: HandlersUpdatePromptPresetRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminPromptPresetsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 物理删除指定的预设模板
 * @summary 删除预设模板（管理端）
 */
export const deleteAdminPromptPresetsId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<DeleteAdminPromptPresetsId200>(
      {url: `/admin/prompt-presets/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminPromptPresetsIdMutationOptions = <TError = DeleteAdminPromptPresetsId400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPromptPresetsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPromptPresetsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminPromptPresetsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminPromptPresetsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminPromptPresetsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminPromptPresetsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminPromptPresetsId>>>
    
    export type DeleteAdminPromptPresetsIdMutationError = DeleteAdminPromptPresetsId400

    /**
 * @summary 删除预设模板（管理端）
 */
export const useDeleteAdminPromptPresetsId = <TError = DeleteAdminPromptPresetsId400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminPromptPresetsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminPromptPresetsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminPromptPresetsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员分页获取所有充值订单，支持搜索和状态、支付方式、支付类型筛选
 * @summary 获取充值订单列表
 */
export const getAdminRechargeOrders = (
    params?: GetAdminRechargeOrdersParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminRechargeOrders200>(
      {url: `/admin/recharge-orders`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminRechargeOrdersQueryKey = (params?: GetAdminRechargeOrdersParams,) => {
    return [
    `/admin/recharge-orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminRechargeOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError = HandlersResponseData>(params?: GetAdminRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRechargeOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRechargeOrders>>> = ({ signal }) => getAdminRechargeOrders(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminRechargeOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRechargeOrders>>>
export type GetAdminRechargeOrdersQueryError = HandlersResponseData


export function useGetAdminRechargeOrders<TData = Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminRechargeOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRechargeOrders>>,
          TError,
          Awaited<ReturnType<typeof getAdminRechargeOrders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRechargeOrders<TData = Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError = HandlersResponseData>(
 params?: GetAdminRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRechargeOrders>>,
          TError,
          Awaited<ReturnType<typeof getAdminRechargeOrders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRechargeOrders<TData = Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError = HandlersResponseData>(
 params?: GetAdminRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取充值订单列表
 */

export function useGetAdminRechargeOrders<TData = Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError = HandlersResponseData>(
 params?: GetAdminRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminRechargeOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员获取充值订单的详细信息，包括对应的用户信息和交易记录
 * @summary 获取充值订单详情
 */
export const getAdminRechargeOrdersId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminRechargeOrdersId200>(
      {url: `/admin/recharge-orders/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminRechargeOrdersIdQueryKey = (id?: string,) => {
    return [
    `/admin/recharge-orders/${id}`
    ] as const;
    }

    
export const getGetAdminRechargeOrdersIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError = HandlersResponseData>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRechargeOrdersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>> = ({ signal }) => getAdminRechargeOrdersId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminRechargeOrdersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>>
export type GetAdminRechargeOrdersIdQueryError = HandlersResponseData


export function useGetAdminRechargeOrdersId<TData = Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError = HandlersResponseData>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRechargeOrdersId>>,
          TError,
          Awaited<ReturnType<typeof getAdminRechargeOrdersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRechargeOrdersId<TData = Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRechargeOrdersId>>,
          TError,
          Awaited<ReturnType<typeof getAdminRechargeOrdersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRechargeOrdersId<TData = Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取充值订单详情
 */

export function useGetAdminRechargeOrdersId<TData = Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRechargeOrdersId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminRechargeOrdersIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员对已支付的充值订单进行退款处理
 * @summary 充值订单退款
 */
export const postAdminRechargeOrdersIdRefund = (
    id: string,
    adminRefundRechargeOrderRequest: AdminRefundRechargeOrderRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminRechargeOrdersIdRefund200>(
      {url: `/admin/recharge-orders/${id}/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminRefundRechargeOrderRequest, signal
    },
      );
    }
  


export const getPostAdminRechargeOrdersIdRefundMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRechargeOrdersIdRefund>>, TError,{id: string;data: AdminRefundRechargeOrderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminRechargeOrdersIdRefund>>, TError,{id: string;data: AdminRefundRechargeOrderRequest}, TContext> => {

const mutationKey = ['postAdminRechargeOrdersIdRefund'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminRechargeOrdersIdRefund>>, {id: string;data: AdminRefundRechargeOrderRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postAdminRechargeOrdersIdRefund(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminRechargeOrdersIdRefundMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminRechargeOrdersIdRefund>>>
    export type PostAdminRechargeOrdersIdRefundMutationBody = AdminRefundRechargeOrderRequest
    export type PostAdminRechargeOrdersIdRefundMutationError = HandlersResponseData

    /**
 * @summary 充值订单退款
 */
export const usePostAdminRechargeOrdersIdRefund = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminRechargeOrdersIdRefund>>, TError,{id: string;data: AdminRefundRechargeOrderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminRechargeOrdersIdRefund>>,
        TError,
        {id: string;data: AdminRefundRechargeOrderRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminRechargeOrdersIdRefundMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员手动更新充值订单状态，如设为已支付
 * @summary 更新充值订单状态
 */
export const putAdminRechargeOrdersIdStatus = (
    id: string,
    adminUpdateRechargeOrderStatusRequest: AdminUpdateRechargeOrderStatusRequest,
 ) => {
      
      
      return origin_point_engine_api<PutAdminRechargeOrdersIdStatus200>(
      {url: `/admin/recharge-orders/${id}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateRechargeOrderStatusRequest
    },
      );
    }
  


export const getPutAdminRechargeOrdersIdStatusMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminRechargeOrdersIdStatus>>, TError,{id: string;data: AdminUpdateRechargeOrderStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminRechargeOrdersIdStatus>>, TError,{id: string;data: AdminUpdateRechargeOrderStatusRequest}, TContext> => {

const mutationKey = ['putAdminRechargeOrdersIdStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminRechargeOrdersIdStatus>>, {id: string;data: AdminUpdateRechargeOrderStatusRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminRechargeOrdersIdStatus(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminRechargeOrdersIdStatusMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminRechargeOrdersIdStatus>>>
    export type PutAdminRechargeOrdersIdStatusMutationBody = AdminUpdateRechargeOrderStatusRequest
    export type PutAdminRechargeOrdersIdStatusMutationError = HandlersResponseData

    /**
 * @summary 更新充值订单状态
 */
export const usePutAdminRechargeOrdersIdStatus = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminRechargeOrdersIdStatus>>, TError,{id: string;data: AdminUpdateRechargeOrderStatusRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminRechargeOrdersIdStatus>>,
        TError,
        {id: string;data: AdminUpdateRechargeOrderStatusRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminRechargeOrdersIdStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取消费记录列表，支持分页和多维度筛选
 * @summary 获取消费记录
 */
export const getAdminSettlementConsumptionRecords = (
    params?: GetAdminSettlementConsumptionRecordsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminSettlementConsumptionRecords200>(
      {url: `/admin/settlement/consumption-records`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminSettlementConsumptionRecordsQueryKey = (params?: GetAdminSettlementConsumptionRecordsParams,) => {
    return [
    `/admin/settlement/consumption-records`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminSettlementConsumptionRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError = HandlersResponseData>(params?: GetAdminSettlementConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSettlementConsumptionRecordsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>> = ({ signal }) => getAdminSettlementConsumptionRecords(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSettlementConsumptionRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>>
export type GetAdminSettlementConsumptionRecordsQueryError = HandlersResponseData


export function useGetAdminSettlementConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminSettlementConsumptionRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>,
          TError,
          Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSettlementConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError = HandlersResponseData>(
 params?: GetAdminSettlementConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>,
          TError,
          Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSettlementConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError = HandlersResponseData>(
 params?: GetAdminSettlementConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取消费记录
 */

export function useGetAdminSettlementConsumptionRecords<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError = HandlersResponseData>(
 params?: GetAdminSettlementConsumptionRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionRecords>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSettlementConsumptionRecordsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员获取消费统计数据
 * @summary 获取消费统计
 */
export const getAdminSettlementConsumptionStats = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/settlement/consumption-stats`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminSettlementConsumptionStatsQueryKey = () => {
    return [
    `/admin/settlement/consumption-stats`
    ] as const;
    }

    
export const getGetAdminSettlementConsumptionStatsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSettlementConsumptionStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>> = ({ signal }) => getAdminSettlementConsumptionStats(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSettlementConsumptionStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>>
export type GetAdminSettlementConsumptionStatsQueryError = unknown


export function useGetAdminSettlementConsumptionStats<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSettlementConsumptionStats<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>,
          TError,
          Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSettlementConsumptionStats<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取消费统计
 */

export function useGetAdminSettlementConsumptionStats<TData = Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSettlementConsumptionStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSettlementConsumptionStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员获取系统预设引擎列表，支持类型、状态、搜索筛选和分页排序
 * @summary 获取系统引擎列表
 */
export const getAdminSystemEngines = (
    params?: GetAdminSystemEnginesParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminSystemEngines200>(
      {url: `/admin/system-engines`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminSystemEnginesQueryKey = (params?: GetAdminSystemEnginesParams,) => {
    return [
    `/admin/system-engines`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminSystemEnginesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSystemEngines>>, TError = HandlersResponseData>(params?: GetAdminSystemEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSystemEngines>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSystemEnginesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSystemEngines>>> = ({ signal }) => getAdminSystemEngines(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSystemEngines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminSystemEnginesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSystemEngines>>>
export type GetAdminSystemEnginesQueryError = HandlersResponseData


export function useGetAdminSystemEngines<TData = Awaited<ReturnType<typeof getAdminSystemEngines>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminSystemEnginesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSystemEngines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSystemEngines>>,
          TError,
          Awaited<ReturnType<typeof getAdminSystemEngines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSystemEngines<TData = Awaited<ReturnType<typeof getAdminSystemEngines>>, TError = HandlersResponseData>(
 params?: GetAdminSystemEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSystemEngines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminSystemEngines>>,
          TError,
          Awaited<ReturnType<typeof getAdminSystemEngines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminSystemEngines<TData = Awaited<ReturnType<typeof getAdminSystemEngines>>, TError = HandlersResponseData>(
 params?: GetAdminSystemEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSystemEngines>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取系统引擎列表
 */

export function useGetAdminSystemEngines<TData = Awaited<ReturnType<typeof getAdminSystemEngines>>, TError = HandlersResponseData>(
 params?: GetAdminSystemEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminSystemEngines>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminSystemEnginesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员创建一个新的系统预设引擎
 * @summary 创建系统引擎
 */
export const postAdminSystemEngines = (
    adminCreateSystemEngineRequest: AdminCreateSystemEngineRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminSystemEngines200>(
      {url: `/admin/system-engines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCreateSystemEngineRequest, signal
    },
      );
    }
  


export const getPostAdminSystemEnginesMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSystemEngines>>, TError,{data: AdminCreateSystemEngineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminSystemEngines>>, TError,{data: AdminCreateSystemEngineRequest}, TContext> => {

const mutationKey = ['postAdminSystemEngines'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminSystemEngines>>, {data: AdminCreateSystemEngineRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminSystemEngines(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminSystemEnginesMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminSystemEngines>>>
    export type PostAdminSystemEnginesMutationBody = AdminCreateSystemEngineRequest
    export type PostAdminSystemEnginesMutationError = HandlersResponseData

    /**
 * @summary 创建系统引擎
 */
export const usePostAdminSystemEngines = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminSystemEngines>>, TError,{data: AdminCreateSystemEngineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminSystemEngines>>,
        TError,
        {data: AdminCreateSystemEngineRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminSystemEnginesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员物理删除指定的系统预设引擎
 * @summary 删除系统引擎
 */
export const deleteAdminSystemEnginesId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/system-engines/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminSystemEnginesIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminSystemEnginesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminSystemEnginesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminSystemEnginesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminSystemEnginesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminSystemEnginesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminSystemEnginesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminSystemEnginesId>>>
    
    export type DeleteAdminSystemEnginesIdMutationError = HandlersResponseData

    /**
 * @summary 删除系统引擎
 */
export const useDeleteAdminSystemEnginesId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminSystemEnginesId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminSystemEnginesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminSystemEnginesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员更新系统引擎的当前运行状态
 * @summary 更新系统引擎状态
 */
export const putAdminSystemEnginesIdStatus = (
    id: string,
    adminUpdateSystemEngineStatusRequest: AdminUpdateSystemEngineStatusRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/system-engines/${id}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateSystemEngineStatusRequest
    },
      );
    }
  


export const getPutAdminSystemEnginesIdStatusMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminSystemEnginesIdStatus>>, TError,{id: string;data: AdminUpdateSystemEngineStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminSystemEnginesIdStatus>>, TError,{id: string;data: AdminUpdateSystemEngineStatusRequest}, TContext> => {

const mutationKey = ['putAdminSystemEnginesIdStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminSystemEnginesIdStatus>>, {id: string;data: AdminUpdateSystemEngineStatusRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminSystemEnginesIdStatus(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminSystemEnginesIdStatusMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminSystemEnginesIdStatus>>>
    export type PutAdminSystemEnginesIdStatusMutationBody = AdminUpdateSystemEngineStatusRequest
    export type PutAdminSystemEnginesIdStatusMutationError = HandlersResponseData

    /**
 * @summary 更新系统引擎状态
 */
export const usePutAdminSystemEnginesIdStatus = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminSystemEnginesIdStatus>>, TError,{id: string;data: AdminUpdateSystemEngineStatusRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminSystemEnginesIdStatus>>,
        TError,
        {id: string;data: AdminUpdateSystemEngineStatusRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminSystemEnginesIdStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员分页获取内容模板列表，支持类型和激活状态筛选
 * @summary 获取模板列表
 */
export const getAdminTemplates = (
    params?: GetAdminTemplatesParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminTemplates200>(
      {url: `/admin/templates`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminTemplatesQueryKey = (params?: GetAdminTemplatesParams,) => {
    return [
    `/admin/templates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTemplates>>, TError = HandlersResponseData>(params?: GetAdminTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTemplatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTemplates>>> = ({ signal }) => getAdminTemplates(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTemplates>>>
export type GetAdminTemplatesQueryError = HandlersResponseData


export function useGetAdminTemplates<TData = Awaited<ReturnType<typeof getAdminTemplates>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAdminTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTemplates<TData = Awaited<ReturnType<typeof getAdminTemplates>>, TError = HandlersResponseData>(
 params?: GetAdminTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAdminTemplates>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTemplates<TData = Awaited<ReturnType<typeof getAdminTemplates>>, TError = HandlersResponseData>(
 params?: GetAdminTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取模板列表
 */

export function useGetAdminTemplates<TData = Awaited<ReturnType<typeof getAdminTemplates>>, TError = HandlersResponseData>(
 params?: GetAdminTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplates>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员创建新的内容模板
 * @summary 创建模板
 */
export const postAdminTemplates = (
    adminCreateTemplateRequest: AdminCreateTemplateRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<ModelsTemplate>(
      {url: `/admin/templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminCreateTemplateRequest, signal
    },
      );
    }
  


export const getPostAdminTemplatesMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminTemplates>>, TError,{data: AdminCreateTemplateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminTemplates>>, TError,{data: AdminCreateTemplateRequest}, TContext> => {

const mutationKey = ['postAdminTemplates'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminTemplates>>, {data: AdminCreateTemplateRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminTemplates(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminTemplates>>>
    export type PostAdminTemplatesMutationBody = AdminCreateTemplateRequest
    export type PostAdminTemplatesMutationError = HandlersResponseData

    /**
 * @summary 创建模板
 */
export const usePostAdminTemplates = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminTemplates>>, TError,{data: AdminCreateTemplateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminTemplates>>,
        TError,
        {data: AdminCreateTemplateRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminTemplatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员通过 ID 获取模板详细信息
 * @summary 获取模板详情
 */
export const getAdminTemplatesId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<ModelsTemplate>(
      {url: `/admin/templates/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminTemplatesIdQueryKey = (id?: string,) => {
    return [
    `/admin/templates/${id}`
    ] as const;
    }

    
export const getGetAdminTemplatesIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminTemplatesId>>, TError = HandlersResponseData>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplatesId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminTemplatesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminTemplatesId>>> = ({ signal }) => getAdminTemplatesId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplatesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminTemplatesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminTemplatesId>>>
export type GetAdminTemplatesIdQueryError = HandlersResponseData


export function useGetAdminTemplatesId<TData = Awaited<ReturnType<typeof getAdminTemplatesId>>, TError = HandlersResponseData>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplatesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTemplatesId>>,
          TError,
          Awaited<ReturnType<typeof getAdminTemplatesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTemplatesId<TData = Awaited<ReturnType<typeof getAdminTemplatesId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplatesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminTemplatesId>>,
          TError,
          Awaited<ReturnType<typeof getAdminTemplatesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminTemplatesId<TData = Awaited<ReturnType<typeof getAdminTemplatesId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplatesId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取模板详情
 */

export function useGetAdminTemplatesId<TData = Awaited<ReturnType<typeof getAdminTemplatesId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminTemplatesId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminTemplatesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员更新现有模板的信息
 * @summary 更新模板
 */
export const putAdminTemplatesId = (
    id: string,
    adminUpdateTemplateRequest: AdminUpdateTemplateRequest,
 ) => {
      
      
      return origin_point_engine_api<ModelsTemplate>(
      {url: `/admin/templates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateTemplateRequest
    },
      );
    }
  


export const getPutAdminTemplatesIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTemplatesId>>, TError,{id: string;data: AdminUpdateTemplateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminTemplatesId>>, TError,{id: string;data: AdminUpdateTemplateRequest}, TContext> => {

const mutationKey = ['putAdminTemplatesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminTemplatesId>>, {id: string;data: AdminUpdateTemplateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminTemplatesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminTemplatesId>>>
    export type PutAdminTemplatesIdMutationBody = AdminUpdateTemplateRequest
    export type PutAdminTemplatesIdMutationError = HandlersResponseData

    /**
 * @summary 更新模板
 */
export const usePutAdminTemplatesId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminTemplatesId>>, TError,{id: string;data: AdminUpdateTemplateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminTemplatesId>>,
        TError,
        {id: string;data: AdminUpdateTemplateRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminTemplatesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员物理删除指定的模板
 * @summary 删除模板
 */
export const deleteAdminTemplatesId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/templates/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminTemplatesIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminTemplatesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminTemplatesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminTemplatesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminTemplatesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminTemplatesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminTemplatesId>>>
    
    export type DeleteAdminTemplatesIdMutationError = HandlersResponseData

    /**
 * @summary 删除模板
 */
export const useDeleteAdminTemplatesId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminTemplatesId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminTemplatesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminTemplatesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员获取所有用户列表，支持分页、角色/状态筛选和搜索
 * @summary 获取用户列表
 */
export const getAdminUsers = (
    params?: GetAdminUsersParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminUsers200>(
      {url: `/admin/users`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminUsersQueryKey = (params?: GetAdminUsersParams,) => {
    return [
    `/admin/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = HandlersResponseData>(params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsers>>> = ({ signal }) => getAdminUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsers>>>
export type GetAdminUsersQueryError = HandlersResponseData


export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = HandlersResponseData>(
 params: undefined |  GetAdminUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = HandlersResponseData>(
 params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = HandlersResponseData>(
 params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取用户列表
 */

export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = HandlersResponseData>(
 params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员批量软删除用户，逐个执行并返回每个用户的成功/失败结果
 * @summary 批量删除用户
 */
export const postAdminUsersBatchDelete = (
    handlerBatchDeleteUsersRequest: HandlerBatchDeleteUsersRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAdminUsersBatchDelete200>(
      {url: `/admin/users/batch-delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlerBatchDeleteUsersRequest, signal
    },
      );
    }
  


export const getPostAdminUsersBatchDeleteMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersBatchDelete>>, TError,{data: HandlerBatchDeleteUsersRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersBatchDelete>>, TError,{data: HandlerBatchDeleteUsersRequest}, TContext> => {

const mutationKey = ['postAdminUsersBatchDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminUsersBatchDelete>>, {data: HandlerBatchDeleteUsersRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminUsersBatchDelete(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminUsersBatchDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminUsersBatchDelete>>>
    export type PostAdminUsersBatchDeleteMutationBody = HandlerBatchDeleteUsersRequest
    export type PostAdminUsersBatchDeleteMutationError = HandlersResponseData

    /**
 * @summary 批量删除用户
 */
export const usePostAdminUsersBatchDelete = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersBatchDelete>>, TError,{data: HandlerBatchDeleteUsersRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminUsersBatchDelete>>,
        TError,
        {data: HandlerBatchDeleteUsersRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminUsersBatchDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员批量更新用户状态（active/banned/pending），逐个执行并返回结果
 * @summary 批量更新用户状态
 */
export const putAdminUsersBatchStatus = (
    handlerBatchUpdateUserStatusRequest: HandlerBatchUpdateUserStatusRequest,
 ) => {
      
      
      return origin_point_engine_api<PutAdminUsersBatchStatus200>(
      {url: `/admin/users/batch-status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlerBatchUpdateUserStatusRequest
    },
      );
    }
  


export const getPutAdminUsersBatchStatusMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersBatchStatus>>, TError,{data: HandlerBatchUpdateUserStatusRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersBatchStatus>>, TError,{data: HandlerBatchUpdateUserStatusRequest}, TContext> => {

const mutationKey = ['putAdminUsersBatchStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUsersBatchStatus>>, {data: HandlerBatchUpdateUserStatusRequest}> = (props) => {
          const {data} = props ?? {};

          return  putAdminUsersBatchStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminUsersBatchStatusMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUsersBatchStatus>>>
    export type PutAdminUsersBatchStatusMutationBody = HandlerBatchUpdateUserStatusRequest
    export type PutAdminUsersBatchStatusMutationError = HandlersResponseData

    /**
 * @summary 批量更新用户状态
 */
export const usePutAdminUsersBatchStatus = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersBatchStatus>>, TError,{data: HandlerBatchUpdateUserStatusRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminUsersBatchStatus>>,
        TError,
        {data: HandlerBatchUpdateUserStatusRequest},
        TContext
      > => {

      const mutationOptions = getPutAdminUsersBatchStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员发放通行证，支持批量发放
 * @summary 发放通行证
 */
export const postAdminUsersDistributePass = (
    adminDistributePassRequest: AdminDistributePassRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<AdminDistributePassResult>(
      {url: `/admin/users/distribute-pass`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminDistributePassRequest, signal
    },
      );
    }
  


export const getPostAdminUsersDistributePassMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersDistributePass>>, TError,{data: AdminDistributePassRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersDistributePass>>, TError,{data: AdminDistributePassRequest}, TContext> => {

const mutationKey = ['postAdminUsersDistributePass'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminUsersDistributePass>>, {data: AdminDistributePassRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAdminUsersDistributePass(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminUsersDistributePassMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminUsersDistributePass>>>
    export type PostAdminUsersDistributePassMutationBody = AdminDistributePassRequest
    export type PostAdminUsersDistributePassMutationError = HandlersResponseData

    /**
 * @summary 发放通行证
 */
export const usePostAdminUsersDistributePass = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersDistributePass>>, TError,{data: AdminDistributePassRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminUsersDistributePass>>,
        TError,
        {data: AdminDistributePassRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminUsersDistributePassMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员根据ID获取特定用户详情
 * @summary 获取用户详情
 */
export const getAdminUsersId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminUsersId200>(
      {url: `/admin/users/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAdminUsersIdQueryKey = (id?: string,) => {
    return [
    `/admin/users/${id}`
    ] as const;
    }

    
export const getGetAdminUsersIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = HandlersResponseData>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsersId>>> = ({ signal }) => getAdminUsersId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersId>>>
export type GetAdminUsersIdQueryError = HandlersResponseData


export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = HandlersResponseData>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersId>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersId>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取用户详情
 */

export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = HandlersResponseData>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUsersIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员根据ID更新用户信息
 * @summary 更新用户信息
 */
export const putAdminUsersId = (
    id: string,
    putAdminUsersIdBody: PutAdminUsersIdBody,
 ) => {
      
      
      return origin_point_engine_api<PutAdminUsersId200>(
      {url: `/admin/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putAdminUsersIdBody
    },
      );
    }
  


export const getPutAdminUsersIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersId>>, TError,{id: string;data: PutAdminUsersIdBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersId>>, TError,{id: string;data: PutAdminUsersIdBody}, TContext> => {

const mutationKey = ['putAdminUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUsersId>>, {id: string;data: PutAdminUsersIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminUsersId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUsersId>>>
    export type PutAdminUsersIdMutationBody = PutAdminUsersIdBody
    export type PutAdminUsersIdMutationError = HandlersResponseData

    /**
 * @summary 更新用户信息
 */
export const usePutAdminUsersId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersId>>, TError,{id: string;data: PutAdminUsersIdBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminUsersId>>,
        TError,
        {id: string;data: PutAdminUsersIdBody},
        TContext
      > => {

      const mutationOptions = getPutAdminUsersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员根据ID软删除用户
 * @summary 删除用户
 */
export const deleteAdminUsersId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<DeleteAdminUsersId200>(
      {url: `/admin/users/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminUsersIdMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUsersId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUsersId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminUsersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminUsersId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminUsersId>>>
    
    export type DeleteAdminUsersIdMutationError = HandlersResponseData

    /**
 * @summary 删除用户
 */
export const useDeleteAdminUsersId = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUsersId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminUsersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminUsersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员对指定用户增加或扣减元点，delta 正数增加/负数扣减，自动写 transaction_records（type: admin_adjust）
 * @summary 调整用户余额
 */
export const postAdminUsersIdAdjustBalance = (
    id: string,
    adminAdjustBalanceRequest: AdminAdjustBalanceRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/users/${id}/adjust-balance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminAdjustBalanceRequest, signal
    },
      );
    }
  


export const getPostAdminUsersIdAdjustBalanceMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersIdAdjustBalance>>, TError,{id: string;data: AdminAdjustBalanceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersIdAdjustBalance>>, TError,{id: string;data: AdminAdjustBalanceRequest}, TContext> => {

const mutationKey = ['postAdminUsersIdAdjustBalance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminUsersIdAdjustBalance>>, {id: string;data: AdminAdjustBalanceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postAdminUsersIdAdjustBalance(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminUsersIdAdjustBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminUsersIdAdjustBalance>>>
    export type PostAdminUsersIdAdjustBalanceMutationBody = AdminAdjustBalanceRequest
    export type PostAdminUsersIdAdjustBalanceMutationError = HandlersResponseData

    /**
 * @summary 调整用户余额
 */
export const usePostAdminUsersIdAdjustBalance = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersIdAdjustBalance>>, TError,{id: string;data: AdminAdjustBalanceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminUsersIdAdjustBalance>>,
        TError,
        {id: string;data: AdminAdjustBalanceRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminUsersIdAdjustBalanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 发送站内私信
 */
export const postAdminUsersIdMessages = (
    id: string,
    adminSendUserMessageRequest: AdminSendUserMessageRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<unknown>(
      {url: `/admin/users/${id}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminSendUserMessageRequest, signal
    },
      );
    }
  


export const getPostAdminUsersIdMessagesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersIdMessages>>, TError,{id: string;data: AdminSendUserMessageRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersIdMessages>>, TError,{id: string;data: AdminSendUserMessageRequest}, TContext> => {

const mutationKey = ['postAdminUsersIdMessages'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminUsersIdMessages>>, {id: string;data: AdminSendUserMessageRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postAdminUsersIdMessages(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminUsersIdMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminUsersIdMessages>>>
    export type PostAdminUsersIdMessagesMutationBody = AdminSendUserMessageRequest
    export type PostAdminUsersIdMessagesMutationError = unknown

    /**
 * @summary 发送站内私信
 */
export const usePostAdminUsersIdMessages = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsersIdMessages>>, TError,{id: string;data: AdminSendUserMessageRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminUsersIdMessages>>,
        TError,
        {id: string;data: AdminSendUserMessageRequest},
        TContext
      > => {

      const mutationOptions = getPostAdminUsersIdMessagesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 管理员分页获取指定用户的所有充值订单
 * @summary 获取用户充值记录
 */
export const getAdminUsersIdRechargeOrders = (
    id: string,
    params?: GetAdminUsersIdRechargeOrdersParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAdminUsersIdRechargeOrders200>(
      {url: `/admin/users/${id}/recharge-orders`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminUsersIdRechargeOrdersQueryKey = (id?: string,
    params?: GetAdminUsersIdRechargeOrdersParams,) => {
    return [
    `/admin/users/${id}/recharge-orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminUsersIdRechargeOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError = HandlersResponseData>(id: string,
    params?: GetAdminUsersIdRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersIdRechargeOrdersQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>> = ({ signal }) => getAdminUsersIdRechargeOrders(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUsersIdRechargeOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>>
export type GetAdminUsersIdRechargeOrdersQueryError = HandlersResponseData


export function useGetAdminUsersIdRechargeOrders<TData = Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError = HandlersResponseData>(
 id: string,
    params: undefined |  GetAdminUsersIdRechargeOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersIdRechargeOrders<TData = Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError = HandlersResponseData>(
 id: string,
    params?: GetAdminUsersIdRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersIdRechargeOrders<TData = Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError = HandlersResponseData>(
 id: string,
    params?: GetAdminUsersIdRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取用户充值记录
 */

export function useGetAdminUsersIdRechargeOrders<TData = Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError = HandlersResponseData>(
 id: string,
    params?: GetAdminUsersIdRechargeOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdRechargeOrders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUsersIdRechargeOrdersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 管理员分页获取指定用户的所有元点收支记录
 * @summary 获取用户元点流水
 */
export const getAdminUsersIdTransactions = (
    id: string,
    params?: GetAdminUsersIdTransactionsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/admin/users/${id}/transactions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAdminUsersIdTransactionsQueryKey = (id?: string,
    params?: GetAdminUsersIdTransactionsParams,) => {
    return [
    `/admin/users/${id}/transactions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminUsersIdTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError = HandlersResponseData>(id: string,
    params?: GetAdminUsersIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersIdTransactionsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>> = ({ signal }) => getAdminUsersIdTransactions(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUsersIdTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>>
export type GetAdminUsersIdTransactionsQueryError = HandlersResponseData


export function useGetAdminUsersIdTransactions<TData = Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError = HandlersResponseData>(
 id: string,
    params: undefined |  GetAdminUsersIdTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersIdTransactions<TData = Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError = HandlersResponseData>(
 id: string,
    params?: GetAdminUsersIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersIdTransactions<TData = Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError = HandlersResponseData>(
 id: string,
    params?: GetAdminUsersIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取用户元点流水
 */

export function useGetAdminUsersIdTransactions<TData = Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError = HandlersResponseData>(
 id: string,
    params?: GetAdminUsersIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUsersIdTransactionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取所有可用的AI厂商和模型配置
 * @summary 获取AI厂商列表
 */
export const getAiProviders = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAiProviders200>(
      {url: `/ai-providers`, method: 'GET', signal
    },
      );
    }
  



export const getGetAiProvidersQueryKey = () => {
    return [
    `/ai-providers`
    ] as const;
    }

    
export const getGetAiProvidersQueryOptions = <TData = Awaited<ReturnType<typeof getAiProviders>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiProviders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiProvidersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiProviders>>> = ({ signal }) => getAiProviders(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getAiProviders>>>
export type GetAiProvidersQueryError = unknown


export function useGetAiProviders<TData = Awaited<ReturnType<typeof getAiProviders>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiProviders>>,
          TError,
          Awaited<ReturnType<typeof getAiProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiProviders<TData = Awaited<ReturnType<typeof getAiProviders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiProviders>>,
          TError,
          Awaited<ReturnType<typeof getAiProviders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiProviders<TData = Awaited<ReturnType<typeof getAiProviders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiProviders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取AI厂商列表
 */

export function useGetAiProviders<TData = Awaited<ReturnType<typeof getAiProviders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiProviders>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiProvidersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取已发布的公告列表（分页）
 * @summary 获取公告列表
 */
export const getAnnouncements = (
    params?: GetAnnouncementsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAnnouncements200>(
      {url: `/announcements`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAnnouncementsQueryKey = (params?: GetAnnouncementsParams,) => {
    return [
    `/announcements`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAnnouncementsQueryOptions = <TData = Awaited<ReturnType<typeof getAnnouncements>>, TError = GetAnnouncements500>(params?: GetAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnnouncementsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnouncements>>> = ({ signal }) => getAnnouncements(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnouncements>>>
export type GetAnnouncementsQueryError = GetAnnouncements500


export function useGetAnnouncements<TData = Awaited<ReturnType<typeof getAnnouncements>>, TError = GetAnnouncements500>(
 params: undefined |  GetAnnouncementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getAnnouncements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnnouncements<TData = Awaited<ReturnType<typeof getAnnouncements>>, TError = GetAnnouncements500>(
 params?: GetAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof getAnnouncements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnnouncements<TData = Awaited<ReturnType<typeof getAnnouncements>>, TError = GetAnnouncements500>(
 params?: GetAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取公告列表
 */

export function useGetAnnouncements<TData = Awaited<ReturnType<typeof getAnnouncements>>, TError = GetAnnouncements500>(
 params?: GetAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncements>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnouncementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取最新发布的公告（用于首页显示）
 * @summary 获取最新公告
 */
export const getAnnouncementsLatest = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAnnouncementsLatest200>(
      {url: `/announcements/latest`, method: 'GET', signal
    },
      );
    }
  



export const getGetAnnouncementsLatestQueryKey = () => {
    return [
    `/announcements/latest`
    ] as const;
    }

    
export const getGetAnnouncementsLatestQueryOptions = <TData = Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError = GetAnnouncementsLatest500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnnouncementsLatestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnouncementsLatest>>> = ({ signal }) => getAnnouncementsLatest(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnnouncementsLatestQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnouncementsLatest>>>
export type GetAnnouncementsLatestQueryError = GetAnnouncementsLatest500


export function useGetAnnouncementsLatest<TData = Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError = GetAnnouncementsLatest500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnouncementsLatest>>,
          TError,
          Awaited<ReturnType<typeof getAnnouncementsLatest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnnouncementsLatest<TData = Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError = GetAnnouncementsLatest500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnouncementsLatest>>,
          TError,
          Awaited<ReturnType<typeof getAnnouncementsLatest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnnouncementsLatest<TData = Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError = GetAnnouncementsLatest500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取最新公告
 */

export function useGetAnnouncementsLatest<TData = Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError = GetAnnouncementsLatest500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsLatest>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnouncementsLatestQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 根据ID获取公告详情
 * @summary 获取公告详情
 */
export const getAnnouncementsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetAnnouncementsId200>(
      {url: `/announcements/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAnnouncementsIdQueryKey = (id?: string,) => {
    return [
    `/announcements/${id}`
    ] as const;
    }

    
export const getGetAnnouncementsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAnnouncementsId>>, TError = GetAnnouncementsId400 | GetAnnouncementsId404>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnnouncementsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnnouncementsId>>> = ({ signal }) => getAnnouncementsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnnouncementsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAnnouncementsId>>>
export type GetAnnouncementsIdQueryError = GetAnnouncementsId400 | GetAnnouncementsId404


export function useGetAnnouncementsId<TData = Awaited<ReturnType<typeof getAnnouncementsId>>, TError = GetAnnouncementsId400 | GetAnnouncementsId404>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnouncementsId>>,
          TError,
          Awaited<ReturnType<typeof getAnnouncementsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnnouncementsId<TData = Awaited<ReturnType<typeof getAnnouncementsId>>, TError = GetAnnouncementsId400 | GetAnnouncementsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnnouncementsId>>,
          TError,
          Awaited<ReturnType<typeof getAnnouncementsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnnouncementsId<TData = Awaited<ReturnType<typeof getAnnouncementsId>>, TError = GetAnnouncementsId400 | GetAnnouncementsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取公告详情
 */

export function useGetAnnouncementsId<TData = Awaited<ReturnType<typeof getAnnouncementsId>>, TError = GetAnnouncementsId400 | GetAnnouncementsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnnouncementsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnnouncementsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 处理微信支付异步通知
 * @summary 微信支付回调
 */
export const postApiV1CallbackWechat = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostApiV1CallbackWechat200>(
      {url: `/api/v1/callback/wechat`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1CallbackWechatMutationOptions = <TError = PostApiV1CallbackWechat400 | PostApiV1CallbackWechat500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1CallbackWechat>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1CallbackWechat>>, TError,void, TContext> => {

const mutationKey = ['postApiV1CallbackWechat'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1CallbackWechat>>, void> = () => {
          

          return  postApiV1CallbackWechat()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1CallbackWechatMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1CallbackWechat>>>
    
    export type PostApiV1CallbackWechatMutationError = PostApiV1CallbackWechat400 | PostApiV1CallbackWechat500

    /**
 * @summary 微信支付回调
 */
export const usePostApiV1CallbackWechat = <TError = PostApiV1CallbackWechat400 | PostApiV1CallbackWechat500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1CallbackWechat>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1CallbackWechat>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostApiV1CallbackWechatMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 处理ZPay支付异步通知
 * @summary ZPay支付回调
 */
export const getApiV1CallbackZpay = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<string>(
      {url: `/api/v1/callback/zpay`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1CallbackZpayQueryKey = () => {
    return [
    `/api/v1/callback/zpay`
    ] as const;
    }

    
export const getGetApiV1CallbackZpayQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1CallbackZpayQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1CallbackZpay>>> = ({ signal }) => getApiV1CallbackZpay(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1CallbackZpayQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1CallbackZpay>>>
export type GetApiV1CallbackZpayQueryError = unknown


export function useGetApiV1CallbackZpay<TData = Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CallbackZpay>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CallbackZpay>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CallbackZpay<TData = Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1CallbackZpay>>,
          TError,
          Awaited<ReturnType<typeof getApiV1CallbackZpay>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1CallbackZpay<TData = Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ZPay支付回调
 */

export function useGetApiV1CallbackZpay<TData = Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1CallbackZpay>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1CallbackZpayQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 使用邮箱密码登录
 * @summary 邮箱登录
 */
export const postAuthLogin = (
    identityLoginEmailRequest: IdentityLoginEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAuthLogin200>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityLoginEmailRequest, signal
    },
      );
    }
  


export const getPostAuthLoginMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: IdentityLoginEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: IdentityLoginEmailRequest}, TContext> => {

const mutationKey = ['postAuthLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLogin>>, {data: IdentityLoginEmailRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthLogin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogin>>>
    export type PostAuthLoginMutationBody = IdentityLoginEmailRequest
    export type PostAuthLoginMutationError = HandlersResponseData

    /**
 * @summary 邮箱登录
 */
export const usePostAuthLogin = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: IdentityLoginEmailRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLogin>>,
        TError,
        {data: IdentityLoginEmailRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 使用手机号和验证码快捷登录
 * @summary 手机号登录
 */
export const postAuthLoginPhone = (
    identityLoginPhoneRequest: IdentityLoginPhoneRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAuthLoginPhone200>(
      {url: `/auth/login-phone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityLoginPhoneRequest, signal
    },
      );
    }
  


export const getPostAuthLoginPhoneMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginPhone>>, TError,{data: IdentityLoginPhoneRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginPhone>>, TError,{data: IdentityLoginPhoneRequest}, TContext> => {

const mutationKey = ['postAuthLoginPhone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLoginPhone>>, {data: IdentityLoginPhoneRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthLoginPhone(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLoginPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLoginPhone>>>
    export type PostAuthLoginPhoneMutationBody = IdentityLoginPhoneRequest
    export type PostAuthLoginPhoneMutationError = HandlersResponseData

    /**
 * @summary 手机号登录
 */
export const usePostAuthLoginPhone = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLoginPhone>>, TError,{data: IdentityLoginPhoneRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLoginPhone>>,
        TError,
        {data: IdentityLoginPhoneRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthLoginPhoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 使用 RefreshToken 获取新的 AccessToken
 * @summary 刷新 Token
 */
export const postAuthRefresh = (
    identityRefreshTokenRequest: IdentityRefreshTokenRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAuthRefresh200>(
      {url: `/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityRefreshTokenRequest, signal
    },
      );
    }
  


export const getPostAuthRefreshMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: IdentityRefreshTokenRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: IdentityRefreshTokenRequest}, TContext> => {

const mutationKey = ['postAuthRefresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRefresh>>, {data: IdentityRefreshTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRefresh(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRefresh>>>
    export type PostAuthRefreshMutationBody = IdentityRefreshTokenRequest
    export type PostAuthRefreshMutationError = HandlersResponseData

    /**
 * @summary 刷新 Token
 */
export const usePostAuthRefresh = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: IdentityRefreshTokenRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRefresh>>,
        TError,
        {data: IdentityRefreshTokenRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 使用邮箱密码注册账号
 * @summary 邮箱注册
 */
export const postAuthRegister = (
    identityRegisterEmailRequest: IdentityRegisterEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAuthRegister200>(
      {url: `/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityRegisterEmailRequest, signal
    },
      );
    }
  


export const getPostAuthRegisterMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRegister>>, TError,{data: IdentityRegisterEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRegister>>, TError,{data: IdentityRegisterEmailRequest}, TContext> => {

const mutationKey = ['postAuthRegister'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRegister>>, {data: IdentityRegisterEmailRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRegister(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRegister>>>
    export type PostAuthRegisterMutationBody = IdentityRegisterEmailRequest
    export type PostAuthRegisterMutationError = HandlersResponseData

    /**
 * @summary 邮箱注册
 */
export const usePostAuthRegister = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRegister>>, TError,{data: IdentityRegisterEmailRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRegister>>,
        TError,
        {data: IdentityRegisterEmailRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthRegisterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 使用手机号和验证码注册新用户
 * @summary 手机号注册
 */
export const postAuthRegisterPhone = (
    identityRegisterPhoneRequest: IdentityRegisterPhoneRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAuthRegisterPhone200>(
      {url: `/auth/register-phone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityRegisterPhoneRequest, signal
    },
      );
    }
  


export const getPostAuthRegisterPhoneMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRegisterPhone>>, TError,{data: IdentityRegisterPhoneRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRegisterPhone>>, TError,{data: IdentityRegisterPhoneRequest}, TContext> => {

const mutationKey = ['postAuthRegisterPhone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRegisterPhone>>, {data: IdentityRegisterPhoneRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRegisterPhone(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRegisterPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRegisterPhone>>>
    export type PostAuthRegisterPhoneMutationBody = IdentityRegisterPhoneRequest
    export type PostAuthRegisterPhoneMutationError = HandlersResponseData

    /**
 * @summary 手机号注册
 */
export const usePostAuthRegisterPhone = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRegisterPhone>>, TError,{data: IdentityRegisterPhoneRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRegisterPhone>>,
        TError,
        {data: IdentityRegisterPhoneRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthRegisterPhoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 发送验证码到指定邮箱
 * @summary 发送邮箱验证码
 */
export const postAuthSendCode = (
    identitySendEmailCodeRequest: IdentitySendEmailCodeRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/auth/send-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identitySendEmailCodeRequest, signal
    },
      );
    }
  


export const getPostAuthSendCodeMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthSendCode>>, TError,{data: IdentitySendEmailCodeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthSendCode>>, TError,{data: IdentitySendEmailCodeRequest}, TContext> => {

const mutationKey = ['postAuthSendCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthSendCode>>, {data: IdentitySendEmailCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthSendCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthSendCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthSendCode>>>
    export type PostAuthSendCodeMutationBody = IdentitySendEmailCodeRequest
    export type PostAuthSendCodeMutationError = HandlersResponseData

    /**
 * @summary 发送邮箱验证码
 */
export const usePostAuthSendCode = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthSendCode>>, TError,{data: IdentitySendEmailCodeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthSendCode>>,
        TError,
        {data: IdentitySendEmailCodeRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthSendCodeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 向指定手机号发送验证码
 * @summary 发送短信验证码
 */
export const postAuthSendSms = (
    identitySendSmsRequest: IdentitySendSmsRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/auth/send-sms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identitySendSmsRequest, signal
    },
      );
    }
  


export const getPostAuthSendSmsMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthSendSms>>, TError,{data: IdentitySendSmsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthSendSms>>, TError,{data: IdentitySendSmsRequest}, TContext> => {

const mutationKey = ['postAuthSendSms'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthSendSms>>, {data: IdentitySendSmsRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthSendSms(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthSendSmsMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthSendSms>>>
    export type PostAuthSendSmsMutationBody = IdentitySendSmsRequest
    export type PostAuthSendSmsMutationError = HandlersResponseData

    /**
 * @summary 发送短信验证码
 */
export const usePostAuthSendSms = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthSendSms>>, TError,{data: IdentitySendSmsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthSendSms>>,
        TError,
        {data: IdentitySendSmsRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthSendSmsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 验证邮箱验证码并登录（如无账号则自动注册）
 * @summary 验证邮箱验证码
 */
export const postAuthVerifyCode = (
    identityVerifyEmailRequest: IdentityVerifyEmailRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostAuthVerifyCode200>(
      {url: `/auth/verify-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityVerifyEmailRequest, signal
    },
      );
    }
  


export const getPostAuthVerifyCodeMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyCode>>, TError,{data: IdentityVerifyEmailRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyCode>>, TError,{data: IdentityVerifyEmailRequest}, TContext> => {

const mutationKey = ['postAuthVerifyCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthVerifyCode>>, {data: IdentityVerifyEmailRequest}> = (props) => {
          const {data} = props ?? {};

          return  postAuthVerifyCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthVerifyCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthVerifyCode>>>
    export type PostAuthVerifyCodeMutationBody = IdentityVerifyEmailRequest
    export type PostAuthVerifyCodeMutationError = HandlersResponseData

    /**
 * @summary 验证邮箱验证码
 */
export const usePostAuthVerifyCode = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthVerifyCode>>, TError,{data: IdentityVerifyEmailRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthVerifyCode>>,
        TError,
        {data: IdentityVerifyEmailRequest},
        TContext
      > => {

      const mutationOptions = getPostAuthVerifyCodeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 支付宝支付平台回调接口，用于接收支付结果通知
 * @summary 支付宝支付回调
 */
export const postCallbackAlipay = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<string>(
      {url: `/callback/alipay`, method: 'POST', signal
    },
      );
    }
  


export const getPostCallbackAlipayMutationOptions = <TError = string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCallbackAlipay>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCallbackAlipay>>, TError,void, TContext> => {

const mutationKey = ['postCallbackAlipay'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCallbackAlipay>>, void> = () => {
          

          return  postCallbackAlipay()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCallbackAlipayMutationResult = NonNullable<Awaited<ReturnType<typeof postCallbackAlipay>>>
    
    export type PostCallbackAlipayMutationError = string

    /**
 * @summary 支付宝支付回调
 */
export const usePostCallbackAlipay = <TError = string,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCallbackAlipay>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCallbackAlipay>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostCallbackAlipayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 提交任务并快速返回 taskId，不等待任务完成
 * @summary 做出选择（非流式异步）
 */
export const postChatSessionsSessionIdChoice = (
    sessionId: string,
    handlersMakeChoiceRequestBody: HandlersMakeChoiceRequestBody,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersMakeChoiceResponse | HandlersMakeChoiceResponse>(
      {url: `/chat/sessions/${sessionId}/choice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersMakeChoiceRequestBody, signal
    },
      );
    }
  


export const getPostChatSessionsSessionIdChoiceMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatSessionsSessionIdChoice>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postChatSessionsSessionIdChoice>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext> => {

const mutationKey = ['postChatSessionsSessionIdChoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatSessionsSessionIdChoice>>, {sessionId: string;data: HandlersMakeChoiceRequestBody}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  postChatSessionsSessionIdChoice(sessionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostChatSessionsSessionIdChoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postChatSessionsSessionIdChoice>>>
    export type PostChatSessionsSessionIdChoiceMutationBody = HandlersMakeChoiceRequestBody
    export type PostChatSessionsSessionIdChoiceMutationError = HandlersResponseData

    /**
 * @summary 做出选择（非流式异步）
 */
export const usePostChatSessionsSessionIdChoice = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatSessionsSessionIdChoice>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatSessionsSessionIdChoice>>,
        TError,
        {sessionId: string;data: HandlersMakeChoiceRequestBody},
        TContext
      > => {

      const mutationOptions = getPostChatSessionsSessionIdChoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 建立 SSE 连接并实时推送 AI 处理进度和结果
 * @summary SSE 流式做出选择
 */
export const postChatSessionsSessionIdChoiceStream = (
    sessionId: string,
    handlersMakeChoiceRequestBody: HandlersMakeChoiceRequestBody,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<void>(
      {url: `/chat/sessions/${sessionId}/choice/stream`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersMakeChoiceRequestBody, signal
    },
      );
    }
  


export const getPostChatSessionsSessionIdChoiceStreamMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatSessionsSessionIdChoiceStream>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postChatSessionsSessionIdChoiceStream>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext> => {

const mutationKey = ['postChatSessionsSessionIdChoiceStream'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postChatSessionsSessionIdChoiceStream>>, {sessionId: string;data: HandlersMakeChoiceRequestBody}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  postChatSessionsSessionIdChoiceStream(sessionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostChatSessionsSessionIdChoiceStreamMutationResult = NonNullable<Awaited<ReturnType<typeof postChatSessionsSessionIdChoiceStream>>>
    export type PostChatSessionsSessionIdChoiceStreamMutationBody = HandlersMakeChoiceRequestBody
    export type PostChatSessionsSessionIdChoiceStreamMutationError = HandlersResponseData

    /**
 * @summary SSE 流式做出选择
 */
export const usePostChatSessionsSessionIdChoiceStream = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postChatSessionsSessionIdChoiceStream>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postChatSessionsSessionIdChoiceStream>>,
        TError,
        {sessionId: string;data: HandlersMakeChoiceRequestBody},
        TContext
      > => {

      const mutationOptions = getPostChatSessionsSessionIdChoiceStreamMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 通过 taskId 查询任务的状态和结果
 * @summary 获取任务状态
 */
export const getChatSessionsSessionIdChoiceTaskTaskId = (
    sessionId: string,
    taskId: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersTaskStatusResponse>(
      {url: `/chat/sessions/${sessionId}/choice/task/${taskId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetChatSessionsSessionIdChoiceTaskTaskIdQueryKey = (sessionId?: string,
    taskId?: string,) => {
    return [
    `/chat/sessions/${sessionId}/choice/task/${taskId}`
    ] as const;
    }

    
export const getGetChatSessionsSessionIdChoiceTaskTaskIdQueryOptions = <TData = Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError = HandlersResponseData>(sessionId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatSessionsSessionIdChoiceTaskTaskIdQueryKey(sessionId,taskId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>> = ({ signal }) => getChatSessionsSessionIdChoiceTaskTaskId(sessionId,taskId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId && taskId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatSessionsSessionIdChoiceTaskTaskIdQueryResult = NonNullable<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>>
export type GetChatSessionsSessionIdChoiceTaskTaskIdQueryError = HandlersResponseData


export function useGetChatSessionsSessionIdChoiceTaskTaskId<TData = Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError = HandlersResponseData>(
 sessionId: string,
    taskId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>,
          TError,
          Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatSessionsSessionIdChoiceTaskTaskId<TData = Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError = HandlersResponseData>(
 sessionId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>,
          TError,
          Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatSessionsSessionIdChoiceTaskTaskId<TData = Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError = HandlersResponseData>(
 sessionId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取任务状态
 */

export function useGetChatSessionsSessionIdChoiceTaskTaskId<TData = Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError = HandlersResponseData>(
 sessionId: string,
    taskId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatSessionsSessionIdChoiceTaskTaskId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatSessionsSessionIdChoiceTaskTaskIdQueryOptions(sessionId,taskId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 用户每日领取元点奖励（每日一次）
 * @summary 每日签到
 */
export const postCheckin = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/checkin`, method: 'POST', signal
    },
      );
    }
  


export const getPostCheckinMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCheckin>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCheckin>>, TError,void, TContext> => {

const mutationKey = ['postCheckin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCheckin>>, void> = () => {
          

          return  postCheckin()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCheckinMutationResult = NonNullable<Awaited<ReturnType<typeof postCheckin>>>
    
    export type PostCheckinMutationError = HandlersResponseData

    /**
 * @summary 每日签到
 */
export const usePostCheckin = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCheckin>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCheckin>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostCheckinMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 查询用户今日是否已签到
 * @summary 获取签到状态
 */
export const getCheckinStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/checkin/status`, method: 'GET', signal
    },
      );
    }
  



export const getGetCheckinStatusQueryKey = () => {
    return [
    `/checkin/status`
    ] as const;
    }

    
export const getGetCheckinStatusQueryOptions = <TData = Awaited<ReturnType<typeof getCheckinStatus>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckinStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCheckinStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCheckinStatus>>> = ({ signal }) => getCheckinStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCheckinStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCheckinStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getCheckinStatus>>>
export type GetCheckinStatusQueryError = HandlersResponseData


export function useGetCheckinStatus<TData = Awaited<ReturnType<typeof getCheckinStatus>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckinStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckinStatus>>,
          TError,
          Awaited<ReturnType<typeof getCheckinStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCheckinStatus<TData = Awaited<ReturnType<typeof getCheckinStatus>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckinStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckinStatus>>,
          TError,
          Awaited<ReturnType<typeof getCheckinStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCheckinStatus<TData = Awaited<ReturnType<typeof getCheckinStatus>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckinStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取签到状态
 */

export function useGetCheckinStatus<TData = Awaited<ReturnType<typeof getCheckinStatus>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCheckinStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCheckinStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 更新自己的评论内容
 * @summary 更新评论
 */
export const putCommentsCommentId = (
    id: string,
    handlersUpdateCommentRequest: HandlersUpdateCommentRequest,
 ) => {
      
      
      return origin_point_engine_api<PutCommentsCommentId200>(
      {url: `/comments/comment/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersUpdateCommentRequest
    },
      );
    }
  


export const getPutCommentsCommentIdMutationOptions = <TError = PutCommentsCommentId400 | PutCommentsCommentId403 | PutCommentsCommentId404 | PutCommentsCommentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCommentsCommentId>>, TError,{id: string;data: HandlersUpdateCommentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCommentsCommentId>>, TError,{id: string;data: HandlersUpdateCommentRequest}, TContext> => {

const mutationKey = ['putCommentsCommentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCommentsCommentId>>, {id: string;data: HandlersUpdateCommentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putCommentsCommentId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCommentsCommentId>>>
    export type PutCommentsCommentIdMutationBody = HandlersUpdateCommentRequest
    export type PutCommentsCommentIdMutationError = PutCommentsCommentId400 | PutCommentsCommentId403 | PutCommentsCommentId404 | PutCommentsCommentId500

    /**
 * @summary 更新评论
 */
export const usePutCommentsCommentId = <TError = PutCommentsCommentId400 | PutCommentsCommentId403 | PutCommentsCommentId404 | PutCommentsCommentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCommentsCommentId>>, TError,{id: string;data: HandlersUpdateCommentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCommentsCommentId>>,
        TError,
        {id: string;data: HandlersUpdateCommentRequest},
        TContext
      > => {

      const mutationOptions = getPutCommentsCommentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 删除自己的评论（软删除）
 * @summary 删除评论
 */
export const deleteCommentsCommentId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<DeleteCommentsCommentId200>(
      {url: `/comments/comment/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCommentsCommentIdMutationOptions = <TError = DeleteCommentsCommentId400 | DeleteCommentsCommentId403 | DeleteCommentsCommentId404 | DeleteCommentsCommentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommentsCommentId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommentsCommentId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCommentsCommentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommentsCommentId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCommentsCommentId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommentsCommentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommentsCommentId>>>
    
    export type DeleteCommentsCommentIdMutationError = DeleteCommentsCommentId400 | DeleteCommentsCommentId403 | DeleteCommentsCommentId404 | DeleteCommentsCommentId500

    /**
 * @summary 删除评论
 */
export const useDeleteCommentsCommentId = <TError = DeleteCommentsCommentId400 | DeleteCommentsCommentId403 | DeleteCommentsCommentId404 | DeleteCommentsCommentId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommentsCommentId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommentsCommentId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCommentsCommentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 为评论点赞或点踩，重复操作可取消
 * @summary 点赞/点踩评论
 */
export const postCommentsCommentIdLike = (
    id: string,
    handlersLikeCommentRequest: HandlersLikeCommentRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostCommentsCommentIdLike200>(
      {url: `/comments/comment/${id}/like`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersLikeCommentRequest, signal
    },
      );
    }
  


export const getPostCommentsCommentIdLikeMutationOptions = <TError = PostCommentsCommentIdLike400 | PostCommentsCommentIdLike404 | PostCommentsCommentIdLike500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsCommentIdLike>>, TError,{id: string;data: HandlersLikeCommentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCommentsCommentIdLike>>, TError,{id: string;data: HandlersLikeCommentRequest}, TContext> => {

const mutationKey = ['postCommentsCommentIdLike'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommentsCommentIdLike>>, {id: string;data: HandlersLikeCommentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postCommentsCommentIdLike(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommentsCommentIdLikeMutationResult = NonNullable<Awaited<ReturnType<typeof postCommentsCommentIdLike>>>
    export type PostCommentsCommentIdLikeMutationBody = HandlersLikeCommentRequest
    export type PostCommentsCommentIdLikeMutationError = PostCommentsCommentIdLike400 | PostCommentsCommentIdLike404 | PostCommentsCommentIdLike500

    /**
 * @summary 点赞/点踩评论
 */
export const usePostCommentsCommentIdLike = <TError = PostCommentsCommentIdLike400 | PostCommentsCommentIdLike404 | PostCommentsCommentIdLike500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsCommentIdLike>>, TError,{id: string;data: HandlersLikeCommentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommentsCommentIdLike>>,
        TError,
        {id: string;data: HandlersLikeCommentRequest},
        TContext
      > => {

      const mutationOptions = getPostCommentsCommentIdLikeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取指定目标的评论列表，支持分页和排序
 * @summary 获取评论列表
 */
export const getCommentsTargetTypeTargetId = (
    targetType: 'engine',
    targetId: string,
    params?: GetCommentsTargetTypeTargetIdParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetCommentsTargetTypeTargetId200>(
      {url: `/comments/${targetType}/${targetId}`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetCommentsTargetTypeTargetIdQueryKey = (targetType?: 'engine',
    targetId?: string,
    params?: GetCommentsTargetTypeTargetIdParams,) => {
    return [
    `/comments/${targetType}/${targetId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommentsTargetTypeTargetIdQueryOptions = <TData = Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError = GetCommentsTargetTypeTargetId400 | GetCommentsTargetTypeTargetId500>(targetType: 'engine',
    targetId: string,
    params?: GetCommentsTargetTypeTargetIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommentsTargetTypeTargetIdQueryKey(targetType,targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>> = ({ signal }) => getCommentsTargetTypeTargetId(targetType,targetId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(targetType && targetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommentsTargetTypeTargetIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>>
export type GetCommentsTargetTypeTargetIdQueryError = GetCommentsTargetTypeTargetId400 | GetCommentsTargetTypeTargetId500


export function useGetCommentsTargetTypeTargetId<TData = Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError = GetCommentsTargetTypeTargetId400 | GetCommentsTargetTypeTargetId500>(
 targetType: 'engine',
    targetId: string,
    params: undefined |  GetCommentsTargetTypeTargetIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>,
          TError,
          Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommentsTargetTypeTargetId<TData = Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError = GetCommentsTargetTypeTargetId400 | GetCommentsTargetTypeTargetId500>(
 targetType: 'engine',
    targetId: string,
    params?: GetCommentsTargetTypeTargetIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>,
          TError,
          Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommentsTargetTypeTargetId<TData = Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError = GetCommentsTargetTypeTargetId400 | GetCommentsTargetTypeTargetId500>(
 targetType: 'engine',
    targetId: string,
    params?: GetCommentsTargetTypeTargetIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取评论列表
 */

export function useGetCommentsTargetTypeTargetId<TData = Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError = GetCommentsTargetTypeTargetId400 | GetCommentsTargetTypeTargetId500>(
 targetType: 'engine',
    targetId: string,
    params?: GetCommentsTargetTypeTargetIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommentsTargetTypeTargetId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommentsTargetTypeTargetIdQueryOptions(targetType,targetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 为指定目标（引擎或角色）创建评论或回复
 * @summary 创建评论
 */
export const postCommentsTargetTypeTargetId = (
    targetType: 'engine',
    targetId: string,
    handlersCreateCommentRequest: HandlersCreateCommentRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostCommentsTargetTypeTargetId201>(
      {url: `/comments/${targetType}/${targetId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersCreateCommentRequest, signal
    },
      );
    }
  


export const getPostCommentsTargetTypeTargetIdMutationOptions = <TError = PostCommentsTargetTypeTargetId400 | PostCommentsTargetTypeTargetId404 | PostCommentsTargetTypeTargetId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsTargetTypeTargetId>>, TError,{targetType: 'engine';targetId: string;data: HandlersCreateCommentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCommentsTargetTypeTargetId>>, TError,{targetType: 'engine';targetId: string;data: HandlersCreateCommentRequest}, TContext> => {

const mutationKey = ['postCommentsTargetTypeTargetId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommentsTargetTypeTargetId>>, {targetType: 'engine';targetId: string;data: HandlersCreateCommentRequest}> = (props) => {
          const {targetType,targetId,data} = props ?? {};

          return  postCommentsTargetTypeTargetId(targetType,targetId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommentsTargetTypeTargetIdMutationResult = NonNullable<Awaited<ReturnType<typeof postCommentsTargetTypeTargetId>>>
    export type PostCommentsTargetTypeTargetIdMutationBody = HandlersCreateCommentRequest
    export type PostCommentsTargetTypeTargetIdMutationError = PostCommentsTargetTypeTargetId400 | PostCommentsTargetTypeTargetId404 | PostCommentsTargetTypeTargetId500

    /**
 * @summary 创建评论
 */
export const usePostCommentsTargetTypeTargetId = <TError = PostCommentsTargetTypeTargetId400 | PostCommentsTargetTypeTargetId404 | PostCommentsTargetTypeTargetId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommentsTargetTypeTargetId>>, TError,{targetType: 'engine';targetId: string;data: HandlersCreateCommentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommentsTargetTypeTargetId>>,
        TError,
        {targetType: 'engine';targetId: string;data: HandlersCreateCommentRequest},
        TContext
      > => {

      const mutationOptions = getPostCommentsTargetTypeTargetIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前活动信息（折扣、名称、结束时间）
 * @summary 获取活动配置
 */
export const getConfigActivity = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetConfigActivity200>(
      {url: `/config/activity`, method: 'GET', signal
    },
      );
    }
  



export const getGetConfigActivityQueryKey = () => {
    return [
    `/config/activity`
    ] as const;
    }

    
export const getGetConfigActivityQueryOptions = <TData = Awaited<ReturnType<typeof getConfigActivity>>, TError = GetConfigActivity500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigActivity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigActivityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigActivity>>> = ({ signal }) => getConfigActivity(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigActivity>>>
export type GetConfigActivityQueryError = GetConfigActivity500


export function useGetConfigActivity<TData = Awaited<ReturnType<typeof getConfigActivity>>, TError = GetConfigActivity500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigActivity>>,
          TError,
          Awaited<ReturnType<typeof getConfigActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigActivity<TData = Awaited<ReturnType<typeof getConfigActivity>>, TError = GetConfigActivity500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigActivity>>,
          TError,
          Awaited<ReturnType<typeof getConfigActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigActivity<TData = Awaited<ReturnType<typeof getConfigActivity>>, TError = GetConfigActivity500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigActivity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取活动配置
 */

export function useGetConfigActivity<TData = Awaited<ReturnType<typeof getConfigActivity>>, TError = GetConfigActivity500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigActivity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigActivityQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取管理端可编辑的帮助中心 FAQ 正文与飞书/QQ 群链接
 * @summary 获取帮助中心内容
 */
export const getConfigHelpCenter = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetConfigHelpCenter200>(
      {url: `/config/help-center`, method: 'GET', signal
    },
      );
    }
  



export const getGetConfigHelpCenterQueryKey = () => {
    return [
    `/config/help-center`
    ] as const;
    }

    
export const getGetConfigHelpCenterQueryOptions = <TData = Awaited<ReturnType<typeof getConfigHelpCenter>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigHelpCenter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigHelpCenterQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigHelpCenter>>> = ({ signal }) => getConfigHelpCenter(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigHelpCenter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigHelpCenterQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigHelpCenter>>>
export type GetConfigHelpCenterQueryError = unknown


export function useGetConfigHelpCenter<TData = Awaited<ReturnType<typeof getConfigHelpCenter>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigHelpCenter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigHelpCenter>>,
          TError,
          Awaited<ReturnType<typeof getConfigHelpCenter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigHelpCenter<TData = Awaited<ReturnType<typeof getConfigHelpCenter>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigHelpCenter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigHelpCenter>>,
          TError,
          Awaited<ReturnType<typeof getConfigHelpCenter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigHelpCenter<TData = Awaited<ReturnType<typeof getConfigHelpCenter>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigHelpCenter>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取帮助中心内容
 */

export function useGetConfigHelpCenter<TData = Awaited<ReturnType<typeof getConfigHelpCenter>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigHelpCenter>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigHelpCenterQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取当前汇率和消耗定价
 * @summary 获取定价配置
 */
export const getConfigPricing = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetConfigPricing200>(
      {url: `/config/pricing`, method: 'GET', signal
    },
      );
    }
  



export const getGetConfigPricingQueryKey = () => {
    return [
    `/config/pricing`
    ] as const;
    }

    
export const getGetConfigPricingQueryOptions = <TData = Awaited<ReturnType<typeof getConfigPricing>>, TError = GetConfigPricing500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigPricing>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigPricingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigPricing>>> = ({ signal }) => getConfigPricing(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigPricing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigPricingQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigPricing>>>
export type GetConfigPricingQueryError = GetConfigPricing500


export function useGetConfigPricing<TData = Awaited<ReturnType<typeof getConfigPricing>>, TError = GetConfigPricing500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigPricing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigPricing>>,
          TError,
          Awaited<ReturnType<typeof getConfigPricing>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigPricing<TData = Awaited<ReturnType<typeof getConfigPricing>>, TError = GetConfigPricing500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigPricing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigPricing>>,
          TError,
          Awaited<ReturnType<typeof getConfigPricing>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfigPricing<TData = Awaited<ReturnType<typeof getConfigPricing>>, TError = GetConfigPricing500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigPricing>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取定价配置
 */

export function useGetConfigPricing<TData = Awaited<ReturnType<typeof getConfigPricing>>, TError = GetConfigPricing500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigPricing>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigPricingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取公开的引擎场景列表，支持分页、分类筛选、标签筛选和搜索
 * @summary 发现场景
 */
export const getDiscoverScenes = (
    params?: GetDiscoverScenesParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetDiscoverScenes200>(
      {url: `/discover/scenes`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetDiscoverScenesQueryKey = (params?: GetDiscoverScenesParams,) => {
    return [
    `/discover/scenes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDiscoverScenesQueryOptions = <TData = Awaited<ReturnType<typeof getDiscoverScenes>>, TError = GetDiscoverScenes500>(params?: GetDiscoverScenesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverScenes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDiscoverScenesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscoverScenes>>> = ({ signal }) => getDiscoverScenes(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDiscoverScenes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDiscoverScenesQueryResult = NonNullable<Awaited<ReturnType<typeof getDiscoverScenes>>>
export type GetDiscoverScenesQueryError = GetDiscoverScenes500


export function useGetDiscoverScenes<TData = Awaited<ReturnType<typeof getDiscoverScenes>>, TError = GetDiscoverScenes500>(
 params: undefined |  GetDiscoverScenesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverScenes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscoverScenes>>,
          TError,
          Awaited<ReturnType<typeof getDiscoverScenes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscoverScenes<TData = Awaited<ReturnType<typeof getDiscoverScenes>>, TError = GetDiscoverScenes500>(
 params?: GetDiscoverScenesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverScenes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscoverScenes>>,
          TError,
          Awaited<ReturnType<typeof getDiscoverScenes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscoverScenes<TData = Awaited<ReturnType<typeof getDiscoverScenes>>, TError = GetDiscoverScenes500>(
 params?: GetDiscoverScenesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverScenes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 发现场景
 */

export function useGetDiscoverScenes<TData = Awaited<ReturnType<typeof getDiscoverScenes>>, TError = GetDiscoverScenes500>(
 params?: GetDiscoverScenesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverScenes>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDiscoverScenesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 搜索引擎和用户，支持多类型搜索和筛选
 * @summary 搜索内容
 */
export const postDiscoverSearch = (
    handlersSearchContentRequest: HandlersSearchContentRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostDiscoverSearch200>(
      {url: `/discover/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersSearchContentRequest, signal
    },
      );
    }
  


export const getPostDiscoverSearchMutationOptions = <TError = PostDiscoverSearch400 | PostDiscoverSearch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDiscoverSearch>>, TError,{data: HandlersSearchContentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postDiscoverSearch>>, TError,{data: HandlersSearchContentRequest}, TContext> => {

const mutationKey = ['postDiscoverSearch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDiscoverSearch>>, {data: HandlersSearchContentRequest}> = (props) => {
          const {data} = props ?? {};

          return  postDiscoverSearch(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDiscoverSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postDiscoverSearch>>>
    export type PostDiscoverSearchMutationBody = HandlersSearchContentRequest
    export type PostDiscoverSearchMutationError = PostDiscoverSearch400 | PostDiscoverSearch500

    /**
 * @summary 搜索内容
 */
export const usePostDiscoverSearch = <TError = PostDiscoverSearch400 | PostDiscoverSearch500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDiscoverSearch>>, TError,{data: HandlersSearchContentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDiscoverSearch>>,
        TError,
        {data: HandlersSearchContentRequest},
        TContext
      > => {

      const mutationOptions = getPostDiscoverSearchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取热门引擎列表
 * @summary 获取热门内容
 */
export const getDiscoverTrending = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetDiscoverTrending200>(
      {url: `/discover/trending`, method: 'GET', signal
    },
      );
    }
  



export const getGetDiscoverTrendingQueryKey = () => {
    return [
    `/discover/trending`
    ] as const;
    }

    
export const getGetDiscoverTrendingQueryOptions = <TData = Awaited<ReturnType<typeof getDiscoverTrending>>, TError = GetDiscoverTrending500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverTrending>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDiscoverTrendingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscoverTrending>>> = ({ signal }) => getDiscoverTrending(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDiscoverTrending>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDiscoverTrendingQueryResult = NonNullable<Awaited<ReturnType<typeof getDiscoverTrending>>>
export type GetDiscoverTrendingQueryError = GetDiscoverTrending500


export function useGetDiscoverTrending<TData = Awaited<ReturnType<typeof getDiscoverTrending>>, TError = GetDiscoverTrending500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverTrending>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscoverTrending>>,
          TError,
          Awaited<ReturnType<typeof getDiscoverTrending>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscoverTrending<TData = Awaited<ReturnType<typeof getDiscoverTrending>>, TError = GetDiscoverTrending500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverTrending>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDiscoverTrending>>,
          TError,
          Awaited<ReturnType<typeof getDiscoverTrending>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDiscoverTrending<TData = Awaited<ReturnType<typeof getDiscoverTrending>>, TError = GetDiscoverTrending500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverTrending>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取热门内容
 */

export function useGetDiscoverTrending<TData = Awaited<ReturnType<typeof getDiscoverTrending>>, TError = GetDiscoverTrending500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDiscoverTrending>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDiscoverTrendingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 删除指定的游玩会话
 * @summary 删除会话
 */
export const postEnginePlayDelete = (
    handlersDeleteSessionRequest: HandlersDeleteSessionRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersDeleteSessionResponse>(
      {url: `/engine-play/delete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersDeleteSessionRequest, signal
    },
      );
    }
  


export const getPostEnginePlayDeleteMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayDelete>>, TError,{data: HandlersDeleteSessionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayDelete>>, TError,{data: HandlersDeleteSessionRequest}, TContext> => {

const mutationKey = ['postEnginePlayDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlayDelete>>, {data: HandlersDeleteSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postEnginePlayDelete(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlayDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlayDelete>>>
    export type PostEnginePlayDeleteMutationBody = HandlersDeleteSessionRequest
    export type PostEnginePlayDeleteMutationError = HandlersResponseData

    /**
 * @summary 删除会话
 */
export const usePostEnginePlayDelete = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayDelete>>, TError,{data: HandlersDeleteSessionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlayDelete>>,
        TError,
        {data: HandlersDeleteSessionRequest},
        TContext
      > => {

      const mutationOptions = getPostEnginePlayDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前用户的所有游玩会话列表
 * @summary 获取我的会话列表
 */
export const getEnginePlayMysession = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersGetMySessionsResponse>(
      {url: `/engine-play/mysession`, method: 'GET', signal
    },
      );
    }
  



export const getGetEnginePlayMysessionQueryKey = () => {
    return [
    `/engine-play/mysession`
    ] as const;
    }

    
export const getGetEnginePlayMysessionQueryOptions = <TData = Awaited<ReturnType<typeof getEnginePlayMysession>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayMysession>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginePlayMysessionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnginePlayMysession>>> = ({ signal }) => getEnginePlayMysession(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayMysession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginePlayMysessionQueryResult = NonNullable<Awaited<ReturnType<typeof getEnginePlayMysession>>>
export type GetEnginePlayMysessionQueryError = HandlersResponseData


export function useGetEnginePlayMysession<TData = Awaited<ReturnType<typeof getEnginePlayMysession>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayMysession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlayMysession>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlayMysession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlayMysession<TData = Awaited<ReturnType<typeof getEnginePlayMysession>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayMysession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlayMysession>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlayMysession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlayMysession<TData = Awaited<ReturnType<typeof getEnginePlayMysession>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayMysession>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取我的会话列表
 */

export function useGetEnginePlayMysession<TData = Awaited<ReturnType<typeof getEnginePlayMysession>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayMysession>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginePlayMysessionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 创建一个新的引擎游玩会话（不检查已有活跃会话）
 * @summary 创建新会话
 */
export const postEnginePlayNew = (
    handlersNewSessionRequest: HandlersNewSessionRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersNewSessionResponse>(
      {url: `/engine-play/new`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersNewSessionRequest, signal
    },
      );
    }
  


export const getPostEnginePlayNewMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayNew>>, TError,{data: HandlersNewSessionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayNew>>, TError,{data: HandlersNewSessionRequest}, TContext> => {

const mutationKey = ['postEnginePlayNew'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlayNew>>, {data: HandlersNewSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postEnginePlayNew(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlayNewMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlayNew>>>
    export type PostEnginePlayNewMutationBody = HandlersNewSessionRequest
    export type PostEnginePlayNewMutationError = HandlersResponseData

    /**
 * @summary 创建新会话
 */
export const usePostEnginePlayNew = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayNew>>, TError,{data: HandlersNewSessionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlayNew>>,
        TError,
        {data: HandlersNewSessionRequest},
        TContext
      > => {

      const mutationOptions = getPostEnginePlayNewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 使用草稿或审核中版本数据调用 AI 生成预览内容，支持多轮对话。userInput 为空时返回开场白。
 * @summary 预览引擎
 */
export const postEnginePlayPreview = (
    handlersPreviewEngineRequest: HandlersPreviewEngineRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostEnginePlayPreview200>(
      {url: `/engine-play/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersPreviewEngineRequest, signal
    },
      );
    }
  


export const getPostEnginePlayPreviewMutationOptions = <TError = PostEnginePlayPreview400 | PostEnginePlayPreview401 | PostEnginePlayPreview403 | PostEnginePlayPreview500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayPreview>>, TError,{data: HandlersPreviewEngineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayPreview>>, TError,{data: HandlersPreviewEngineRequest}, TContext> => {

const mutationKey = ['postEnginePlayPreview'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlayPreview>>, {data: HandlersPreviewEngineRequest}> = (props) => {
          const {data} = props ?? {};

          return  postEnginePlayPreview(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlayPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlayPreview>>>
    export type PostEnginePlayPreviewMutationBody = HandlersPreviewEngineRequest
    export type PostEnginePlayPreviewMutationError = PostEnginePlayPreview400 | PostEnginePlayPreview401 | PostEnginePlayPreview403 | PostEnginePlayPreview500

    /**
 * @summary 预览引擎
 */
export const usePostEnginePlayPreview = <TError = PostEnginePlayPreview400 | PostEnginePlayPreview401 | PostEnginePlayPreview403 | PostEnginePlayPreview500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayPreview>>, TError,{data: HandlersPreviewEngineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlayPreview>>,
        TError,
        {data: HandlersPreviewEngineRequest},
        TContext
      > => {

      const mutationOptions = getPostEnginePlayPreviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取指定会话的详细信息
 * @summary 获取会话信息
 */
export const getEnginePlaySessionsSessionId = (
    sessionId: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetEnginePlaySessionsSessionId200>(
      {url: `/engine-play/sessions/${sessionId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetEnginePlaySessionsSessionIdQueryKey = (sessionId?: string,) => {
    return [
    `/engine-play/sessions/${sessionId}`
    ] as const;
    }

    
export const getGetEnginePlaySessionsSessionIdQueryOptions = <TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError = GetEnginePlaySessionsSessionId400 | GetEnginePlaySessionsSessionId401 | GetEnginePlaySessionsSessionId403 | GetEnginePlaySessionsSessionId404 | GetEnginePlaySessionsSessionId500>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginePlaySessionsSessionIdQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>> = ({ signal }) => getEnginePlaySessionsSessionId(sessionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginePlaySessionsSessionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>>
export type GetEnginePlaySessionsSessionIdQueryError = GetEnginePlaySessionsSessionId400 | GetEnginePlaySessionsSessionId401 | GetEnginePlaySessionsSessionId403 | GetEnginePlaySessionsSessionId404 | GetEnginePlaySessionsSessionId500


export function useGetEnginePlaySessionsSessionId<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError = GetEnginePlaySessionsSessionId400 | GetEnginePlaySessionsSessionId401 | GetEnginePlaySessionsSessionId403 | GetEnginePlaySessionsSessionId404 | GetEnginePlaySessionsSessionId500>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlaySessionsSessionId<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError = GetEnginePlaySessionsSessionId400 | GetEnginePlaySessionsSessionId401 | GetEnginePlaySessionsSessionId403 | GetEnginePlaySessionsSessionId404 | GetEnginePlaySessionsSessionId500>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlaySessionsSessionId<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError = GetEnginePlaySessionsSessionId400 | GetEnginePlaySessionsSessionId401 | GetEnginePlaySessionsSessionId403 | GetEnginePlaySessionsSessionId404 | GetEnginePlaySessionsSessionId500>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取会话信息
 */

export function useGetEnginePlaySessionsSessionId<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError = GetEnginePlaySessionsSessionId400 | GetEnginePlaySessionsSessionId401 | GetEnginePlaySessionsSessionId403 | GetEnginePlaySessionsSessionId404 | GetEnginePlaySessionsSessionId500>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginePlaySessionsSessionIdQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 结束指定的游玩会话
 * @summary 结束会话
 */
export const postEnginePlaySessionsSessionIdEnd = (
    sessionId: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostEnginePlaySessionsSessionIdEnd200>(
      {url: `/engine-play/sessions/${sessionId}/end`, method: 'POST', signal
    },
      );
    }
  


export const getPostEnginePlaySessionsSessionIdEndMutationOptions = <TError = PostEnginePlaySessionsSessionIdEnd400 | PostEnginePlaySessionsSessionIdEnd401 | PostEnginePlaySessionsSessionIdEnd403 | PostEnginePlaySessionsSessionIdEnd404 | PostEnginePlaySessionsSessionIdEnd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdEnd>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdEnd>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['postEnginePlaySessionsSessionIdEnd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdEnd>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  postEnginePlaySessionsSessionIdEnd(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlaySessionsSessionIdEndMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdEnd>>>
    
    export type PostEnginePlaySessionsSessionIdEndMutationError = PostEnginePlaySessionsSessionIdEnd400 | PostEnginePlaySessionsSessionIdEnd401 | PostEnginePlaySessionsSessionIdEnd403 | PostEnginePlaySessionsSessionIdEnd404 | PostEnginePlaySessionsSessionIdEnd500

    /**
 * @summary 结束会话
 */
export const usePostEnginePlaySessionsSessionIdEnd = <TError = PostEnginePlaySessionsSessionIdEnd400 | PostEnginePlaySessionsSessionIdEnd401 | PostEnginePlaySessionsSessionIdEnd403 | PostEnginePlaySessionsSessionIdEnd404 | PostEnginePlaySessionsSessionIdEnd500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdEnd>>, TError,{sessionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdEnd>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getPostEnginePlaySessionsSessionIdEndMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取指定会话的当前存档消息列表，支持基于游标的分页
 * @summary 获取会话消息
 */
export const getEnginePlaySessionsSessionIdMessages = (
    sessionId: string,
    params?: GetEnginePlaySessionsSessionIdMessagesParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersGetMessagesResponse>(
      {url: `/engine-play/sessions/${sessionId}/messages`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetEnginePlaySessionsSessionIdMessagesQueryKey = (sessionId?: string,
    params?: GetEnginePlaySessionsSessionIdMessagesParams,) => {
    return [
    `/engine-play/sessions/${sessionId}/messages`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEnginePlaySessionsSessionIdMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError = HandlersResponseData>(sessionId: string,
    params?: GetEnginePlaySessionsSessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginePlaySessionsSessionIdMessagesQueryKey(sessionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>> = ({ signal }) => getEnginePlaySessionsSessionIdMessages(sessionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginePlaySessionsSessionIdMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>>
export type GetEnginePlaySessionsSessionIdMessagesQueryError = HandlersResponseData


export function useGetEnginePlaySessionsSessionIdMessages<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError = HandlersResponseData>(
 sessionId: string,
    params: undefined |  GetEnginePlaySessionsSessionIdMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlaySessionsSessionIdMessages<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError = HandlersResponseData>(
 sessionId: string,
    params?: GetEnginePlaySessionsSessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlaySessionsSessionIdMessages<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError = HandlersResponseData>(
 sessionId: string,
    params?: GetEnginePlaySessionsSessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取会话消息
 */

export function useGetEnginePlaySessionsSessionIdMessages<TData = Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError = HandlersResponseData>(
 sessionId: string,
    params?: GetEnginePlaySessionsSessionIdMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlaySessionsSessionIdMessages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginePlaySessionsSessionIdMessagesQueryOptions(sessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 删除指定ID的消息（story_event）
 * @summary 删除消息
 */
export const postEnginePlaySessionsSessionIdMessagesMsgIdDelete = (
    sessionId: string,
    msgId: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/engine-play/sessions/${sessionId}/messages/${msgId}/delete`, method: 'POST', signal
    },
      );
    }
  


export const getPostEnginePlaySessionsSessionIdMessagesMsgIdDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdMessagesMsgIdDelete>>, TError,{sessionId: string;msgId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdMessagesMsgIdDelete>>, TError,{sessionId: string;msgId: string}, TContext> => {

const mutationKey = ['postEnginePlaySessionsSessionIdMessagesMsgIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdMessagesMsgIdDelete>>, {sessionId: string;msgId: string}> = (props) => {
          const {sessionId,msgId} = props ?? {};

          return  postEnginePlaySessionsSessionIdMessagesMsgIdDelete(sessionId,msgId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlaySessionsSessionIdMessagesMsgIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdMessagesMsgIdDelete>>>
    
    export type PostEnginePlaySessionsSessionIdMessagesMsgIdDeleteMutationError = unknown

    /**
 * @summary 删除消息
 */
export const usePostEnginePlaySessionsSessionIdMessagesMsgIdDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdMessagesMsgIdDelete>>, TError,{sessionId: string;msgId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdMessagesMsgIdDelete>>,
        TError,
        {sessionId: string;msgId: string},
        TContext
      > => {

      const mutationOptions = getPostEnginePlaySessionsSessionIdMessagesMsgIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 删除最后一条AI回复并基于上一条用户输入重新生成（异步，返回 taskId）
 * @summary 重新生成
 */
export const postEnginePlaySessionsSessionIdRegenerate = (
    sessionId: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData | HandlersResponseData>(
      {url: `/engine-play/sessions/${sessionId}/regenerate`, method: 'POST', signal
    },
      );
    }
  


export const getPostEnginePlaySessionsSessionIdRegenerateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRegenerate>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRegenerate>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['postEnginePlaySessionsSessionIdRegenerate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRegenerate>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  postEnginePlaySessionsSessionIdRegenerate(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlaySessionsSessionIdRegenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRegenerate>>>
    
    export type PostEnginePlaySessionsSessionIdRegenerateMutationError = unknown

    /**
 * @summary 重新生成
 */
export const usePostEnginePlaySessionsSessionIdRegenerate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRegenerate>>, TError,{sessionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRegenerate>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getPostEnginePlaySessionsSessionIdRegenerateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 重置会话状态，重新开始游玩
 * @summary 重新开始会话
 */
export const postEnginePlaySessionsSessionIdRestart = (
    sessionId: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostEnginePlaySessionsSessionIdRestart200>(
      {url: `/engine-play/sessions/${sessionId}/restart`, method: 'POST', signal
    },
      );
    }
  


export const getPostEnginePlaySessionsSessionIdRestartMutationOptions = <TError = PostEnginePlaySessionsSessionIdRestart400 | PostEnginePlaySessionsSessionIdRestart401 | PostEnginePlaySessionsSessionIdRestart403 | PostEnginePlaySessionsSessionIdRestart404 | PostEnginePlaySessionsSessionIdRestart500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRestart>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRestart>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['postEnginePlaySessionsSessionIdRestart'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRestart>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  postEnginePlaySessionsSessionIdRestart(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlaySessionsSessionIdRestartMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRestart>>>
    
    export type PostEnginePlaySessionsSessionIdRestartMutationError = PostEnginePlaySessionsSessionIdRestart400 | PostEnginePlaySessionsSessionIdRestart401 | PostEnginePlaySessionsSessionIdRestart403 | PostEnginePlaySessionsSessionIdRestart404 | PostEnginePlaySessionsSessionIdRestart500

    /**
 * @summary 重新开始会话
 */
export const usePostEnginePlaySessionsSessionIdRestart = <TError = PostEnginePlaySessionsSessionIdRestart400 | PostEnginePlaySessionsSessionIdRestart401 | PostEnginePlaySessionsSessionIdRestart403 | PostEnginePlaySessionsSessionIdRestart404 | PostEnginePlaySessionsSessionIdRestart500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRestart>>, TError,{sessionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlaySessionsSessionIdRestart>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getPostEnginePlaySessionsSessionIdRestartMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 开始一个新的引擎游玩会话
 * @summary 开始游玩
 */
export const postEnginePlayStart = (
    handlersStartEnginePlayRequestBody: HandlersStartEnginePlayRequestBody,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostEnginePlayStart200>(
      {url: `/engine-play/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersStartEnginePlayRequestBody, signal
    },
      );
    }
  


export const getPostEnginePlayStartMutationOptions = <TError = PostEnginePlayStart400 | PostEnginePlayStart401 | PostEnginePlayStart500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayStart>>, TError,{data: HandlersStartEnginePlayRequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayStart>>, TError,{data: HandlersStartEnginePlayRequestBody}, TContext> => {

const mutationKey = ['postEnginePlayStart'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginePlayStart>>, {data: HandlersStartEnginePlayRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  postEnginePlayStart(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginePlayStartMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginePlayStart>>>
    export type PostEnginePlayStartMutationBody = HandlersStartEnginePlayRequestBody
    export type PostEnginePlayStartMutationError = PostEnginePlayStart400 | PostEnginePlayStart401 | PostEnginePlayStart500

    /**
 * @summary 开始游玩
 */
export const usePostEnginePlayStart = <TError = PostEnginePlayStart400 | PostEnginePlayStart401 | PostEnginePlayStart500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginePlayStart>>, TError,{data: HandlersStartEnginePlayRequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginePlayStart>>,
        TError,
        {data: HandlersStartEnginePlayRequestBody},
        TContext
      > => {

      const mutationOptions = getPostEnginePlayStartMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取指定引擎的Token使用统计信息
 * @summary 获取Token统计
 */
export const getEnginePlayTokenStats = (
    params: GetEnginePlayTokenStatsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetEnginePlayTokenStats200>(
      {url: `/engine-play/token-stats`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetEnginePlayTokenStatsQueryKey = (params?: GetEnginePlayTokenStatsParams,) => {
    return [
    `/engine-play/token-stats`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEnginePlayTokenStatsQueryOptions = <TData = Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError = GetEnginePlayTokenStats400 | GetEnginePlayTokenStats403 | GetEnginePlayTokenStats404 | GetEnginePlayTokenStats500>(params: GetEnginePlayTokenStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginePlayTokenStatsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnginePlayTokenStats>>> = ({ signal }) => getEnginePlayTokenStats(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginePlayTokenStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getEnginePlayTokenStats>>>
export type GetEnginePlayTokenStatsQueryError = GetEnginePlayTokenStats400 | GetEnginePlayTokenStats403 | GetEnginePlayTokenStats404 | GetEnginePlayTokenStats500


export function useGetEnginePlayTokenStats<TData = Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError = GetEnginePlayTokenStats400 | GetEnginePlayTokenStats403 | GetEnginePlayTokenStats404 | GetEnginePlayTokenStats500>(
 params: GetEnginePlayTokenStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlayTokenStats>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlayTokenStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlayTokenStats<TData = Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError = GetEnginePlayTokenStats400 | GetEnginePlayTokenStats403 | GetEnginePlayTokenStats404 | GetEnginePlayTokenStats500>(
 params: GetEnginePlayTokenStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginePlayTokenStats>>,
          TError,
          Awaited<ReturnType<typeof getEnginePlayTokenStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginePlayTokenStats<TData = Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError = GetEnginePlayTokenStats400 | GetEnginePlayTokenStats403 | GetEnginePlayTokenStats404 | GetEnginePlayTokenStats500>(
 params: GetEnginePlayTokenStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取Token统计
 */

export function useGetEnginePlayTokenStats<TData = Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError = GetEnginePlayTokenStats400 | GetEnginePlayTokenStats403 | GetEnginePlayTokenStats404 | GetEnginePlayTokenStats500>(
 params: GetEnginePlayTokenStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginePlayTokenStats>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginePlayTokenStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取公开的引擎列表，支持分页、筛选和搜索
 * @summary 获取引擎列表
 */
export const getEngines = (
    params?: GetEnginesParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetEngines200>(
      {url: `/engines`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetEnginesQueryKey = (params?: GetEnginesParams,) => {
    return [
    `/engines`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEnginesQueryOptions = <TData = Awaited<ReturnType<typeof getEngines>>, TError = GetEngines500>(params?: GetEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngines>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEngines>>> = ({ signal }) => getEngines(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEngines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginesQueryResult = NonNullable<Awaited<ReturnType<typeof getEngines>>>
export type GetEnginesQueryError = GetEngines500


export function useGetEngines<TData = Awaited<ReturnType<typeof getEngines>>, TError = GetEngines500>(
 params: undefined |  GetEnginesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngines>>,
          TError,
          Awaited<ReturnType<typeof getEngines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEngines<TData = Awaited<ReturnType<typeof getEngines>>, TError = GetEngines500>(
 params?: GetEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngines>>,
          TError,
          Awaited<ReturnType<typeof getEngines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEngines<TData = Awaited<ReturnType<typeof getEngines>>, TError = GetEngines500>(
 params?: GetEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngines>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取引擎列表
 */

export function useGetEngines<TData = Awaited<ReturnType<typeof getEngines>>, TError = GetEngines500>(
 params?: GetEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEngines>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 创建新的引擎
 * @summary 创建引擎
 */
export const postEngines = (
    handlersCreateEngineRequest: HandlersCreateEngineRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostEngines201>(
      {url: `/engines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersCreateEngineRequest, signal
    },
      );
    }
  


export const getPostEnginesMutationOptions = <TError = PostEngines400 | PostEngines401 | PostEngines500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEngines>>, TError,{data: HandlersCreateEngineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEngines>>, TError,{data: HandlersCreateEngineRequest}, TContext> => {

const mutationKey = ['postEngines'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEngines>>, {data: HandlersCreateEngineRequest}> = (props) => {
          const {data} = props ?? {};

          return  postEngines(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginesMutationResult = NonNullable<Awaited<ReturnType<typeof postEngines>>>
    export type PostEnginesMutationBody = HandlersCreateEngineRequest
    export type PostEnginesMutationError = PostEngines400 | PostEngines401 | PostEngines500

    /**
 * @summary 创建引擎
 */
export const usePostEngines = <TError = PostEngines400 | PostEngines401 | PostEngines500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEngines>>, TError,{data: HandlersCreateEngineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEngines>>,
        TError,
        {data: HandlersCreateEngineRequest},
        TContext
      > => {

      const mutationOptions = getPostEnginesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前登录用户创建的引擎列表，支持分页、筛选和搜索
 * @summary 获取我的引擎列表
 */
export const getEnginesMy = (
    params?: GetEnginesMyParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetEnginesMy200>(
      {url: `/engines/my`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetEnginesMyQueryKey = (params?: GetEnginesMyParams,) => {
    return [
    `/engines/my`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEnginesMyQueryOptions = <TData = Awaited<ReturnType<typeof getEnginesMy>>, TError = GetEnginesMy401 | GetEnginesMy500>(params?: GetEnginesMyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesMy>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginesMyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnginesMy>>> = ({ signal }) => getEnginesMy(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnginesMy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginesMyQueryResult = NonNullable<Awaited<ReturnType<typeof getEnginesMy>>>
export type GetEnginesMyQueryError = GetEnginesMy401 | GetEnginesMy500


export function useGetEnginesMy<TData = Awaited<ReturnType<typeof getEnginesMy>>, TError = GetEnginesMy401 | GetEnginesMy500>(
 params: undefined |  GetEnginesMyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesMy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginesMy>>,
          TError,
          Awaited<ReturnType<typeof getEnginesMy>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginesMy<TData = Awaited<ReturnType<typeof getEnginesMy>>, TError = GetEnginesMy401 | GetEnginesMy500>(
 params?: GetEnginesMyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesMy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginesMy>>,
          TError,
          Awaited<ReturnType<typeof getEnginesMy>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginesMy<TData = Awaited<ReturnType<typeof getEnginesMy>>, TError = GetEnginesMy401 | GetEnginesMy500>(
 params?: GetEnginesMyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesMy>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取我的引擎列表
 */

export function useGetEnginesMy<TData = Awaited<ReturnType<typeof getEnginesMy>>, TError = GetEnginesMy401 | GetEnginesMy500>(
 params?: GetEnginesMyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesMy>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginesMyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取指定引擎的详细信息
 * @summary 获取引擎详情
 */
export const getEnginesId = (
    id: string,
    params?: GetEnginesIdParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetEnginesId200>(
      {url: `/engines/${id}`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetEnginesIdQueryKey = (id?: string,
    params?: GetEnginesIdParams,) => {
    return [
    `/engines/${id}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEnginesIdQueryOptions = <TData = Awaited<ReturnType<typeof getEnginesId>>, TError = GetEnginesId400 | GetEnginesId401 | GetEnginesId404 | GetEnginesId500>(id: string,
    params?: GetEnginesIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginesIdQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnginesId>>> = ({ signal }) => getEnginesId(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnginesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEnginesId>>>
export type GetEnginesIdQueryError = GetEnginesId400 | GetEnginesId401 | GetEnginesId404 | GetEnginesId500


export function useGetEnginesId<TData = Awaited<ReturnType<typeof getEnginesId>>, TError = GetEnginesId400 | GetEnginesId401 | GetEnginesId404 | GetEnginesId500>(
 id: string,
    params: undefined |  GetEnginesIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginesId>>,
          TError,
          Awaited<ReturnType<typeof getEnginesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginesId<TData = Awaited<ReturnType<typeof getEnginesId>>, TError = GetEnginesId400 | GetEnginesId401 | GetEnginesId404 | GetEnginesId500>(
 id: string,
    params?: GetEnginesIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginesId>>,
          TError,
          Awaited<ReturnType<typeof getEnginesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginesId<TData = Awaited<ReturnType<typeof getEnginesId>>, TError = GetEnginesId400 | GetEnginesId401 | GetEnginesId404 | GetEnginesId500>(
 id: string,
    params?: GetEnginesIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取引擎详情
 */

export function useGetEnginesId<TData = Awaited<ReturnType<typeof getEnginesId>>, TError = GetEnginesId400 | GetEnginesId401 | GetEnginesId404 | GetEnginesId500>(
 id: string,
    params?: GetEnginesIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginesIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 更新指定引擎的信息
 * @summary 更新引擎
 */
export const putEnginesId = (
    id: string,
    handlersUpdateEngineRequest: HandlersUpdateEngineRequest,
 ) => {
      
      
      return origin_point_engine_api<PutEnginesId200>(
      {url: `/engines/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersUpdateEngineRequest
    },
      );
    }
  


export const getPutEnginesIdMutationOptions = <TError = PutEnginesId400 | PutEnginesId401 | PutEnginesId403 | PutEnginesId404 | PutEnginesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesId>>, TError,{id: string;data: HandlersUpdateEngineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEnginesId>>, TError,{id: string;data: HandlersUpdateEngineRequest}, TContext> => {

const mutationKey = ['putEnginesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEnginesId>>, {id: string;data: HandlersUpdateEngineRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putEnginesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEnginesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEnginesId>>>
    export type PutEnginesIdMutationBody = HandlersUpdateEngineRequest
    export type PutEnginesIdMutationError = PutEnginesId400 | PutEnginesId401 | PutEnginesId403 | PutEnginesId404 | PutEnginesId500

    /**
 * @summary 更新引擎
 */
export const usePutEnginesId = <TError = PutEnginesId400 | PutEnginesId401 | PutEnginesId403 | PutEnginesId404 | PutEnginesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesId>>, TError,{id: string;data: HandlersUpdateEngineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEnginesId>>,
        TError,
        {id: string;data: HandlersUpdateEngineRequest},
        TContext
      > => {

      const mutationOptions = getPutEnginesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 删除指定的引擎（软删除）
 * @summary 删除引擎
 */
export const deleteEnginesId = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<DeleteEnginesId200>(
      {url: `/engines/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEnginesIdMutationOptions = <TError = DeleteEnginesId400 | DeleteEnginesId401 | DeleteEnginesId403 | DeleteEnginesId404 | DeleteEnginesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEnginesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEnginesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteEnginesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEnginesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEnginesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEnginesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEnginesId>>>
    
    export type DeleteEnginesIdMutationError = DeleteEnginesId400 | DeleteEnginesId401 | DeleteEnginesId403 | DeleteEnginesId404 | DeleteEnginesId500

    /**
 * @summary 删除引擎
 */
export const useDeleteEnginesId = <TError = DeleteEnginesId400 | DeleteEnginesId401 | DeleteEnginesId403 | DeleteEnginesId404 | DeleteEnginesId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEnginesId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEnginesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEnginesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取指定引擎当前使用的预设模板
 * @summary 获取引擎预设
 */
export const getEnginesIdPreset = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetEnginesIdPreset200>(
      {url: `/engines/${id}/preset`, method: 'GET', signal
    },
      );
    }
  



export const getGetEnginesIdPresetQueryKey = (id?: string,) => {
    return [
    `/engines/${id}/preset`
    ] as const;
    }

    
export const getGetEnginesIdPresetQueryOptions = <TData = Awaited<ReturnType<typeof getEnginesIdPreset>>, TError = GetEnginesIdPreset400 | GetEnginesIdPreset404>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesIdPreset>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEnginesIdPresetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnginesIdPreset>>> = ({ signal }) => getEnginesIdPreset(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEnginesIdPreset>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEnginesIdPresetQueryResult = NonNullable<Awaited<ReturnType<typeof getEnginesIdPreset>>>
export type GetEnginesIdPresetQueryError = GetEnginesIdPreset400 | GetEnginesIdPreset404


export function useGetEnginesIdPreset<TData = Awaited<ReturnType<typeof getEnginesIdPreset>>, TError = GetEnginesIdPreset400 | GetEnginesIdPreset404>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesIdPreset>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginesIdPreset>>,
          TError,
          Awaited<ReturnType<typeof getEnginesIdPreset>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginesIdPreset<TData = Awaited<ReturnType<typeof getEnginesIdPreset>>, TError = GetEnginesIdPreset400 | GetEnginesIdPreset404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesIdPreset>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnginesIdPreset>>,
          TError,
          Awaited<ReturnType<typeof getEnginesIdPreset>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEnginesIdPreset<TData = Awaited<ReturnType<typeof getEnginesIdPreset>>, TError = GetEnginesIdPreset400 | GetEnginesIdPreset404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesIdPreset>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取引擎预设
 */

export function useGetEnginesIdPreset<TData = Awaited<ReturnType<typeof getEnginesIdPreset>>, TError = GetEnginesIdPreset400 | GetEnginesIdPreset404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEnginesIdPreset>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEnginesIdPresetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 为指定引擎设置预设模板
 * @summary 设置引擎预设
 */
export const putEnginesIdPreset = (
    id: string,
    handlersSetEnginePresetRequest: HandlersSetEnginePresetRequest,
 ) => {
      
      
      return origin_point_engine_api<PutEnginesIdPreset200>(
      {url: `/engines/${id}/preset`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersSetEnginePresetRequest
    },
      );
    }
  


export const getPutEnginesIdPresetMutationOptions = <TError = PutEnginesIdPreset400 | PutEnginesIdPreset500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdPreset>>, TError,{id: string;data: HandlersSetEnginePresetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdPreset>>, TError,{id: string;data: HandlersSetEnginePresetRequest}, TContext> => {

const mutationKey = ['putEnginesIdPreset'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEnginesIdPreset>>, {id: string;data: HandlersSetEnginePresetRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putEnginesIdPreset(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEnginesIdPresetMutationResult = NonNullable<Awaited<ReturnType<typeof putEnginesIdPreset>>>
    export type PutEnginesIdPresetMutationBody = HandlersSetEnginePresetRequest
    export type PutEnginesIdPresetMutationError = PutEnginesIdPreset400 | PutEnginesIdPreset500

    /**
 * @summary 设置引擎预设
 */
export const usePutEnginesIdPreset = <TError = PutEnginesIdPreset400 | PutEnginesIdPreset500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdPreset>>, TError,{id: string;data: HandlersSetEnginePresetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEnginesIdPreset>>,
        TError,
        {id: string;data: HandlersSetEnginePresetRequest},
        TContext
      > => {

      const mutationOptions = getPutEnginesIdPresetMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 将引擎状态设置为已发布。支持幂等操作：如果引擎已发布，可重复调用以实现"更新发布"功能
 * @summary 发布引擎
 */
export const putEnginesIdPublish = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<PutEnginesIdPublish200>(
      {url: `/engines/${id}/publish`, method: 'PUT'
    },
      );
    }
  


export const getPutEnginesIdPublishMutationOptions = <TError = PutEnginesIdPublish400 | PutEnginesIdPublish401 | PutEnginesIdPublish403 | PutEnginesIdPublish404 | PutEnginesIdPublish500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdPublish>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdPublish>>, TError,{id: string}, TContext> => {

const mutationKey = ['putEnginesIdPublish'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEnginesIdPublish>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putEnginesIdPublish(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEnginesIdPublishMutationResult = NonNullable<Awaited<ReturnType<typeof putEnginesIdPublish>>>
    
    export type PutEnginesIdPublishMutationError = PutEnginesIdPublish400 | PutEnginesIdPublish401 | PutEnginesIdPublish403 | PutEnginesIdPublish404 | PutEnginesIdPublish500

    /**
 * @summary 发布引擎
 */
export const usePutEnginesIdPublish = <TError = PutEnginesIdPublish400 | PutEnginesIdPublish401 | PutEnginesIdPublish403 | PutEnginesIdPublish404 | PutEnginesIdPublish500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdPublish>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEnginesIdPublish>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutEnginesIdPublishMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 将引擎状态设置为草稿
 * @summary 取消发布引擎
 */
export const putEnginesIdUnpublish = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<PutEnginesIdUnpublish200>(
      {url: `/engines/${id}/unpublish`, method: 'PUT'
    },
      );
    }
  


export const getPutEnginesIdUnpublishMutationOptions = <TError = PutEnginesIdUnpublish400 | PutEnginesIdUnpublish401 | PutEnginesIdUnpublish403 | PutEnginesIdUnpublish404 | PutEnginesIdUnpublish500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdUnpublish>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdUnpublish>>, TError,{id: string}, TContext> => {

const mutationKey = ['putEnginesIdUnpublish'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEnginesIdUnpublish>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putEnginesIdUnpublish(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEnginesIdUnpublishMutationResult = NonNullable<Awaited<ReturnType<typeof putEnginesIdUnpublish>>>
    
    export type PutEnginesIdUnpublishMutationError = PutEnginesIdUnpublish400 | PutEnginesIdUnpublish401 | PutEnginesIdUnpublish403 | PutEnginesIdUnpublish404 | PutEnginesIdUnpublish500

    /**
 * @summary 取消发布引擎
 */
export const usePutEnginesIdUnpublish = <TError = PutEnginesIdUnpublish400 | PutEnginesIdUnpublish401 | PutEnginesIdUnpublish403 | PutEnginesIdUnpublish404 | PutEnginesIdUnpublish500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEnginesIdUnpublish>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEnginesIdUnpublish>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutEnginesIdUnpublishMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 将JSON格式的世界信息导入到指定引擎
 * @summary 导入世界信息
 */
export const postEnginesIdWorldInfoImport = (
    id: string,
    handlersImportWorldInfoRequest: HandlersImportWorldInfoRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostEnginesIdWorldInfoImport200>(
      {url: `/engines/${id}/world-info/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersImportWorldInfoRequest, signal
    },
      );
    }
  


export const getPostEnginesIdWorldInfoImportMutationOptions = <TError = PostEnginesIdWorldInfoImport400 | PostEnginesIdWorldInfoImport401 | PostEnginesIdWorldInfoImport403 | PostEnginesIdWorldInfoImport404 | PostEnginesIdWorldInfoImport500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginesIdWorldInfoImport>>, TError,{id: string;data: HandlersImportWorldInfoRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginesIdWorldInfoImport>>, TError,{id: string;data: HandlersImportWorldInfoRequest}, TContext> => {

const mutationKey = ['postEnginesIdWorldInfoImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginesIdWorldInfoImport>>, {id: string;data: HandlersImportWorldInfoRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postEnginesIdWorldInfoImport(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginesIdWorldInfoImportMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginesIdWorldInfoImport>>>
    export type PostEnginesIdWorldInfoImportMutationBody = HandlersImportWorldInfoRequest
    export type PostEnginesIdWorldInfoImportMutationError = PostEnginesIdWorldInfoImport400 | PostEnginesIdWorldInfoImport401 | PostEnginesIdWorldInfoImport403 | PostEnginesIdWorldInfoImport404 | PostEnginesIdWorldInfoImport500

    /**
 * @summary 导入世界信息
 */
export const usePostEnginesIdWorldInfoImport = <TError = PostEnginesIdWorldInfoImport400 | PostEnginesIdWorldInfoImport401 | PostEnginesIdWorldInfoImport403 | PostEnginesIdWorldInfoImport404 | PostEnginesIdWorldInfoImport500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginesIdWorldInfoImport>>, TError,{id: string;data: HandlersImportWorldInfoRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginesIdWorldInfoImport>>,
        TError,
        {id: string;data: HandlersImportWorldInfoRequest},
        TContext
      > => {

      const mutationOptions = getPostEnginesIdWorldInfoImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 验证世界信息导入文件的格式和内容，不实际导入
 * @summary 验证导入文件
 */
export const postEnginesIdWorldInfoValidateImport = (
    id: string,
    handlersValidateWorldInfoImportRequest: HandlersValidateWorldInfoImportRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostEnginesIdWorldInfoValidateImport200>(
      {url: `/engines/${id}/world-info/validate-import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersValidateWorldInfoImportRequest, signal
    },
      );
    }
  


export const getPostEnginesIdWorldInfoValidateImportMutationOptions = <TError = PostEnginesIdWorldInfoValidateImport400 | PostEnginesIdWorldInfoValidateImport404 | PostEnginesIdWorldInfoValidateImport500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginesIdWorldInfoValidateImport>>, TError,{id: string;data: HandlersValidateWorldInfoImportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEnginesIdWorldInfoValidateImport>>, TError,{id: string;data: HandlersValidateWorldInfoImportRequest}, TContext> => {

const mutationKey = ['postEnginesIdWorldInfoValidateImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEnginesIdWorldInfoValidateImport>>, {id: string;data: HandlersValidateWorldInfoImportRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postEnginesIdWorldInfoValidateImport(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEnginesIdWorldInfoValidateImportMutationResult = NonNullable<Awaited<ReturnType<typeof postEnginesIdWorldInfoValidateImport>>>
    export type PostEnginesIdWorldInfoValidateImportMutationBody = HandlersValidateWorldInfoImportRequest
    export type PostEnginesIdWorldInfoValidateImportMutationError = PostEnginesIdWorldInfoValidateImport400 | PostEnginesIdWorldInfoValidateImport404 | PostEnginesIdWorldInfoValidateImport500

    /**
 * @summary 验证导入文件
 */
export const usePostEnginesIdWorldInfoValidateImport = <TError = PostEnginesIdWorldInfoValidateImport400 | PostEnginesIdWorldInfoValidateImport404 | PostEnginesIdWorldInfoValidateImport500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEnginesIdWorldInfoValidateImport>>, TError,{id: string;data: HandlersValidateWorldInfoImportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEnginesIdWorldInfoValidateImport>>,
        TError,
        {id: string;data: HandlersValidateWorldInfoImportRequest},
        TContext
      > => {

      const mutationOptions = getPostEnginesIdWorldInfoValidateImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 游客做出选择并返回结果（消耗1轮）
 * @summary 游客做出选择
 */
export const postGuestEnginePlaySessionsSessionIdChoice = (
    sessionId: string,
    handlersMakeChoiceRequestBody: HandlersMakeChoiceRequestBody,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostGuestEnginePlaySessionsSessionIdChoice200>(
      {url: `/guest/engine-play/sessions/${sessionId}/choice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersMakeChoiceRequestBody, signal
    },
      );
    }
  


export const getPostGuestEnginePlaySessionsSessionIdChoiceMutationOptions = <TError = PostGuestEnginePlaySessionsSessionIdChoice400 | PostGuestEnginePlaySessionsSessionIdChoice403 | PostGuestEnginePlaySessionsSessionIdChoice404 | PostGuestEnginePlaySessionsSessionIdChoice500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuestEnginePlaySessionsSessionIdChoice>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postGuestEnginePlaySessionsSessionIdChoice>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext> => {

const mutationKey = ['postGuestEnginePlaySessionsSessionIdChoice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGuestEnginePlaySessionsSessionIdChoice>>, {sessionId: string;data: HandlersMakeChoiceRequestBody}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  postGuestEnginePlaySessionsSessionIdChoice(sessionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGuestEnginePlaySessionsSessionIdChoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postGuestEnginePlaySessionsSessionIdChoice>>>
    export type PostGuestEnginePlaySessionsSessionIdChoiceMutationBody = HandlersMakeChoiceRequestBody
    export type PostGuestEnginePlaySessionsSessionIdChoiceMutationError = PostGuestEnginePlaySessionsSessionIdChoice400 | PostGuestEnginePlaySessionsSessionIdChoice403 | PostGuestEnginePlaySessionsSessionIdChoice404 | PostGuestEnginePlaySessionsSessionIdChoice500

    /**
 * @summary 游客做出选择
 */
export const usePostGuestEnginePlaySessionsSessionIdChoice = <TError = PostGuestEnginePlaySessionsSessionIdChoice400 | PostGuestEnginePlaySessionsSessionIdChoice403 | PostGuestEnginePlaySessionsSessionIdChoice404 | PostGuestEnginePlaySessionsSessionIdChoice500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuestEnginePlaySessionsSessionIdChoice>>, TError,{sessionId: string;data: HandlersMakeChoiceRequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postGuestEnginePlaySessionsSessionIdChoice>>,
        TError,
        {sessionId: string;data: HandlersMakeChoiceRequestBody},
        TContext
      > => {

      const mutationOptions = getPostGuestEnginePlaySessionsSessionIdChoiceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 游客开始一个新的引擎游玩会话（不消费元点）
 * @summary 游客开始游玩
 */
export const postGuestEnginePlayStart = (
    handlersStartEnginePlayRequestBody: HandlersStartEnginePlayRequestBody,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostGuestEnginePlayStart200>(
      {url: `/guest/engine-play/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersStartEnginePlayRequestBody, signal
    },
      );
    }
  


export const getPostGuestEnginePlayStartMutationOptions = <TError = PostGuestEnginePlayStart400 | PostGuestEnginePlayStart403 | PostGuestEnginePlayStart500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuestEnginePlayStart>>, TError,{data: HandlersStartEnginePlayRequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postGuestEnginePlayStart>>, TError,{data: HandlersStartEnginePlayRequestBody}, TContext> => {

const mutationKey = ['postGuestEnginePlayStart'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGuestEnginePlayStart>>, {data: HandlersStartEnginePlayRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  postGuestEnginePlayStart(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGuestEnginePlayStartMutationResult = NonNullable<Awaited<ReturnType<typeof postGuestEnginePlayStart>>>
    export type PostGuestEnginePlayStartMutationBody = HandlersStartEnginePlayRequestBody
    export type PostGuestEnginePlayStartMutationError = PostGuestEnginePlayStart400 | PostGuestEnginePlayStart403 | PostGuestEnginePlayStart500

    /**
 * @summary 游客开始游玩
 */
export const usePostGuestEnginePlayStart = <TError = PostGuestEnginePlayStart400 | PostGuestEnginePlayStart403 | PostGuestEnginePlayStart500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuestEnginePlayStart>>, TError,{data: HandlersStartEnginePlayRequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postGuestEnginePlayStart>>,
        TError,
        {data: HandlersStartEnginePlayRequestBody},
        TContext
      > => {

      const mutationOptions = getPostGuestEnginePlayStartMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 游客注册为正式用户，并迁移游客数据
 * @summary 游客注册转换
 */
export const postGuestRegister = (
    handlersGuestRegisterRequest: HandlersGuestRegisterRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostGuestRegister200>(
      {url: `/guest/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersGuestRegisterRequest, signal
    },
      );
    }
  


export const getPostGuestRegisterMutationOptions = <TError = PostGuestRegister400 | PostGuestRegister500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuestRegister>>, TError,{data: HandlersGuestRegisterRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postGuestRegister>>, TError,{data: HandlersGuestRegisterRequest}, TContext> => {

const mutationKey = ['postGuestRegister'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGuestRegister>>, {data: HandlersGuestRegisterRequest}> = (props) => {
          const {data} = props ?? {};

          return  postGuestRegister(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGuestRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof postGuestRegister>>>
    export type PostGuestRegisterMutationBody = HandlersGuestRegisterRequest
    export type PostGuestRegisterMutationError = PostGuestRegister400 | PostGuestRegister500

    /**
 * @summary 游客注册转换
 */
export const usePostGuestRegister = <TError = PostGuestRegister400 | PostGuestRegister500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuestRegister>>, TError,{data: HandlersGuestRegisterRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postGuestRegister>>,
        TError,
        {data: HandlersGuestRegisterRequest},
        TContext
      > => {

      const mutationOptions = getPostGuestRegisterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前游客的游玩状态，包括轮次使用情况
 * @summary 获取游客状态
 */
export const getGuestStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetGuestStatus200>(
      {url: `/guest/status`, method: 'GET', signal
    },
      );
    }
  



export const getGetGuestStatusQueryKey = () => {
    return [
    `/guest/status`
    ] as const;
    }

    
export const getGetGuestStatusQueryOptions = <TData = Awaited<ReturnType<typeof getGuestStatus>>, TError = GetGuestStatus400 | GetGuestStatus500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestStatus>>> = ({ signal }) => getGuestStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestStatus>>>
export type GetGuestStatusQueryError = GetGuestStatus400 | GetGuestStatus500


export function useGetGuestStatus<TData = Awaited<ReturnType<typeof getGuestStatus>>, TError = GetGuestStatus400 | GetGuestStatus500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestStatus>>,
          TError,
          Awaited<ReturnType<typeof getGuestStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestStatus<TData = Awaited<ReturnType<typeof getGuestStatus>>, TError = GetGuestStatus400 | GetGuestStatus500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestStatus>>,
          TError,
          Awaited<ReturnType<typeof getGuestStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestStatus<TData = Awaited<ReturnType<typeof getGuestStatus>>, TError = GetGuestStatus400 | GetGuestStatus500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取游客状态
 */

export function useGetGuestStatus<TData = Awaited<ReturnType<typeof getGuestStatus>>, TError = GetGuestStatus400 | GetGuestStatus500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 健康检查
 */
export const getHealth = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetHealth200>(
      {url: `/health`, method: 'GET', signal
    },
      );
    }
  



export const getGetHealthQueryKey = () => {
    return [
    `/health`
    ] as const;
    }

    
export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = unknown


export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 健康检查
 */

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 获取我的私信列表
 */
export const getMeMessages = (
    params?: GetMeMessagesParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<unknown>(
      {url: `/me/messages`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetMeMessagesQueryKey = (params?: GetMeMessagesParams,) => {
    return [
    `/me/messages`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMeMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getMeMessages>>, TError = unknown>(params?: GetMeMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeMessagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeMessages>>> = ({ signal }) => getMeMessages(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getMeMessages>>>
export type GetMeMessagesQueryError = unknown


export function useGetMeMessages<TData = Awaited<ReturnType<typeof getMeMessages>>, TError = unknown>(
 params: undefined |  GetMeMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeMessages>>,
          TError,
          Awaited<ReturnType<typeof getMeMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeMessages<TData = Awaited<ReturnType<typeof getMeMessages>>, TError = unknown>(
 params?: GetMeMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeMessages>>,
          TError,
          Awaited<ReturnType<typeof getMeMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeMessages<TData = Awaited<ReturnType<typeof getMeMessages>>, TError = unknown>(
 params?: GetMeMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取我的私信列表
 */

export function useGetMeMessages<TData = Awaited<ReturnType<typeof getMeMessages>>, TError = unknown>(
 params?: GetMeMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessages>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 获取未读私信数量
 */
export const getMeMessagesUnreadCount = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<unknown>(
      {url: `/me/messages/unread-count`, method: 'GET', signal
    },
      );
    }
  



export const getGetMeMessagesUnreadCountQueryKey = () => {
    return [
    `/me/messages/unread-count`
    ] as const;
    }

    
export const getGetMeMessagesUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeMessagesUnreadCountQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>> = ({ signal }) => getMeMessagesUnreadCount(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeMessagesUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>>
export type GetMeMessagesUnreadCountQueryError = unknown


export function useGetMeMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeMessagesUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getMeMessagesUnreadCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeMessagesUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getMeMessagesUnreadCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取未读私信数量
 */

export function useGetMeMessagesUnreadCount<TData = Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeMessagesUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeMessagesUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 标记私信已读
 */
export const putMeMessagesIdRead = (
    id: string,
 ) => {
      
      
      return origin_point_engine_api<unknown>(
      {url: `/me/messages/${id}/read`, method: 'PUT'
    },
      );
    }
  


export const getPutMeMessagesIdReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMeMessagesIdRead>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMeMessagesIdRead>>, TError,{id: string}, TContext> => {

const mutationKey = ['putMeMessagesIdRead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMeMessagesIdRead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putMeMessagesIdRead(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMeMessagesIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof putMeMessagesIdRead>>>
    
    export type PutMeMessagesIdReadMutationError = unknown

    /**
 * @summary 标记私信已读
 */
export const usePutMeMessagesIdRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMeMessagesIdRead>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMeMessagesIdRead>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutMeMessagesIdReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 更新指定的角色记忆记录
 * @summary 更新角色记录
 */
export const putMemoryCharacterId = (
    id: string,
    requestBody: RequestBody,
 ) => {
      
      
      return origin_point_engine_api<PutMemoryCharacterId200>(
      {url: `/memory/character/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: requestBody
    },
      );
    }
  


export const getPutMemoryCharacterIdMutationOptions = <TError = PutMemoryCharacterId400 | PutMemoryCharacterId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryCharacterId>>, TError,{id: string;data: RequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMemoryCharacterId>>, TError,{id: string;data: RequestBody}, TContext> => {

const mutationKey = ['putMemoryCharacterId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMemoryCharacterId>>, {id: string;data: RequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putMemoryCharacterId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMemoryCharacterIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMemoryCharacterId>>>
    export type PutMemoryCharacterIdMutationBody = RequestBody
    export type PutMemoryCharacterIdMutationError = PutMemoryCharacterId400 | PutMemoryCharacterId500

    /**
 * @summary 更新角色记录
 */
export const usePutMemoryCharacterId = <TError = PutMemoryCharacterId400 | PutMemoryCharacterId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryCharacterId>>, TError,{id: string;data: RequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMemoryCharacterId>>,
        TError,
        {id: string;data: RequestBody},
        TContext
      > => {

      const mutationOptions = getPutMemoryCharacterIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 更新指定的物品记忆记录
 * @summary 更新物品记录
 */
export const putMemoryItemId = (
    id: string,
    requestBody: RequestBody,
 ) => {
      
      
      return origin_point_engine_api<PutMemoryItemId200>(
      {url: `/memory/item/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: requestBody
    },
      );
    }
  


export const getPutMemoryItemIdMutationOptions = <TError = PutMemoryItemId400 | PutMemoryItemId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryItemId>>, TError,{id: string;data: RequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMemoryItemId>>, TError,{id: string;data: RequestBody}, TContext> => {

const mutationKey = ['putMemoryItemId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMemoryItemId>>, {id: string;data: RequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putMemoryItemId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMemoryItemIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMemoryItemId>>>
    export type PutMemoryItemIdMutationBody = RequestBody
    export type PutMemoryItemIdMutationError = PutMemoryItemId400 | PutMemoryItemId500

    /**
 * @summary 更新物品记录
 */
export const usePutMemoryItemId = <TError = PutMemoryItemId400 | PutMemoryItemId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryItemId>>, TError,{id: string;data: RequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMemoryItemId>>,
        TError,
        {id: string;data: RequestBody},
        TContext
      > => {

      const mutationOptions = getPutMemoryItemIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 更新指定的角色关系记忆记录
 * @summary 更新关系记录
 */
export const putMemoryRelationshipId = (
    id: string,
    requestBody: RequestBody,
 ) => {
      
      
      return origin_point_engine_api<PutMemoryRelationshipId200>(
      {url: `/memory/relationship/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: requestBody
    },
      );
    }
  


export const getPutMemoryRelationshipIdMutationOptions = <TError = PutMemoryRelationshipId400 | PutMemoryRelationshipId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryRelationshipId>>, TError,{id: string;data: RequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMemoryRelationshipId>>, TError,{id: string;data: RequestBody}, TContext> => {

const mutationKey = ['putMemoryRelationshipId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMemoryRelationshipId>>, {id: string;data: RequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putMemoryRelationshipId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMemoryRelationshipIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMemoryRelationshipId>>>
    export type PutMemoryRelationshipIdMutationBody = RequestBody
    export type PutMemoryRelationshipIdMutationError = PutMemoryRelationshipId400 | PutMemoryRelationshipId500

    /**
 * @summary 更新关系记录
 */
export const usePutMemoryRelationshipId = <TError = PutMemoryRelationshipId400 | PutMemoryRelationshipId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryRelationshipId>>, TError,{id: string;data: RequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMemoryRelationshipId>>,
        TError,
        {id: string;data: RequestBody},
        TContext
      > => {

      const mutationOptions = getPutMemoryRelationshipIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取指定会话的所有记忆数据（时空、角色、关系、任务、事件、物品）
 * @summary 获取会话记忆
 */
export const getMemorySessionsSessionId = (
    sessionId: string,
    params?: GetMemorySessionsSessionIdParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetMemorySessionsSessionId200>(
      {url: `/memory/sessions/${sessionId}`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetMemorySessionsSessionIdQueryKey = (sessionId?: string,
    params?: GetMemorySessionsSessionIdParams,) => {
    return [
    `/memory/sessions/${sessionId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMemorySessionsSessionIdQueryOptions = <TData = Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError = GetMemorySessionsSessionId400 | GetMemorySessionsSessionId500>(sessionId: string,
    params?: GetMemorySessionsSessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMemorySessionsSessionIdQueryKey(sessionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemorySessionsSessionId>>> = ({ signal }) => getMemorySessionsSessionId(sessionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMemorySessionsSessionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMemorySessionsSessionId>>>
export type GetMemorySessionsSessionIdQueryError = GetMemorySessionsSessionId400 | GetMemorySessionsSessionId500


export function useGetMemorySessionsSessionId<TData = Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError = GetMemorySessionsSessionId400 | GetMemorySessionsSessionId500>(
 sessionId: string,
    params: undefined |  GetMemorySessionsSessionIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemorySessionsSessionId>>,
          TError,
          Awaited<ReturnType<typeof getMemorySessionsSessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemorySessionsSessionId<TData = Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError = GetMemorySessionsSessionId400 | GetMemorySessionsSessionId500>(
 sessionId: string,
    params?: GetMemorySessionsSessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemorySessionsSessionId>>,
          TError,
          Awaited<ReturnType<typeof getMemorySessionsSessionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMemorySessionsSessionId<TData = Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError = GetMemorySessionsSessionId400 | GetMemorySessionsSessionId500>(
 sessionId: string,
    params?: GetMemorySessionsSessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取会话记忆
 */

export function useGetMemorySessionsSessionId<TData = Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError = GetMemorySessionsSessionId400 | GetMemorySessionsSessionId500>(
 sessionId: string,
    params?: GetMemorySessionsSessionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMemorySessionsSessionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMemorySessionsSessionIdQueryOptions(sessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 更新指定的任务记忆记录
 * @summary 更新任务记录
 */
export const putMemoryTaskId = (
    id: string,
    requestBody: RequestBody,
 ) => {
      
      
      return origin_point_engine_api<PutMemoryTaskId200>(
      {url: `/memory/task/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: requestBody
    },
      );
    }
  


export const getPutMemoryTaskIdMutationOptions = <TError = PutMemoryTaskId400 | PutMemoryTaskId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryTaskId>>, TError,{id: string;data: RequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMemoryTaskId>>, TError,{id: string;data: RequestBody}, TContext> => {

const mutationKey = ['putMemoryTaskId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMemoryTaskId>>, {id: string;data: RequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putMemoryTaskId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMemoryTaskIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMemoryTaskId>>>
    export type PutMemoryTaskIdMutationBody = RequestBody
    export type PutMemoryTaskIdMutationError = PutMemoryTaskId400 | PutMemoryTaskId500

    /**
 * @summary 更新任务记录
 */
export const usePutMemoryTaskId = <TError = PutMemoryTaskId400 | PutMemoryTaskId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryTaskId>>, TError,{id: string;data: RequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMemoryTaskId>>,
        TError,
        {id: string;data: RequestBody},
        TContext
      > => {

      const mutationOptions = getPutMemoryTaskIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 更新指定的时空记忆记录
 * @summary 更新时空记录
 */
export const putMemoryTimespaceId = (
    id: string,
    requestBody: RequestBody,
 ) => {
      
      
      return origin_point_engine_api<PutMemoryTimespaceId200>(
      {url: `/memory/timespace/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: requestBody
    },
      );
    }
  


export const getPutMemoryTimespaceIdMutationOptions = <TError = PutMemoryTimespaceId400 | PutMemoryTimespaceId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryTimespaceId>>, TError,{id: string;data: RequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putMemoryTimespaceId>>, TError,{id: string;data: RequestBody}, TContext> => {

const mutationKey = ['putMemoryTimespaceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMemoryTimespaceId>>, {id: string;data: RequestBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putMemoryTimespaceId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMemoryTimespaceIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMemoryTimespaceId>>>
    export type PutMemoryTimespaceIdMutationBody = RequestBody
    export type PutMemoryTimespaceIdMutationError = PutMemoryTimespaceId400 | PutMemoryTimespaceId500

    /**
 * @summary 更新时空记录
 */
export const usePutMemoryTimespaceId = <TError = PutMemoryTimespaceId400 | PutMemoryTimespaceId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMemoryTimespaceId>>, TError,{id: string;data: RequestBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMemoryTimespaceId>>,
        TError,
        {id: string;data: RequestBody},
        TContext
      > => {

      const mutationOptions = getPutMemoryTimespaceIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 停用指定的记忆记录（软删除）
 * @summary 停用记忆记录
 */
export const deleteMemoryTableId = (
    table: 'timespace' | 'character' | 'relationship' | 'task' | 'event' | 'item',
    id: string,
 ) => {
      
      
      return origin_point_engine_api<DeleteMemoryTableId200>(
      {url: `/memory/${table}/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteMemoryTableIdMutationOptions = <TError = DeleteMemoryTableId400 | DeleteMemoryTableId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemoryTableId>>, TError,{table: 'timespace' | 'character' | 'relationship' | 'task' | 'event' | 'item';id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteMemoryTableId>>, TError,{table: 'timespace' | 'character' | 'relationship' | 'task' | 'event' | 'item';id: string}, TContext> => {

const mutationKey = ['deleteMemoryTableId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMemoryTableId>>, {table: 'timespace' | 'character' | 'relationship' | 'task' | 'event' | 'item';id: string}> = (props) => {
          const {table,id} = props ?? {};

          return  deleteMemoryTableId(table,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMemoryTableIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMemoryTableId>>>
    
    export type DeleteMemoryTableIdMutationError = DeleteMemoryTableId400 | DeleteMemoryTableId500

    /**
 * @summary 停用记忆记录
 */
export const useDeleteMemoryTableId = <TError = DeleteMemoryTableId400 | DeleteMemoryTableId500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMemoryTableId>>, TError,{table: 'timespace' | 'character' | 'relationship' | 'task' | 'event' | 'item';id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMemoryTableId>>,
        TError,
        {table: 'timespace' | 'character' | 'relationship' | 'task' | 'event' | 'item';id: string},
        TContext
      > => {

      const mutationOptions = getDeleteMemoryTableIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前用户的元点余额及会员信息
 * @summary 获取用户余额
 */
export const getPaymentBalance = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPaymentBalance200>(
      {url: `/payment/balance`, method: 'GET', signal
    },
      );
    }
  



export const getGetPaymentBalanceQueryKey = () => {
    return [
    `/payment/balance`
    ] as const;
    }

    
export const getGetPaymentBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentBalance>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentBalanceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentBalance>>> = ({ signal }) => getPaymentBalance(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentBalance>>>
export type GetPaymentBalanceQueryError = HandlersResponseData


export function useGetPaymentBalance<TData = Awaited<ReturnType<typeof getPaymentBalance>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentBalance>>,
          TError,
          Awaited<ReturnType<typeof getPaymentBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentBalance<TData = Awaited<ReturnType<typeof getPaymentBalance>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentBalance>>,
          TError,
          Awaited<ReturnType<typeof getPaymentBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentBalance<TData = Awaited<ReturnType<typeof getPaymentBalance>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取用户余额
 */

export function useGetPaymentBalance<TData = Awaited<ReturnType<typeof getPaymentBalance>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentBalance>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentBalanceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 检查用户是否有足够余额（返回布尔值和当前余额）
 * @summary 检查余额
 */
export const getPaymentCheckBalance = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPaymentCheckBalance200>(
      {url: `/payment/check-balance`, method: 'GET', signal
    },
      );
    }
  



export const getGetPaymentCheckBalanceQueryKey = () => {
    return [
    `/payment/check-balance`
    ] as const;
    }

    
export const getGetPaymentCheckBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentCheckBalanceQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentCheckBalance>>> = ({ signal }) => getPaymentCheckBalance(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentCheckBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentCheckBalance>>>
export type GetPaymentCheckBalanceQueryError = HandlersResponseData


export function useGetPaymentCheckBalance<TData = Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentCheckBalance>>,
          TError,
          Awaited<ReturnType<typeof getPaymentCheckBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentCheckBalance<TData = Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentCheckBalance>>,
          TError,
          Awaited<ReturnType<typeof getPaymentCheckBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentCheckBalance<TData = Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 检查余额
 */

export function useGetPaymentCheckBalance<TData = Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentCheckBalance>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentCheckBalanceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取支付相关的系统配置（如价格、汇率）
 * @summary 获取支付配置
 */
export const getPaymentConfig = (
    params?: GetPaymentConfigParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPaymentConfig200>(
      {url: `/payment/config`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPaymentConfigQueryKey = (params?: GetPaymentConfigParams,) => {
    return [
    `/payment/config`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaymentConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentConfig>>, TError = HandlersResponseData>(params?: GetPaymentConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentConfigQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentConfig>>> = ({ signal }) => getPaymentConfig(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentConfig>>>
export type GetPaymentConfigQueryError = HandlersResponseData


export function useGetPaymentConfig<TData = Awaited<ReturnType<typeof getPaymentConfig>>, TError = HandlersResponseData>(
 params: undefined |  GetPaymentConfigParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentConfig>>,
          TError,
          Awaited<ReturnType<typeof getPaymentConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentConfig<TData = Awaited<ReturnType<typeof getPaymentConfig>>, TError = HandlersResponseData>(
 params?: GetPaymentConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentConfig>>,
          TError,
          Awaited<ReturnType<typeof getPaymentConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentConfig<TData = Awaited<ReturnType<typeof getPaymentConfig>>, TError = HandlersResponseData>(
 params?: GetPaymentConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取支付配置
 */

export function useGetPaymentConfig<TData = Awaited<ReturnType<typeof getPaymentConfig>>, TError = HandlersResponseData>(
 params?: GetPaymentConfigParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentConfigQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 创建充值或月卡购买订单
 * @summary 创建支付订单
 */
export const postPaymentOrder = (
    handlerCreatePaymentOrderRequest: HandlerCreatePaymentOrderRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostPaymentOrder201>(
      {url: `/payment/order`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlerCreatePaymentOrderRequest, signal
    },
      );
    }
  


export const getPostPaymentOrderMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentOrder>>, TError,{data: HandlerCreatePaymentOrderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPaymentOrder>>, TError,{data: HandlerCreatePaymentOrderRequest}, TContext> => {

const mutationKey = ['postPaymentOrder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPaymentOrder>>, {data: HandlerCreatePaymentOrderRequest}> = (props) => {
          const {data} = props ?? {};

          return  postPaymentOrder(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPaymentOrderMutationResult = NonNullable<Awaited<ReturnType<typeof postPaymentOrder>>>
    export type PostPaymentOrderMutationBody = HandlerCreatePaymentOrderRequest
    export type PostPaymentOrderMutationError = HandlersResponseData

    /**
 * @summary 创建支付订单
 */
export const usePostPaymentOrder = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentOrder>>, TError,{data: HandlerCreatePaymentOrderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPaymentOrder>>,
        TError,
        {data: HandlerCreatePaymentOrderRequest},
        TContext
      > => {

      const mutationOptions = getPostPaymentOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 根据订单号查询支付订单详情及状态
 * @summary 查询订单状态
 */
export const getPaymentOrderOrderNoStatus = (
    orderNo: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPaymentOrderOrderNoStatus200>(
      {url: `/payment/order/${orderNo}/status`, method: 'GET', signal
    },
      );
    }
  



export const getGetPaymentOrderOrderNoStatusQueryKey = (orderNo?: string,) => {
    return [
    `/payment/order/${orderNo}/status`
    ] as const;
    }

    
export const getGetPaymentOrderOrderNoStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError = HandlersResponseData>(orderNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentOrderOrderNoStatusQueryKey(orderNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>> = ({ signal }) => getPaymentOrderOrderNoStatus(orderNo, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentOrderOrderNoStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>>
export type GetPaymentOrderOrderNoStatusQueryError = HandlersResponseData


export function useGetPaymentOrderOrderNoStatus<TData = Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError = HandlersResponseData>(
 orderNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>,
          TError,
          Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentOrderOrderNoStatus<TData = Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError = HandlersResponseData>(
 orderNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>,
          TError,
          Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentOrderOrderNoStatus<TData = Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError = HandlersResponseData>(
 orderNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 查询订单状态
 */

export function useGetPaymentOrderOrderNoStatus<TData = Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError = HandlersResponseData>(
 orderNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentOrderOrderNoStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentOrderOrderNoStatusQueryOptions(orderNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取所有可购买的通行证配置及当前用户的通行证状态
 * @summary 获取通行证列表
 */
export const getPaymentPasses = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPaymentPasses200>(
      {url: `/payment/passes`, method: 'GET', signal
    },
      );
    }
  



export const getGetPaymentPassesQueryKey = () => {
    return [
    `/payment/passes`
    ] as const;
    }

    
export const getGetPaymentPassesQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentPasses>>, TError = GetPaymentPasses401 | GetPaymentPasses500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPasses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentPassesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentPasses>>> = ({ signal }) => getPaymentPasses(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentPasses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentPassesQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentPasses>>>
export type GetPaymentPassesQueryError = GetPaymentPasses401 | GetPaymentPasses500


export function useGetPaymentPasses<TData = Awaited<ReturnType<typeof getPaymentPasses>>, TError = GetPaymentPasses401 | GetPaymentPasses500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPasses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentPasses>>,
          TError,
          Awaited<ReturnType<typeof getPaymentPasses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentPasses<TData = Awaited<ReturnType<typeof getPaymentPasses>>, TError = GetPaymentPasses401 | GetPaymentPasses500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPasses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentPasses>>,
          TError,
          Awaited<ReturnType<typeof getPaymentPasses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentPasses<TData = Awaited<ReturnType<typeof getPaymentPasses>>, TError = GetPaymentPasses401 | GetPaymentPasses500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPasses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取通行证列表
 */

export function useGetPaymentPasses<TData = Awaited<ReturnType<typeof getPaymentPasses>>, TError = GetPaymentPasses401 | GetPaymentPasses500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPasses>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentPassesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 验证当前用户是否可以购买指定类型的通行证（检查叠加上限）
 * @summary 验证通行证购买
 */
export const postPaymentPassesValidate = (
    postPaymentPassesValidateBody: PostPaymentPassesValidateBody,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostPaymentPassesValidate200>(
      {url: `/payment/passes/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postPaymentPassesValidateBody, signal
    },
      );
    }
  


export const getPostPaymentPassesValidateMutationOptions = <TError = PostPaymentPassesValidate400 | PostPaymentPassesValidate401 | PostPaymentPassesValidate500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentPassesValidate>>, TError,{data: PostPaymentPassesValidateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPaymentPassesValidate>>, TError,{data: PostPaymentPassesValidateBody}, TContext> => {

const mutationKey = ['postPaymentPassesValidate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPaymentPassesValidate>>, {data: PostPaymentPassesValidateBody}> = (props) => {
          const {data} = props ?? {};

          return  postPaymentPassesValidate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPaymentPassesValidateMutationResult = NonNullable<Awaited<ReturnType<typeof postPaymentPassesValidate>>>
    export type PostPaymentPassesValidateMutationBody = PostPaymentPassesValidateBody
    export type PostPaymentPassesValidateMutationError = PostPaymentPassesValidate400 | PostPaymentPassesValidate401 | PostPaymentPassesValidate500

    /**
 * @summary 验证通行证购买
 */
export const usePostPaymentPassesValidate = <TError = PostPaymentPassesValidate400 | PostPaymentPassesValidate401 | PostPaymentPassesValidate500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentPassesValidate>>, TError,{data: PostPaymentPassesValidateBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPaymentPassesValidate>>,
        TError,
        {data: PostPaymentPassesValidateBody},
        TContext
      > => {

      const mutationOptions = getPostPaymentPassesValidateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前汇率、消耗定价和活动信息
 * @summary 获取定价信息
 */
export const getPaymentPricing = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPaymentPricing200>(
      {url: `/payment/pricing`, method: 'GET', signal
    },
      );
    }
  



export const getGetPaymentPricingQueryKey = () => {
    return [
    `/payment/pricing`
    ] as const;
    }

    
export const getGetPaymentPricingQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentPricing>>, TError = GetPaymentPricing500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPricing>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentPricingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentPricing>>> = ({ signal }) => getPaymentPricing(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentPricing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentPricingQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentPricing>>>
export type GetPaymentPricingQueryError = GetPaymentPricing500


export function useGetPaymentPricing<TData = Awaited<ReturnType<typeof getPaymentPricing>>, TError = GetPaymentPricing500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPricing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentPricing>>,
          TError,
          Awaited<ReturnType<typeof getPaymentPricing>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentPricing<TData = Awaited<ReturnType<typeof getPaymentPricing>>, TError = GetPaymentPricing500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPricing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentPricing>>,
          TError,
          Awaited<ReturnType<typeof getPaymentPricing>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentPricing<TData = Awaited<ReturnType<typeof getPaymentPricing>>, TError = GetPaymentPricing500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPricing>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取定价信息
 */

export function useGetPaymentPricing<TData = Awaited<ReturnType<typeof getPaymentPricing>>, TError = GetPaymentPricing500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentPricing>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentPricingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 接收支付宝页面跳转，主动查询订单状态并验证
 * @summary 支付宝同步跳转
 */
export const getPaymentResult = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<unknown>(
      {url: `/payment/result`, method: 'GET', signal
    },
      );
    }
  



export const getGetPaymentResultQueryKey = () => {
    return [
    `/payment/result`
    ] as const;
    }

    
export const getGetPaymentResultQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentResult>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentResult>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentResultQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentResult>>> = ({ signal }) => getPaymentResult(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentResultQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentResult>>>
export type GetPaymentResultQueryError = unknown


export function useGetPaymentResult<TData = Awaited<ReturnType<typeof getPaymentResult>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentResult>>,
          TError,
          Awaited<ReturnType<typeof getPaymentResult>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentResult<TData = Awaited<ReturnType<typeof getPaymentResult>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentResult>>,
          TError,
          Awaited<ReturnType<typeof getPaymentResult>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentResult<TData = Awaited<ReturnType<typeof getPaymentResult>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentResult>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 支付宝同步跳转
 */

export function useGetPaymentResult<TData = Awaited<ReturnType<typeof getPaymentResult>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentResult>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentResultQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 手动触发支付成功回调逻辑（仅测试环境或开发环境）
 * @summary 模拟支付成功
 */
export const postPaymentSimulate = (
    handlerSimulatePaymentRequest: HandlerSimulatePaymentRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/payment/simulate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlerSimulatePaymentRequest, signal
    },
      );
    }
  


export const getPostPaymentSimulateMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentSimulate>>, TError,{data: HandlerSimulatePaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postPaymentSimulate>>, TError,{data: HandlerSimulatePaymentRequest}, TContext> => {

const mutationKey = ['postPaymentSimulate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPaymentSimulate>>, {data: HandlerSimulatePaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  postPaymentSimulate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPaymentSimulateMutationResult = NonNullable<Awaited<ReturnType<typeof postPaymentSimulate>>>
    export type PostPaymentSimulateMutationBody = HandlerSimulatePaymentRequest
    export type PostPaymentSimulateMutationError = HandlersResponseData

    /**
 * @summary 模拟支付成功
 */
export const usePostPaymentSimulate = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentSimulate>>, TError,{data: HandlerSimulatePaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPaymentSimulate>>,
        TError,
        {data: HandlerSimulatePaymentRequest},
        TContext
      > => {

      const mutationOptions = getPostPaymentSimulateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 分页获取用户的交易历史记录
 * @summary 获取交易记录
 */
export const getPaymentTransactions = (
    params?: GetPaymentTransactionsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPaymentTransactions200>(
      {url: `/payment/transactions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPaymentTransactionsQueryKey = (params?: GetPaymentTransactionsParams,) => {
    return [
    `/payment/transactions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaymentTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentTransactions>>, TError = HandlersResponseData>(params?: GetPaymentTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentTransactions>>> = ({ signal }) => getPaymentTransactions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentTransactions>>>
export type GetPaymentTransactionsQueryError = HandlersResponseData


export function useGetPaymentTransactions<TData = Awaited<ReturnType<typeof getPaymentTransactions>>, TError = HandlersResponseData>(
 params: undefined |  GetPaymentTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTransactions>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTransactions<TData = Awaited<ReturnType<typeof getPaymentTransactions>>, TError = HandlersResponseData>(
 params?: GetPaymentTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentTransactions>>,
          TError,
          Awaited<ReturnType<typeof getPaymentTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentTransactions<TData = Awaited<ReturnType<typeof getPaymentTransactions>>, TError = HandlersResponseData>(
 params?: GetPaymentTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取交易记录
 */

export function useGetPaymentTransactions<TData = Awaited<ReturnType<typeof getPaymentTransactions>>, TError = HandlersResponseData>(
 params?: GetPaymentTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取所有启用的预设模板（代入/互动/小说模式）
 * @summary 获取预设模板列表
 */
export const getPromptPresets = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPromptPresets200>(
      {url: `/prompt-presets`, method: 'GET', signal
    },
      );
    }
  



export const getGetPromptPresetsQueryKey = () => {
    return [
    `/prompt-presets`
    ] as const;
    }

    
export const getGetPromptPresetsQueryOptions = <TData = Awaited<ReturnType<typeof getPromptPresets>>, TError = GetPromptPresets500>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptPresetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptPresets>>> = ({ signal }) => getPromptPresets(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptPresets>>>
export type GetPromptPresetsQueryError = GetPromptPresets500


export function useGetPromptPresets<TData = Awaited<ReturnType<typeof getPromptPresets>>, TError = GetPromptPresets500>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptPresets>>,
          TError,
          Awaited<ReturnType<typeof getPromptPresets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptPresets<TData = Awaited<ReturnType<typeof getPromptPresets>>, TError = GetPromptPresets500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptPresets>>,
          TError,
          Awaited<ReturnType<typeof getPromptPresets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptPresets<TData = Awaited<ReturnType<typeof getPromptPresets>>, TError = GetPromptPresets500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取预设模板列表
 */

export function useGetPromptPresets<TData = Awaited<ReturnType<typeof getPromptPresets>>, TError = GetPromptPresets500>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresets>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptPresetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 根据ID获取单个预设模板
 * @summary 获取预设模板详情
 */
export const getPromptPresetsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPromptPresetsId200>(
      {url: `/prompt-presets/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetPromptPresetsIdQueryKey = (id?: string,) => {
    return [
    `/prompt-presets/${id}`
    ] as const;
    }

    
export const getGetPromptPresetsIdQueryOptions = <TData = Awaited<ReturnType<typeof getPromptPresetsId>>, TError = GetPromptPresetsId400 | GetPromptPresetsId404>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresetsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptPresetsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptPresetsId>>> = ({ signal }) => getPromptPresetsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptPresetsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptPresetsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptPresetsId>>>
export type GetPromptPresetsIdQueryError = GetPromptPresetsId400 | GetPromptPresetsId404


export function useGetPromptPresetsId<TData = Awaited<ReturnType<typeof getPromptPresetsId>>, TError = GetPromptPresetsId400 | GetPromptPresetsId404>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresetsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptPresetsId>>,
          TError,
          Awaited<ReturnType<typeof getPromptPresetsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptPresetsId<TData = Awaited<ReturnType<typeof getPromptPresetsId>>, TError = GetPromptPresetsId400 | GetPromptPresetsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresetsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptPresetsId>>,
          TError,
          Awaited<ReturnType<typeof getPromptPresetsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptPresetsId<TData = Awaited<ReturnType<typeof getPromptPresetsId>>, TError = GetPromptPresetsId400 | GetPromptPresetsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresetsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取预设模板详情
 */

export function useGetPromptPresetsId<TData = Awaited<ReturnType<typeof getPromptPresetsId>>, TError = GetPromptPresetsId400 | GetPromptPresetsId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptPresetsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptPresetsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取当前的人民币到元点的兑换比例（公开接口）
 * @summary 获取公开汇率
 */
export const getPublicPriceConfigsExchangeRate = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetPublicPriceConfigsExchangeRate200>(
      {url: `/public/price-configs/exchange-rate`, method: 'GET', signal
    },
      );
    }
  



export const getGetPublicPriceConfigsExchangeRateQueryKey = () => {
    return [
    `/public/price-configs/exchange-rate`
    ] as const;
    }

    
export const getGetPublicPriceConfigsExchangeRateQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPriceConfigsExchangeRateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>> = ({ signal }) => getPublicPriceConfigsExchangeRate(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicPriceConfigsExchangeRateQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>>
export type GetPublicPriceConfigsExchangeRateQueryError = unknown


export function useGetPublicPriceConfigsExchangeRate<TData = Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>,
          TError,
          Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPriceConfigsExchangeRate<TData = Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>,
          TError,
          Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPriceConfigsExchangeRate<TData = Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取公开汇率
 */

export function useGetPublicPriceConfigsExchangeRate<TData = Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPriceConfigsExchangeRate>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicPriceConfigsExchangeRateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 记录用户对引擎的消费或AI使用
 * @summary 记录消费
 */
export const postSettlementConsumption = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<unknown>(
      {url: `/settlement/consumption`, method: 'POST', signal
    },
      );
    }
  


export const getPostSettlementConsumptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettlementConsumption>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postSettlementConsumption>>, TError,void, TContext> => {

const mutationKey = ['postSettlementConsumption'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSettlementConsumption>>, void> = () => {
          

          return  postSettlementConsumption()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSettlementConsumptionMutationResult = NonNullable<Awaited<ReturnType<typeof postSettlementConsumption>>>
    
    export type PostSettlementConsumptionMutationError = unknown

    /**
 * @summary 记录消费
 */
export const usePostSettlementConsumption = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettlementConsumption>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSettlementConsumption>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostSettlementConsumptionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * super_admin 专属：获取所有 admin/super_admin 账号及其权限配置
 * @summary 获取管理员列表
 */
export const getSuperAdminAdmins = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetSuperAdminAdmins200>(
      {url: `/super-admin/admins`, method: 'GET', signal
    },
      );
    }
  



export const getGetSuperAdminAdminsQueryKey = () => {
    return [
    `/super-admin/admins`
    ] as const;
    }

    
export const getGetSuperAdminAdminsQueryOptions = <TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuperAdminAdminsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperAdminAdmins>>> = ({ signal }) => getSuperAdminAdmins(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperAdminAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof getSuperAdminAdmins>>>
export type GetSuperAdminAdminsQueryError = unknown


export function useGetSuperAdminAdmins<TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminAdmins>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminAdmins>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminAdmins<TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperAdminAdmins>>,
          TError,
          Awaited<ReturnType<typeof getSuperAdminAdmins>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperAdminAdmins<TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取管理员列表
 */

export function useGetSuperAdminAdmins<TData = Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperAdminAdmins>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuperAdminAdminsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * super_admin 专属：替换指定 admin 的全部权限配置
 * @summary 更新管理员权限
 */
export const putSuperAdminAdminsIdPermissions = (
    id: string,
    adminUpdateAdminPermissionsRequest: AdminUpdateAdminPermissionsRequest,
 ) => {
      
      
      return origin_point_engine_api<PutSuperAdminAdminsIdPermissions200>(
      {url: `/super-admin/admins/${id}/permissions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUpdateAdminPermissionsRequest
    },
      );
    }
  


export const getPutSuperAdminAdminsIdPermissionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSuperAdminAdminsIdPermissions>>, TError,{id: string;data: AdminUpdateAdminPermissionsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putSuperAdminAdminsIdPermissions>>, TError,{id: string;data: AdminUpdateAdminPermissionsRequest}, TContext> => {

const mutationKey = ['putSuperAdminAdminsIdPermissions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSuperAdminAdminsIdPermissions>>, {id: string;data: AdminUpdateAdminPermissionsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putSuperAdminAdminsIdPermissions(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSuperAdminAdminsIdPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof putSuperAdminAdminsIdPermissions>>>
    export type PutSuperAdminAdminsIdPermissionsMutationBody = AdminUpdateAdminPermissionsRequest
    export type PutSuperAdminAdminsIdPermissionsMutationError = unknown

    /**
 * @summary 更新管理员权限
 */
export const usePutSuperAdminAdminsIdPermissions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSuperAdminAdminsIdPermissions>>, TError,{id: string;data: AdminUpdateAdminPermissionsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSuperAdminAdminsIdPermissions>>,
        TError,
        {id: string;data: AdminUpdateAdminPermissionsRequest},
        TContext
      > => {

      const mutationOptions = getPutSuperAdminAdminsIdPermissionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 上传用户头像图片，最大2MB
 * @summary 上传用户头像
 */
export const postUploadAvatar = (
    postUploadAvatarBody: PostUploadAvatarBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`avatar`, postUploadAvatarBody.avatar)

      return origin_point_engine_api<PostUploadAvatar200>(
      {url: `/upload/avatar`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getPostUploadAvatarMutationOptions = <TError = PostUploadAvatar400 | PostUploadAvatar500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadAvatar>>, TError,{data: PostUploadAvatarBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUploadAvatar>>, TError,{data: PostUploadAvatarBody}, TContext> => {

const mutationKey = ['postUploadAvatar'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUploadAvatar>>, {data: PostUploadAvatarBody}> = (props) => {
          const {data} = props ?? {};

          return  postUploadAvatar(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUploadAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof postUploadAvatar>>>
    export type PostUploadAvatarMutationBody = PostUploadAvatarBody
    export type PostUploadAvatarMutationError = PostUploadAvatar400 | PostUploadAvatar500

    /**
 * @summary 上传用户头像
 */
export const usePostUploadAvatar = <TError = PostUploadAvatar400 | PostUploadAvatar500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadAvatar>>, TError,{data: PostUploadAvatarBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUploadAvatar>>,
        TError,
        {data: PostUploadAvatarBody},
        TContext
      > => {

      const mutationOptions = getPostUploadAvatarMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 上传引擎背景图片，最大5MB
 * @summary 上传引擎背景图片
 */
export const postUploadEngineEngineIdBackground = (
    engineId: string,
    postUploadEngineEngineIdBackgroundBody: PostUploadEngineEngineIdBackgroundBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`image`, postUploadEngineEngineIdBackgroundBody.image)

      return origin_point_engine_api<PostUploadEngineEngineIdBackground200>(
      {url: `/upload/engine/${engineId}/background`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getPostUploadEngineEngineIdBackgroundMutationOptions = <TError = PostUploadEngineEngineIdBackground400 | PostUploadEngineEngineIdBackground500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadEngineEngineIdBackground>>, TError,{engineId: string;data: PostUploadEngineEngineIdBackgroundBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUploadEngineEngineIdBackground>>, TError,{engineId: string;data: PostUploadEngineEngineIdBackgroundBody}, TContext> => {

const mutationKey = ['postUploadEngineEngineIdBackground'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUploadEngineEngineIdBackground>>, {engineId: string;data: PostUploadEngineEngineIdBackgroundBody}> = (props) => {
          const {engineId,data} = props ?? {};

          return  postUploadEngineEngineIdBackground(engineId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUploadEngineEngineIdBackgroundMutationResult = NonNullable<Awaited<ReturnType<typeof postUploadEngineEngineIdBackground>>>
    export type PostUploadEngineEngineIdBackgroundMutationBody = PostUploadEngineEngineIdBackgroundBody
    export type PostUploadEngineEngineIdBackgroundMutationError = PostUploadEngineEngineIdBackground400 | PostUploadEngineEngineIdBackground500

    /**
 * @summary 上传引擎背景图片
 */
export const usePostUploadEngineEngineIdBackground = <TError = PostUploadEngineEngineIdBackground400 | PostUploadEngineEngineIdBackground500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadEngineEngineIdBackground>>, TError,{engineId: string;data: PostUploadEngineEngineIdBackgroundBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUploadEngineEngineIdBackground>>,
        TError,
        {engineId: string;data: PostUploadEngineEngineIdBackgroundBody},
        TContext
      > => {

      const mutationOptions = getPostUploadEngineEngineIdBackgroundMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 上传引擎封面图片到京东云 OSS，返回多规格动态处理 URL
 * @summary 上传引擎封面图片
 */
export const postUploadEngineEngineIdImage = (
    engineId: string,
    postUploadEngineEngineIdImageBody: PostUploadEngineEngineIdImageBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`image`, postUploadEngineEngineIdImageBody.image)

      return origin_point_engine_api<PostUploadEngineEngineIdImage200>(
      {url: `/upload/engine/${engineId}/image`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getPostUploadEngineEngineIdImageMutationOptions = <TError = PostUploadEngineEngineIdImage400 | PostUploadEngineEngineIdImage500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadEngineEngineIdImage>>, TError,{engineId: string;data: PostUploadEngineEngineIdImageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUploadEngineEngineIdImage>>, TError,{engineId: string;data: PostUploadEngineEngineIdImageBody}, TContext> => {

const mutationKey = ['postUploadEngineEngineIdImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUploadEngineEngineIdImage>>, {engineId: string;data: PostUploadEngineEngineIdImageBody}> = (props) => {
          const {engineId,data} = props ?? {};

          return  postUploadEngineEngineIdImage(engineId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUploadEngineEngineIdImageMutationResult = NonNullable<Awaited<ReturnType<typeof postUploadEngineEngineIdImage>>>
    export type PostUploadEngineEngineIdImageMutationBody = PostUploadEngineEngineIdImageBody
    export type PostUploadEngineEngineIdImageMutationError = PostUploadEngineEngineIdImage400 | PostUploadEngineEngineIdImage500

    /**
 * @summary 上传引擎封面图片
 */
export const usePostUploadEngineEngineIdImage = <TError = PostUploadEngineEngineIdImage400 | PostUploadEngineEngineIdImage500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadEngineEngineIdImage>>, TError,{engineId: string;data: PostUploadEngineEngineIdImageBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUploadEngineEngineIdImage>>,
        TError,
        {engineId: string;data: PostUploadEngineEngineIdImageBody},
        TContext
      > => {

      const mutationOptions = getPostUploadEngineEngineIdImageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 上传通用文件（支持图片、PDF、文档等），最大10MB
 * @summary 上传文件
 */
export const postUploadFile = (
    postUploadFileBody: PostUploadFileBody,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, postUploadFileBody.file)

      return origin_point_engine_api<PostUploadFile200>(
      {url: `/upload/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getPostUploadFileMutationOptions = <TError = PostUploadFile400 | PostUploadFile500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadFile>>, TError,{data: PostUploadFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUploadFile>>, TError,{data: PostUploadFileBody}, TContext> => {

const mutationKey = ['postUploadFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUploadFile>>, {data: PostUploadFileBody}> = (props) => {
          const {data} = props ?? {};

          return  postUploadFile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof postUploadFile>>>
    export type PostUploadFileMutationBody = PostUploadFileBody
    export type PostUploadFileMutationError = PostUploadFile400 | PostUploadFile500

    /**
 * @summary 上传文件
 */
export const usePostUploadFile = <TError = PostUploadFile400 | PostUploadFile500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUploadFile>>, TError,{data: PostUploadFileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUploadFile>>,
        TError,
        {data: PostUploadFileBody},
        TContext
      > => {

      const mutationOptions = getPostUploadFileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 删除指定的文件
 * @summary 删除文件
 */
export const deleteUploadFileKey = (
    key: string,
 ) => {
      
      
      return origin_point_engine_api<DeleteUploadFileKey200>(
      {url: `/upload/file/${key}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUploadFileKeyMutationOptions = <TError = DeleteUploadFileKey400 | DeleteUploadFileKey403 | DeleteUploadFileKey500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUploadFileKey>>, TError,{key: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUploadFileKey>>, TError,{key: string}, TContext> => {

const mutationKey = ['deleteUploadFileKey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUploadFileKey>>, {key: string}> = (props) => {
          const {key} = props ?? {};

          return  deleteUploadFileKey(key,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUploadFileKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUploadFileKey>>>
    
    export type DeleteUploadFileKeyMutationError = DeleteUploadFileKey400 | DeleteUploadFileKey403 | DeleteUploadFileKey500

    /**
 * @summary 删除文件
 */
export const useDeleteUploadFileKey = <TError = DeleteUploadFileKey400 | DeleteUploadFileKey403 | DeleteUploadFileKey500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUploadFileKey>>, TError,{key: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUploadFileKey>>,
        TError,
        {key: string},
        TContext
      > => {

      const mutationOptions = getDeleteUploadFileKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 用户注册后补填邀请码，建立邀请关系并获得初始奖励。注意：只能填写一次。
 * @summary 补填邀请码
 */
export const postUsersBindInviteCode = (
    identityBindInviteCodeRequest: IdentityBindInviteCodeRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/bind-invite-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityBindInviteCodeRequest, signal
    },
      );
    }
  


export const getPostUsersBindInviteCodeMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersBindInviteCode>>, TError,{data: IdentityBindInviteCodeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUsersBindInviteCode>>, TError,{data: IdentityBindInviteCodeRequest}, TContext> => {

const mutationKey = ['postUsersBindInviteCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersBindInviteCode>>, {data: IdentityBindInviteCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUsersBindInviteCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsersBindInviteCodeMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersBindInviteCode>>>
    export type PostUsersBindInviteCodeMutationBody = IdentityBindInviteCodeRequest
    export type PostUsersBindInviteCodeMutationError = HandlersResponseData

    /**
 * @summary 补填邀请码
 */
export const usePostUsersBindInviteCode = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersBindInviteCode>>, TError,{data: IdentityBindInviteCodeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUsersBindInviteCode>>,
        TError,
        {data: IdentityBindInviteCodeRequest},
        TContext
      > => {

      const mutationOptions = getPostUsersBindInviteCodeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 老用户绑定手机号，绑定成功后自动生成邀请码
 * @summary 绑定手机号
 */
export const postUsersBindPhone = (
    identityBindPhoneRequest: IdentityBindPhoneRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/bind-phone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: identityBindPhoneRequest, signal
    },
      );
    }
  


export const getPostUsersBindPhoneMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersBindPhone>>, TError,{data: IdentityBindPhoneRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUsersBindPhone>>, TError,{data: IdentityBindPhoneRequest}, TContext> => {

const mutationKey = ['postUsersBindPhone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersBindPhone>>, {data: IdentityBindPhoneRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUsersBindPhone(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsersBindPhoneMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersBindPhone>>>
    export type PostUsersBindPhoneMutationBody = IdentityBindPhoneRequest
    export type PostUsersBindPhoneMutationError = HandlersResponseData

    /**
 * @summary 绑定手机号
 */
export const usePostUsersBindPhone = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersBindPhone>>, TError,{data: IdentityBindPhoneRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUsersBindPhone>>,
        TError,
        {data: IdentityBindPhoneRequest},
        TContext
      > => {

      const mutationOptions = getPostUsersBindPhoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前用户的专属邀请码，如果没有则自动生成
 * @summary 获取邀请码
 */
export const getUsersInviteCode = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetUsersInviteCode200>(
      {url: `/users/invite-code`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersInviteCodeQueryKey = () => {
    return [
    `/users/invite-code`
    ] as const;
    }

    
export const getGetUsersInviteCodeQueryOptions = <TData = Awaited<ReturnType<typeof getUsersInviteCode>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersInviteCodeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersInviteCode>>> = ({ signal }) => getUsersInviteCode(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersInviteCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersInviteCode>>>
export type GetUsersInviteCodeQueryError = HandlersResponseData


export function useGetUsersInviteCode<TData = Awaited<ReturnType<typeof getUsersInviteCode>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersInviteCode>>,
          TError,
          Awaited<ReturnType<typeof getUsersInviteCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersInviteCode<TData = Awaited<ReturnType<typeof getUsersInviteCode>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersInviteCode>>,
          TError,
          Awaited<ReturnType<typeof getUsersInviteCode>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersInviteCode<TData = Awaited<ReturnType<typeof getUsersInviteCode>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteCode>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取邀请码
 */

export function useGetUsersInviteCode<TData = Awaited<ReturnType<typeof getUsersInviteCode>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteCode>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersInviteCodeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取当前用户邀请的所有用户列表，包含奖励发放状态
 * @summary 获取邀请记录
 */
export const getUsersInviteRecords = (
    params?: GetUsersInviteRecordsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetUsersInviteRecords200>(
      {url: `/users/invite-records`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetUsersInviteRecordsQueryKey = (params?: GetUsersInviteRecordsParams,) => {
    return [
    `/users/invite-records`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUsersInviteRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getUsersInviteRecords>>, TError = HandlersResponseData>(params?: GetUsersInviteRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteRecords>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersInviteRecordsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersInviteRecords>>> = ({ signal }) => getUsersInviteRecords(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersInviteRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersInviteRecords>>>
export type GetUsersInviteRecordsQueryError = HandlersResponseData


export function useGetUsersInviteRecords<TData = Awaited<ReturnType<typeof getUsersInviteRecords>>, TError = HandlersResponseData>(
 params: undefined |  GetUsersInviteRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersInviteRecords>>,
          TError,
          Awaited<ReturnType<typeof getUsersInviteRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersInviteRecords<TData = Awaited<ReturnType<typeof getUsersInviteRecords>>, TError = HandlersResponseData>(
 params?: GetUsersInviteRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersInviteRecords>>,
          TError,
          Awaited<ReturnType<typeof getUsersInviteRecords>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersInviteRecords<TData = Awaited<ReturnType<typeof getUsersInviteRecords>>, TError = HandlersResponseData>(
 params?: GetUsersInviteRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteRecords>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取邀请记录
 */

export function useGetUsersInviteRecords<TData = Awaited<ReturnType<typeof getUsersInviteRecords>>, TError = HandlersResponseData>(
 params?: GetUsersInviteRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersInviteRecords>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersInviteRecordsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 用户登出
 * @summary 用户登出
 */
export const postUsersLogout = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/logout`, method: 'POST', signal
    },
      );
    }
  


export const getPostUsersLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersLogout>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUsersLogout>>, TError,void, TContext> => {

const mutationKey = ['postUsersLogout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsersLogout>>, void> = () => {
          

          return  postUsersLogout()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsersLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postUsersLogout>>>
    
    export type PostUsersLogoutMutationError = unknown

    /**
 * @summary 用户登出
 */
export const usePostUsersLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsersLogout>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUsersLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostUsersLogoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 修改当前登录用户的密码
 * @summary 修改密码
 */
export const putUsersPassword = (
    handlerChangePasswordRequest: HandlerChangePasswordRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/password`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlerChangePasswordRequest
    },
      );
    }
  


export const getPutUsersPasswordMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersPassword>>, TError,{data: HandlerChangePasswordRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUsersPassword>>, TError,{data: HandlerChangePasswordRequest}, TContext> => {

const mutationKey = ['putUsersPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersPassword>>, {data: HandlerChangePasswordRequest}> = (props) => {
          const {data} = props ?? {};

          return  putUsersPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersPassword>>>
    export type PutUsersPasswordMutationBody = HandlerChangePasswordRequest
    export type PutUsersPasswordMutationError = HandlersResponseData

    /**
 * @summary 修改密码
 */
export const usePutUsersPassword = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersPassword>>, TError,{data: HandlerChangePasswordRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersPassword>>,
        TError,
        {data: HandlerChangePasswordRequest},
        TContext
      > => {

      const mutationOptions = getPutUsersPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前登录用户的资料信息
 * @summary 获取用户资料
 */
export const getUsersProfile = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/profile`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersProfileQueryKey = () => {
    return [
    `/users/profile`
    ] as const;
    }

    
export const getGetUsersProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUsersProfile>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersProfile>>> = ({ signal }) => getUsersProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersProfile>>>
export type GetUsersProfileQueryError = HandlersResponseData


export function useGetUsersProfile<TData = Awaited<ReturnType<typeof getUsersProfile>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersProfile>>,
          TError,
          Awaited<ReturnType<typeof getUsersProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersProfile<TData = Awaited<ReturnType<typeof getUsersProfile>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersProfile>>,
          TError,
          Awaited<ReturnType<typeof getUsersProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersProfile<TData = Awaited<ReturnType<typeof getUsersProfile>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取用户资料
 */

export function useGetUsersProfile<TData = Awaited<ReturnType<typeof getUsersProfile>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersProfile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 更新当前登录用户的资料信息
 * @summary 更新用户资料
 */
export const putUsersProfile = (
    handlerUpdateProfileRequest: HandlerUpdateProfileRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlerUpdateProfileRequest
    },
      );
    }
  


export const getPutUsersProfileMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersProfile>>, TError,{data: HandlerUpdateProfileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUsersProfile>>, TError,{data: HandlerUpdateProfileRequest}, TContext> => {

const mutationKey = ['putUsersProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersProfile>>, {data: HandlerUpdateProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  putUsersProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersProfile>>>
    export type PutUsersProfileMutationBody = HandlerUpdateProfileRequest
    export type PutUsersProfileMutationError = HandlersResponseData

    /**
 * @summary 更新用户资料
 */
export const usePutUsersProfile = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersProfile>>, TError,{data: HandlerUpdateProfileRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersProfile>>,
        TError,
        {data: HandlerUpdateProfileRequest},
        TContext
      > => {

      const mutationOptions = getPutUsersProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取当前登录用户的设置信息
 * @summary 获取用户设置
 */
export const getUsersSettings = (
    
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/settings`, method: 'GET', signal
    },
      );
    }
  



export const getGetUsersSettingsQueryKey = () => {
    return [
    `/users/settings`
    ] as const;
    }

    
export const getGetUsersSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getUsersSettings>>, TError = HandlersResponseData>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersSettings>>> = ({ signal }) => getUsersSettings(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersSettings>>>
export type GetUsersSettingsQueryError = HandlersResponseData


export function useGetUsersSettings<TData = Awaited<ReturnType<typeof getUsersSettings>>, TError = HandlersResponseData>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersSettings>>,
          TError,
          Awaited<ReturnType<typeof getUsersSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersSettings<TData = Awaited<ReturnType<typeof getUsersSettings>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersSettings>>,
          TError,
          Awaited<ReturnType<typeof getUsersSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersSettings<TData = Awaited<ReturnType<typeof getUsersSettings>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取用户设置
 */

export function useGetUsersSettings<TData = Awaited<ReturnType<typeof getUsersSettings>>, TError = HandlersResponseData>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersSettings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 更新当前登录用户的设置信息
 * @summary 更新用户设置
 */
export const putUsersSettings = (
    handlersUpdateUserSettingsRequest: HandlersUpdateUserSettingsRequest,
 ) => {
      
      
      return origin_point_engine_api<HandlersResponseData>(
      {url: `/users/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: handlersUpdateUserSettingsRequest
    },
      );
    }
  


export const getPutUsersSettingsMutationOptions = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersSettings>>, TError,{data: HandlersUpdateUserSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUsersSettings>>, TError,{data: HandlersUpdateUserSettingsRequest}, TContext> => {

const mutationKey = ['putUsersSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersSettings>>, {data: HandlersUpdateUserSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  putUsersSettings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersSettings>>>
    export type PutUsersSettingsMutationBody = HandlersUpdateUserSettingsRequest
    export type PutUsersSettingsMutationError = HandlersResponseData

    /**
 * @summary 更新用户设置
 */
export const usePutUsersSettings = <TError = HandlersResponseData,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersSettings>>, TError,{data: HandlersUpdateUserSettingsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersSettings>>,
        TError,
        {data: HandlersUpdateUserSettingsRequest},
        TContext
      > => {

      const mutationOptions = getPutUsersSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取工坊中公开的引擎列表，支持分页、分类筛选和搜索
 * @summary 获取工坊引擎列表
 */
export const getWorkshopEngines = (
    params?: GetWorkshopEnginesParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetWorkshopEngines200>(
      {url: `/workshop/engines`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetWorkshopEnginesQueryKey = (params?: GetWorkshopEnginesParams,) => {
    return [
    `/workshop/engines`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWorkshopEnginesQueryOptions = <TData = Awaited<ReturnType<typeof getWorkshopEngines>>, TError = GetWorkshopEngines500>(params?: GetWorkshopEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEngines>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkshopEnginesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkshopEngines>>> = ({ signal }) => getWorkshopEngines(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEngines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkshopEnginesQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkshopEngines>>>
export type GetWorkshopEnginesQueryError = GetWorkshopEngines500


export function useGetWorkshopEngines<TData = Awaited<ReturnType<typeof getWorkshopEngines>>, TError = GetWorkshopEngines500>(
 params: undefined |  GetWorkshopEnginesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEngines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopEngines>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopEngines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkshopEngines<TData = Awaited<ReturnType<typeof getWorkshopEngines>>, TError = GetWorkshopEngines500>(
 params?: GetWorkshopEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEngines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopEngines>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopEngines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkshopEngines<TData = Awaited<ReturnType<typeof getWorkshopEngines>>, TError = GetWorkshopEngines500>(
 params?: GetWorkshopEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEngines>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取工坊引擎列表
 */

export function useGetWorkshopEngines<TData = Awaited<ReturnType<typeof getWorkshopEngines>>, TError = GetWorkshopEngines500>(
 params?: GetWorkshopEnginesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEngines>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkshopEnginesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 获取指定引擎的详细信息
 * @summary 获取工坊引擎详情
 */
export const getWorkshopEnginesId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetWorkshopEnginesId200>(
      {url: `/workshop/engines/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetWorkshopEnginesIdQueryKey = (id?: string,) => {
    return [
    `/workshop/engines/${id}`
    ] as const;
    }

    
export const getGetWorkshopEnginesIdQueryOptions = <TData = Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError = GetWorkshopEnginesId400 | GetWorkshopEnginesId404>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkshopEnginesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkshopEnginesId>>> = ({ signal }) => getWorkshopEnginesId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkshopEnginesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkshopEnginesId>>>
export type GetWorkshopEnginesIdQueryError = GetWorkshopEnginesId400 | GetWorkshopEnginesId404


export function useGetWorkshopEnginesId<TData = Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError = GetWorkshopEnginesId400 | GetWorkshopEnginesId404>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopEnginesId>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopEnginesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkshopEnginesId<TData = Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError = GetWorkshopEnginesId400 | GetWorkshopEnginesId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopEnginesId>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopEnginesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkshopEnginesId<TData = Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError = GetWorkshopEnginesId400 | GetWorkshopEnginesId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取工坊引擎详情
 */

export function useGetWorkshopEnginesId<TData = Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError = GetWorkshopEnginesId400 | GetWorkshopEnginesId404>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkshopEnginesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 收藏指定的引擎
 * @summary 收藏引擎
 */
export const postWorkshopEnginesIdBookmark = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostWorkshopEnginesIdBookmark200>(
      {url: `/workshop/engines/${id}/bookmark`, method: 'POST', signal
    },
      );
    }
  


export const getPostWorkshopEnginesIdBookmarkMutationOptions = <TError = PostWorkshopEnginesIdBookmark400 | PostWorkshopEnginesIdBookmark500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdBookmark>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdBookmark>>, TError,{id: string}, TContext> => {

const mutationKey = ['postWorkshopEnginesIdBookmark'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkshopEnginesIdBookmark>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postWorkshopEnginesIdBookmark(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWorkshopEnginesIdBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkshopEnginesIdBookmark>>>
    
    export type PostWorkshopEnginesIdBookmarkMutationError = PostWorkshopEnginesIdBookmark400 | PostWorkshopEnginesIdBookmark500

    /**
 * @summary 收藏引擎
 */
export const usePostWorkshopEnginesIdBookmark = <TError = PostWorkshopEnginesIdBookmark400 | PostWorkshopEnginesIdBookmark500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdBookmark>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkshopEnginesIdBookmark>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostWorkshopEnginesIdBookmarkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 获取指定引擎的评论列表，支持分页
 * @summary 获取引擎评论
 */
export const getWorkshopEnginesIdComments = (
    id: string,
    params?: GetWorkshopEnginesIdCommentsParams,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<GetWorkshopEnginesIdComments200>(
      {url: `/workshop/engines/${id}/comments`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetWorkshopEnginesIdCommentsQueryKey = (id?: string,
    params?: GetWorkshopEnginesIdCommentsParams,) => {
    return [
    `/workshop/engines/${id}/comments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWorkshopEnginesIdCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError = GetWorkshopEnginesIdComments400 | GetWorkshopEnginesIdComments404 | GetWorkshopEnginesIdComments500>(id: string,
    params?: GetWorkshopEnginesIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkshopEnginesIdCommentsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>> = ({ signal }) => getWorkshopEnginesIdComments(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkshopEnginesIdCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>>
export type GetWorkshopEnginesIdCommentsQueryError = GetWorkshopEnginesIdComments400 | GetWorkshopEnginesIdComments404 | GetWorkshopEnginesIdComments500


export function useGetWorkshopEnginesIdComments<TData = Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError = GetWorkshopEnginesIdComments400 | GetWorkshopEnginesIdComments404 | GetWorkshopEnginesIdComments500>(
 id: string,
    params: undefined |  GetWorkshopEnginesIdCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkshopEnginesIdComments<TData = Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError = GetWorkshopEnginesIdComments400 | GetWorkshopEnginesIdComments404 | GetWorkshopEnginesIdComments500>(
 id: string,
    params?: GetWorkshopEnginesIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>,
          TError,
          Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkshopEnginesIdComments<TData = Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError = GetWorkshopEnginesIdComments400 | GetWorkshopEnginesIdComments404 | GetWorkshopEnginesIdComments500>(
 id: string,
    params?: GetWorkshopEnginesIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 获取引擎评论
 */

export function useGetWorkshopEnginesIdComments<TData = Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError = GetWorkshopEnginesIdComments400 | GetWorkshopEnginesIdComments404 | GetWorkshopEnginesIdComments500>(
 id: string,
    params?: GetWorkshopEnginesIdCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkshopEnginesIdComments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkshopEnginesIdCommentsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 为指定引擎创建评论或回复
 * @summary 创建引擎评论
 */
export const postWorkshopEnginesIdComments = (
    id: string,
    handlersCreateEngineCommentRequest: HandlersCreateEngineCommentRequest,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostWorkshopEnginesIdComments201>(
      {url: `/workshop/engines/${id}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handlersCreateEngineCommentRequest, signal
    },
      );
    }
  


export const getPostWorkshopEnginesIdCommentsMutationOptions = <TError = PostWorkshopEnginesIdComments400 | PostWorkshopEnginesIdComments404 | PostWorkshopEnginesIdComments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdComments>>, TError,{id: string;data: HandlersCreateEngineCommentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdComments>>, TError,{id: string;data: HandlersCreateEngineCommentRequest}, TContext> => {

const mutationKey = ['postWorkshopEnginesIdComments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkshopEnginesIdComments>>, {id: string;data: HandlersCreateEngineCommentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postWorkshopEnginesIdComments(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWorkshopEnginesIdCommentsMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkshopEnginesIdComments>>>
    export type PostWorkshopEnginesIdCommentsMutationBody = HandlersCreateEngineCommentRequest
    export type PostWorkshopEnginesIdCommentsMutationError = PostWorkshopEnginesIdComments400 | PostWorkshopEnginesIdComments404 | PostWorkshopEnginesIdComments500

    /**
 * @summary 创建引擎评论
 */
export const usePostWorkshopEnginesIdComments = <TError = PostWorkshopEnginesIdComments400 | PostWorkshopEnginesIdComments404 | PostWorkshopEnginesIdComments500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdComments>>, TError,{id: string;data: HandlersCreateEngineCommentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkshopEnginesIdComments>>,
        TError,
        {id: string;data: HandlersCreateEngineCommentRequest},
        TContext
      > => {

      const mutationOptions = getPostWorkshopEnginesIdCommentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 为指定引擎点赞
 * @summary 点赞引擎
 */
export const postWorkshopEnginesIdLike = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return origin_point_engine_api<PostWorkshopEnginesIdLike200>(
      {url: `/workshop/engines/${id}/like`, method: 'POST', signal
    },
      );
    }
  


export const getPostWorkshopEnginesIdLikeMutationOptions = <TError = PostWorkshopEnginesIdLike400 | PostWorkshopEnginesIdLike404 | PostWorkshopEnginesIdLike500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdLike>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdLike>>, TError,{id: string}, TContext> => {

const mutationKey = ['postWorkshopEnginesIdLike'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkshopEnginesIdLike>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postWorkshopEnginesIdLike(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWorkshopEnginesIdLikeMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkshopEnginesIdLike>>>
    
    export type PostWorkshopEnginesIdLikeMutationError = PostWorkshopEnginesIdLike400 | PostWorkshopEnginesIdLike404 | PostWorkshopEnginesIdLike500

    /**
 * @summary 点赞引擎
 */
export const usePostWorkshopEnginesIdLike = <TError = PostWorkshopEnginesIdLike400 | PostWorkshopEnginesIdLike404 | PostWorkshopEnginesIdLike500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkshopEnginesIdLike>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkshopEnginesIdLike>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostWorkshopEnginesIdLikeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
